import React from "react";

function MainHeader() {
  return (
    <div>
      <div className="-z-10 ">
        <svg
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x={0}
          y={0}
          viewBox="0 0 1920 1080"
          style={{
            enableBackground: "new 0 0 1920 1080",
            height: "100%",
            width: "100vw",
          }}
          xmlSpace="preserve"
        >
          <style>
            {
              ".st1{fill:#d6d7da}.st2{fill:#f5f5f5}.st3{fill:#9aa0a6}.st4{fill:#e0e4ea}.st9{fill:#585b5e}.st10{fill:#ea4335}.st11{opacity:.4}.st12{fill:#979da5}.st13{fill:#fff}.st16{enable-background:new;opacity:.1;fill:#1a2e35}.st22{fill:#f1f1f1}.st23{fill:#ebedee}.st24{fill:#eeeff0}.st25{fill:#e2e5e7}.st26{fill:#e5e7e7}.st27{fill:#ecedef}.st29{fill:#375a64}.st30{fill:#1a2e35}.st32{fill:#c4c7cb}.st33{fill:#fbdd85}.st34{fill:#4285f4}.st35{fill:#34a853}.st36{opacity:.3;fill:#fff;enable-background:new}.st40{fill:#e1e1e1}.st41{opacity:.5}.st43{opacity:.3}.st44{fill:#fbbc04}.st45{fill:#e6ebef}.st46{fill:none}.st50{fill:#32a551}.st51{fill:#7dc993}.st53{fill:#bdc1c6}.st54{opacity:.5;fill:none;stroke:#fff;stroke-miterlimit:10;enable-background:new}.st61{fill:#8c9195}.st62{opacity:.1}.st63,.st66{fill:none;stroke:#1a2e35;stroke-width:4;stroke-miterlimit:10}.st66{stroke-width:2}.st69{opacity:.1;fill:#fff;enable-background:new}.st72,.st73{fill-rule:evenodd;clip-rule:evenodd;fill:#c9ced3}.st73{fill:#dbdbdb}.st74{fill:#979da5}.st74,.st75,.st77{fill-rule:evenodd;clip-rule:evenodd}.st75{fill:#e8e8e8}.st77{opacity:.15;enable-background:new}.st87{fill:#283242}.st88{fill:#f29d00}.st89{fill:#a9a9ba}.st90{fill:#626d77}.st91{fill:#808891}.st92{fill:#808396}.st93{fill:#ced2e3}.st94{fill:#505c70}.st95{fill:#586e91}.st96{fill:#0091b5}.st97{fill:#bec0d1}.st98{fill:#bcbecc}.st99{fill:#636473}.st100{fill:#2c2c33}.st101{fill:#d6d8e6}.st102{fill:#40404a}.st103{fill:#a3a5b3}.st104{fill:#a5a6bf}.st105{fill:#2c4c57}.st106{fill:#71748a}.st107{fill:#f21c00}.st108{fill:#a3a6b5}.st109{fill:#dddeeb}.st110{fill:#343442}.st111{fill:#4a4d59}.st112{fill:#337fdb}.st113{fill:#ff8f6a}.st116{fill:#191919}.st117{fill:#f77a5e}.st118{fill:#7b6b55}.st119,.st120{opacity:.2;enable-background:new}.st120{opacity:.13;fill:#cf7355}.st121{fill:#202127}.st122{opacity:.3;enable-background:new}.st123{fill:#333}.st124{fill:#191a1e}.st125{fill:#8c6861}.st127{fill:#2976d3}.st128{opacity:.1;enable-background:new}.st130{fill:#fbbc05}.st132{fill:#163e69}.st133{fill:#4f555b}.st135{fill:#3db75a}.st139{fill:#f9fafc}.st140{fill:#e8eaed}"
            }
          </style>
          <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1={960}
            y1={8934.858}
            x2={960}
            y2={9002.775}
            gradientTransform="translate(0 -8026)"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#9aa0a6",
              }}
            />
            <stop
              offset={0.236}
              style={{
                stopColor: "#9aa0a6",
                stopOpacity: 0.2,
              }}
            />
            <stop
              offset={1}
              style={{
                stopColor: "#9aa0a6",
                stopOpacity: 0,
              }}
            />
          </linearGradient>
          <path
            style={{
              opacity: 0.15,
              fill: "url(#SVGID_1_)",
              enableBackground: "new",
            }}
            d="M0 909.1h1920v70.4H0z"
          />
          <path
            className="st1"
            d="M984.7 947.4v-3.8h1.4l.1 3.8h-1.5zm.1-5.7v-3.8h1.2v3.8h-1.2zm.1-5.7.1-3.8h.8l.1 3.8h-1zm.1-5.7.1-3.8h.6l.1 3.8h-.8zm.1-5.7.1-3.8h.4l.1 3.8h-.6zm.1-5.7.1-3.8h.2l.1 3.8h-.4z"
          />
          <path
            className="st2"
            d="M1046.1 999h-9.1l35.3 31.7h14.9l-41.1-31.7zm-16.8.2h-8.5l21.8 31.7h15.5l-28.8-31.7zm34.6.2h-8.5l47 31.2h15.5l-54-31.2zm-53.1-.4h-9.2l10 31.7h14.9l-15.7-31.7zm-96.3-.5-54.1 32.2h15.3l46.3-32.2h-7.5zm51.9.5-15.6 31.7h15.6l8.7-31.7h-8.7zm-17.8 0-27.8 31.7h14.5l22.2-31.7h-8.9zm-17.9.1-40.6 31.6h15.6l34.6-31.7-9.6.1zm62.1-.1H984l-2.6 31.7h14.8l-3.4-31.7z"
          />
          <path
            d="M634.3 339.7s23.6-27.7 80-24.6c0 0 81.9-46.1 169.1-6.2 0 0 92.8-9.9 161.5 8.6 45.8 12.3 60.9 25.3 60.9 25.3l-471.5-3.1zm-542.2 76s20.6-24.1 69.7-21.5c0 0 71.4-40.2 147.6-5.4 0 0 81-8.6 140.9 7.5 40 10.8 53.2 22.1 53.2 22.1l-411.4-2.7zm1348.4 267.1s23.6-27.7 80-24.6c0 0 81.9-46.1 169.1-6.2 0 0 92.8-9.9 161.5 8.6 45.8 12.3 60.9 25.3 60.9 25.3l-471.5-3.1zm-171.7-217.9s16.1-18.9 54.6-16.8c0 0 55.9-31.5 115.5-4.2 0 0 63.3-6.8 110.2 5.9 31.3 8.4 41.6 17.2 41.6 17.2l-321.9-2.1zM864.9 645.5s10.4-12.3 35.4-10.9c0 0 36.3-20.4 75-2.7 0 0 41.1-4.4 71.5 3.8 20.3 5.5 27 11.2 27 11.2l-208.9-1.4zM365.8 540.6s14.6-17.2 49.6-15.3c0 0 50.7-28.6 104.8-3.8 0 0 57.5-6.1 100.1 5.3 28.4 7.6 37.8 15.7 37.8 15.7l-292.3-1.9z"
            style={{
              fill: "#f8f9fa",
            }}
            id="clouds"
          />
          <g id="Back_Road">
            <path
              className="st1"
              d="M1813.1 942.4v.8h106.1v3.4h-105.3v.8H1920v-5h-106.9zm-778.7 0v.8h531.1v-.8h-531.1zm0 4.2v.8h530.9v-.8h-530.9zm-98.6-3.4v-.8H0v5h935.8v-.8H.8v-3.4h935z"
            />
            <path
              className="st1"
              d="m1567.3 918-2 28.6v.8h-1v-.8l.3-3.4v-.8l1.7-24.4zm247.4 29.4h-1l-6-30.4h1z"
            />
            <path
              className="st16"
              d="M821.2 943.2v3.4h30v-3.4h-30zm-62 0v3.4h30v-3.4h-30zm31 0v3.4h30v-3.4h-30zm-62 0v3.4h30v-3.4h-30zm-92.9 0v3.4h30v-3.4h-30zm62 0v3.4h30v-3.4h-30zm-31 0v3.4h30v-3.4h-30zm239.7 0v3.4h16v-3.4h-16zm-797.1 0v3.4h30v-3.4h-30zm-31 0v3.4h30v-3.4h-30zm774.2 0v3.4h30v-3.4h-30zm-805.1 0v3.4h30v-3.4H47zm836.1 0v3.4h22v-3.4h-22zm-867.1 0v3.4h30v-3.4H16zm588.4 0v3.4h30v-3.4h-30zm-340.7 0v3.4h30v-3.4h-30zm31 0v3.4h30v-3.4h-30zm31 0v3.4h30v-3.4h-30zm-123.9 0v3.4h30v-3.4h-30zm31 0v3.4h30v-3.4h-30zm-62 0v3.4h30v-3.4h-30zm185.8 0v3.4h30v-3.4h-30zm31 0v3.4h30v-3.4h-30zm-247.7 0v3.4h30v-3.4h-30zm340.6 0v3.4h30v-3.4h-30zm61.9 0v3.4h30v-3.4h-30zm-123.8 0v3.4h30v-3.4h-30zm30.9 0v3.4h30v-3.4h-30zm123.9 0v3.4h30v-3.4h-30zm-61.9 0v3.4h30v-3.4h-30zm743.2 0v3.4h30v-3.4h-30zm185.8 0v3.4h30v-3.4h-30zm-92.9 0v3.4h30v-3.4h-30zm61.9 0v3.4h30v-3.4h-30zm-92.9 0v3.4h30v-3.4h-30zm-30.9 0v3.4h30v-3.4h-30zm588.3 0v3.4h30v-3.4h-30zm-402.5 0v3.4h30v-3.4h-30zm93.2 0h-9.3v3.4h8.9l.4-3.4zm278.4 0v3.4h30v-3.4h-30zm-29.2 0 .7 3.4h27.5v-3.4h-28.2zm-280.5 0v3.4h21v-3.4h-21zm-31 0v3.4h30v-3.4h-30zm-123.8 0v3.4h30v-3.4h-30zm-323.7 0v3.4h20v-3.4h-20zm168.8 0v3.4h30v-3.4h-30zM0 943.2v3.4h15v-3.4H0zm1905 0v3.4h15v-3.4h-15zm-829.1 0v3.4h23v-3.4h-23zm116.9 0v3.4h30v-3.4h-30zm-31 0v3.4h30v-3.4h-30zm-62 0v3.4h30v-3.4h-30zm31 0v3.4h30v-3.4h-30zm-96.4 0v3.4h19.6v-3.4h-19.6zm-128.4 0v3.4h16v-3.4h-16zm17 0v3.4h12.8v-3.4H923z"
            />
            <linearGradient
              id="SVGID_6_"
              gradientUnits="userSpaceOnUse"
              x1={985.1}
              y1={-2004.853}
              x2={985.1}
              y2={-2036.357}
              gradientTransform="matrix(1 0 0 -1 0 -1090)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              style={{
                opacity: 0.2,
                fill: "url(#SVGID_6_)",
                enableBackground: "new",
              }}
              d="M1034.4 947.4h-98.6l43.2-32.3h11.5z"
            />
            <path
              d="M977.8 909.1h-1.6c1 0 1.6.5 1.6.5h14.3s.6-.5 1.6-.5h-15.9z"
              style={{
                fill: "#cdced1",
              }}
            />
            <path
              className="st16"
              d="m935.8 943.2 3.1-2.4 1.5 1.7-4.6 4.1v-3.4zm5.3-1.3 7.5-6.6-1.1-1.4-7.8 6.2 1.4 1.8zm8.3-7.3 7.5-6.6-.8-1-7.8 6.2 1.1 1.4zm8.2-7.2 7.5-6.6-.5-.6-7.8 6.2.8 1zm8.3-7.3 7.5-6.6-.2-.2-7.8 6.2.5.6zm8.2-7.2 3.8-3.3-3.9 3.1.1.2zm60.3 33.7-4.6-4 1.5-1.9 3.1 2.5v3.4zm-3.8-6.5-7.9-6.2-1.2 1.5 7.5 6.6 1.6-1.9zm-8.7-6.8-7.8-6.2-.9 1.1 7.5 6.6 1.2-1.5zm-8.6-6.9-7.9-6.2-.5.6 7.5 6.6.9-1zm-8.7-6.8-7.9-6.2-.2.2 7.5 6.6.6-.6zm-8.6-6.9-4-3.1 3.8 3.3.2-.2z"
            />
            <linearGradient
              id="SVGID_7_"
              gradientUnits="userSpaceOnUse"
              x1={936.336}
              y1={-2038.177}
              x2={978.101}
              y2={-2002.647}
              gradientTransform="matrix(1 0 0 -1 0 -1090)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              style={{
                opacity: 0.3,
                fill: "url(#SVGID_7_)",
                enableBackground: "new",
              }}
              d="m977.9 909.6 1.1 5.5-43.2 32.3z"
            />
            <linearGradient
              id="SVGID_8_"
              gradientUnits="userSpaceOnUse"
              x1={1034.165}
              y1={-2037.685}
              x2={990.188}
              y2={-2001.475}
              gradientTransform="matrix(1 0 0 -1 0 -1090)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              style={{
                opacity: 0.3,
                fill: "url(#SVGID_8_)",
                enableBackground: "new",
              }}
              d="m1034.4 947.4-43.9-32.3 1.5-5.5z"
            />
            <path
              className="st1"
              d="m935.8 947 43.2-31.9-43.2 32.3zm98.6.4-43.9-32.3 43.9 31.9z"
            />
            <path
              className="st1"
              d="m1034.4 947.4-42.3-37.6 42.3 36.8zm0-4.2-42.3-33.6 42.3 32.8zm-98.6 3.4 42-36.8-42 37.6zm0-4.2 42-32.8-42 33.6z"
            />
          </g>
          <g id="train_track">
            <path className="st13" d="M0 901.5h1920v7.6H0z" />
            <path
              style={{
                fill: "none",
                stroke: "#e0e4ea",
                strokeWidth: 0.6,
                strokeMiterlimit: 10,
                strokeDasharray: "2,5",
              }}
              d="M0 907.1h1920"
            />
            <path className="st1" d="M0 905.6h1920v.5H0zm0 2.5h1920v1H0z" />
          </g>
          <g id="train">
            <path
              className="st22"
              d="M64 903.5H3c-1.7 0-3-1.3-3-3v-18c0-1.7 1.3-3 3-3h61c1.7 0 3 1.3 3 3v18c0 1.6-1.4 3-3 3z"
            />
            <circle className="st23" cx={9} cy={903.5} r={3.5} />
            <circle className="st23" cx={23} cy={903.5} r={3.5} />
            <circle className="st23" cx={44} cy={903.5} r={3.5} />
            <circle className="st23" cx={58} cy={903.5} r={3.5} />
            <path className="st24" d="M.7 883.4h8v5.1h-8z" />
            <path className="st25" d="M8.7 883.4h1v5.1h-1z" />
            <path className="st24" d="M9.7 883.4h8v5.1h-8z" />
            <path className="st25" d="M17.7 883.4h1v5.1h-1z" />
            <path className="st24" d="M18.7 883.4h9.2v5.1h-9.2z" />
            <path className="st25" d="M27.9 883.4h1v5.1h-1z" />
            <path className="st24" d="M58.1 883.5h8.1v5.1h-8.1z" />
            <path className="st25" d="M57.2 883.5h1v5.1h-1z" />
            <path className="st24" d="M48.1 883.5h9.1v5.1h-9.1z" />
            <path className="st25" d="M47.1 883.5h1v5.1h-1z" />
            <path className="st24" d="M38 883.5h9.1v5.1H38z" />
            <path className="st25" d="M36.9 883.5h1v5.1h-1z" />
            <path className="st24" d="M28.9 883.4H37v15.1h-8.1z" />
            <path className="st25" d="M32.4 883.4h1v15.1h-1z" />
            <path className="st26" d="M65 898.5h7v1h-7z" />
            <path
              className="st22"
              d="M136 903.5H75c-1.7 0-3-1.3-3-3v-18c0-1.7 1.3-3 3-3h61c1.7 0 3 1.3 3 3v18c0 1.6-1.4 3-3 3z"
            />
            <circle className="st23" cx={81} cy={903.5} r={3.5} />
            <circle className="st23" cx={95} cy={903.5} r={3.5} />
            <circle className="st23" cx={116} cy={903.5} r={3.5} />
            <circle className="st23" cx={130} cy={903.5} r={3.5} />
            <path className="st24" d="M72.7 883.4h8v5.1h-8z" />
            <path className="st25" d="M80.7 883.4h1v5.1h-1z" />
            <path className="st24" d="M81.7 883.4h8v5.1h-8z" />
            <path className="st25" d="M89.7 883.4h1v5.1h-1z" />
            <path className="st24" d="M90.7 883.4h9.2v5.1h-9.2z" />
            <path className="st25" d="M99.9 883.4h1v5.1h-1z" />
            <path className="st24" d="M130.1 883.5h8.1v5.1h-8.1z" />
            <path className="st25" d="M129.2 883.5h1v5.1h-1z" />
            <path className="st24" d="M120.1 883.5h9.1v5.1h-9.1z" />
            <path className="st25" d="M119.1 883.5h1v5.1h-1z" />
            <path className="st24" d="M110 883.5h9.1v5.1H110z" />
            <path className="st25" d="M108.9 883.5h1v5.1h-1z" />
            <path className="st27" d="M100.9 883.4h8.1v15.1h-8.1z" />
            <path className="st25" d="M104.4 883.4h1v15.1h-1z" />
            <path className="st26" d="M137 898.5h7v1h-7z" />
            <path
              className="st22"
              d="M292.6 900.2c-.8 2-2.8 3.2-5 3.2H219c-1.7 0-3-1.3-3-3v-18c0-1.7 1.3-3 3-3h50.2c.8 0 1.7.3 2.3.8l4.8 3.5 2.3 1.6 12.3 8.9c1.8 1.3 2.6 3.8 1.7 6z"
            />
            <circle className="st23" cx={228.5} cy={903.5} r={3.5} />
            <circle className="st23" cx={242.5} cy={903.5} r={3.5} />
            <circle className="st23" cx={263.5} cy={903.5} r={3.5} />
            <circle className="st23" cx={277.5} cy={903.5} r={3.5} />
            <path className="st24" d="M216.9 883.7H229v5.1h-12.1z" />
            <path className="st25" d="M229 883.7h1v5.1h-1z" />
            <path
              className="st24"
              d="M230 883.7h9.2v5.1H230zm48.5 1.6v3.5h-8.1v-5.1h5.9z"
            />
            <path className="st25" d="M269.4 883.7h1v5.1h-1z" />
            <path className="st24" d="M260.3 883.7h9.1v5.1h-9.1z" />
            <path className="st25" d="M259.3 883.7h1v5.1h-1z" />
            <path className="st24" d="M250.2 883.7h9.1v5.1h-9.1z" />
            <path className="st25" d="M239.2 883.7h1v6.1h-1zm10 0h1v6.1h-1z" />
            <path className="st27" d="M240.2 883.7h9.1v15.1h-9.1z" />
            <path className="st25" d="M244.2 883.7h1v15.1h-1z" />
            <path
              className="st22"
              d="M208 903.5h-61c-1.7 0-3-1.3-3-3v-18c0-1.7 1.3-3 3-3h61c1.7 0 3 1.3 3 3v18c0 1.6-1.4 3-3 3z"
            />
            <circle className="st23" cx={153} cy={903.5} r={3.5} />
            <circle className="st23" cx={167} cy={903.5} r={3.5} />
            <circle className="st23" cx={188} cy={903.5} r={3.5} />
            <circle className="st23" cx={202} cy={903.5} r={3.5} />
            <path className="st24" d="M144.7 883.4h8v5.1h-8z" />
            <path className="st25" d="M152.7 883.4h1v5.1h-1z" />
            <path className="st24" d="M153.7 883.4h8v5.1h-8z" />
            <path className="st25" d="M161.7 883.4h1v5.1h-1z" />
            <path className="st24" d="M162.7 883.4h9.2v5.1h-9.2z" />
            <path className="st25" d="M171.9 883.4h1v5.1h-1z" />
            <path className="st24" d="M202.1 883.5h8.1v5.1h-8.1z" />
            <path className="st25" d="M201.2 883.5h1v5.1h-1z" />
            <path className="st24" d="M192.1 883.5h9.1v5.1h-9.1z" />
            <path className="st25" d="M191.1 883.5h1v5.1h-1z" />
            <path className="st24" d="M182 883.5h9.1v5.1H182z" />
            <path className="st25" d="M180.9 883.5h1v5.1h-1z" />
            <path className="st27" d="M172.9 883.4h8.1v15.1h-8.1z" />
            <path className="st25" d="M176.4 883.4h1v15.1h-1z" />
            <path className="st26" d="M209 898.5h7v1h-7z" />
          </g>
          <g id="Front_Road">
            <g id="right_x5F_garden">
              <linearGradient
                id="SVGID_9_"
                gradientUnits="userSpaceOnUse"
                x1={1526.155}
                y1={4343.05}
                x2={1526.155}
                y2={4259.55}
                gradientTransform="translate(0 -3256)"
              >
                <stop
                  offset={0}
                  style={{
                    stopColor: "#e0e4ea",
                    stopOpacity: 0,
                  }}
                />
                <stop
                  offset={1}
                  style={{
                    stopColor: "#e0e4ea",
                  }}
                />
              </linearGradient>
              <path
                d="M1920 995.7v83.4h-626.4l-159.5-77.5c-3-1.4-2-6 1.3-6l784.6.1z"
                style={{
                  fill: "url(#SVGID_9_)",
                }}
              />
              <path
                className="st29"
                d="M1220.3 1000.8c-.1 0 .1-.7.5-1.8s1-2.5 1.8-4.1 1.6-2.9 2.2-3.9 1.1-1.5 1.1-1.5-.3.6-.9 1.6-1.3 2.4-2.1 3.9c-.8 1.6-1.4 3-1.9 4-.4 1.1-.7 1.8-.7 1.8zm-3-13s.4.5.7 1.5c.3 1 .7 2.4.7 4 .1 1.6-.1 3-.4 4s-.5 1.6-.6 1.6.7-2.5.5-5.6c0-3-1-5.4-.9-5.5zm-15.5 17.3v-.9c.1-.6.2-1.4.3-2.4.3-2 .9-4.7 1.9-7.7 1-2.9 2.1-5.5 3-7.3.4-.9.8-1.6 1.1-2.1.3-.5.5-.8.5-.7 0 0-.1.3-.3.8-.3.6-.6 1.3-1 2.2-.8 1.8-1.9 4.4-2.8 7.3-.9 2.9-1.6 5.6-2 7.6-.2.9-.3 1.7-.5 2.3-.1.6-.2.9-.2.9zm-.8-19.4c.1 0 .1.9.1 2.3s-.2 3.3-.4 5.4c-.3 2.1-.7 4-1 5.4s-.6 2.2-.7 2.2.1-.9.4-2.2c.3-1.4.6-3.2.9-5.3s.5-4 .6-5.4c0-1.5 0-2.4.1-2.4zm-4.9 1.4s.4.6.8 1.5c.4 1 .8 2.4 1 4.1.2 1.6.1 3.1 0 4.2s-.3 1.7-.4 1.7.4-2.6 0-5.8-1.5-5.6-1.4-5.7zm-16.5 2.7c.1 0-.6 1.8-1 4.1-.5 2.3-.5 4.2-.6 4.2s-.3-1.9.2-4.2c.4-2.4 1.3-4.1 1.4-4.1zm-4.5-.2c.1 0 .4 1.9-.1 4.3-.5 2.3-1.5 4-1.5 4-.1-.1.7-1.8 1.1-4 .5-2.4.4-4.3.5-4.3zm-4.6-.3c.1 0 1 1.7 1.3 4.1.3 2.4-.1 4.3-.2 4.3s.1-1.9-.2-4.3c-.3-2.3-1-4.1-.9-4.1zm-13.9-2.1c.1.1-.8 2.2-1.8 4.9s-1.6 4.9-1.7 4.9.4-2.3 1.3-5.1c1-2.7 2.1-4.8 2.2-4.7zm-7.2 2.3c.1 0 .6 1.6.6 3.6.1 2.1-.2 3.7-.3 3.7-.1 0 0-1.7-.1-3.7s-.3-3.6-.2-3.6z"
              />
              <path
                className="st30"
                d="M1214.2 1014s.1.3.2.8h-.2c.3-.8.8-2 1.3-3.4 1-2.3 1.8-4.1 2-4 .1 0-.6 1.9-1.6 4.2-.6 1.4-1.1 2.6-1.5 3.3l-.2.5v-.5c-.1-.6-.1-.9 0-.9zm-.5-9.5c.1 0 .2 2.3-.1 5.2-.3 2.9-.8 5.2-.9 5.1-.1 0 .2-2.3.5-5.2.3-2.8.4-5.1.5-5.1zm-2.6 4.8c.1-.1.6.6.7 1.6.2 1-.1 1.8-.2 1.8s0-.8-.2-1.7c-.1-.9-.4-1.6-.3-1.7zm-20.7-6.4c.1.1-.7 1.9-1.3 4.4-.6 2.5-.7 4.5-.8 4.5-.1 0-.2-2.1.4-4.6.6-2.5 1.6-4.3 1.7-4.3zm-3.3.9c.1 0 .3 1.4.3 3.1.1 1.7.1 3.1-.1 3.1-.1 0-.3-1.4-.3-3.1 0-1.7 0-3.1.1-3.1zm-3.2 4.1c.1 0 .5.8.9 1.9.4 1.1.6 2 .5 2s-.5-.8-.9-1.9c-.3-1-.6-1.9-.5-2zm56.2-5.2c.1 0-.3 1.5-1.2 3-.9 1.6-2 2.6-2 2.5-.1-.1.8-1.2 1.7-2.7.9-1.5 1.4-2.8 1.5-2.8zm-4.8-1.4s.1-.1.4-.2h.1v.1c.1.6.2 1.9-.2 3.2-.5 2-1.6 3.4-1.6 3.3-.1-.1.8-1.5 1.2-3.4.3-1.3.4-2.5.4-3.1l.1.1h-.4zm-4.5 3c.1 0 .2 1.3.3 2.9 0 1.6 0 3-.1 3s-.2-1.3-.3-2.9c0-1.6 0-3 .1-3zm-64.6 4.3c-.1 0 .3-1.2.8-2.5.6-1.3 1.1-2.4 1.2-2.3.1 0-.3 1.2-.8 2.5-.6 1.3-1.1 2.4-1.2 2.3zm-1.1-.1c-.1 0-.1-1.5 0-3.3s.3-3.3.4-3.3.1 1.5 0 3.3-.3 3.3-.4 3.3zm-1.4 0c-.1 0-.6-1.1-1-2.6s-.7-2.7-.6-2.7.6 1.1 1 2.6c.4 1.4.7 2.6.6 2.7zm49.2 21.6c-.1 0 .2-1.1.8-2.4.5-1.3 1.1-2.3 1.2-2.2.1 0-.2 1.1-.8 2.4-.6 1.2-1.1 2.3-1.2 2.2zm-1-.7c-.1 0 .1-1.2.4-2.7.4-1.5.7-2.7.8-2.6.1 0-.1 1.2-.4 2.7s-.7 2.6-.8 2.6zm-1.9-.4c-.1 0-.4-1.3-.7-3-.3-1.7-.4-3.1-.3-3.1s.4 1.3.7 3c.3 1.8.5 3.1.3 3.1z"
              />
            </g>
            <path
              className="st16"
              d="m1152.2 1032.3-21-11.8c0 .7.1 1.5.1 2.4 0 1.2 0 2.2-.1 2.9 7.3 4.3 14.4 8.4 21 12.3-.1-.7-.1-1.8-.1-3 0-1 .1-2 .1-2.8zm-64.2-36.1-20.9-11.8c0 .5.1 1.2.1 1.9 0 .9 0 1.6-.1 2.1 7.1 4.1 14.1 8.2 20.9 12.2 0-.6-.1-1.4-.1-2.3 0-.7.1-1.4.1-2.1zm107 60.2-21.1-11.9c0 .7.1 1.7.1 2.8 0 1.4 0 2.7-.1 3.4.2.1.4.3.7.4 7.6 4.4 14.5 8.5 20.4 11.9-.1-.7-.1-1.9-.1-3.4 0-1.2 0-2.5.1-3.2zm-128.3-72.2-7.9-4.4c-.1 0-.1-.1-.1-.1h-.2c0 1.3-.2 2.5-.2 3.7 2.8 1.6 5.7 3.3 8.4 4.9 0-.5-.1-1.2-.1-1.9 0-.9 0-1.6.1-2.2zm106.9 60.2-21-11.8c.1.7.1 1.6.1 2.6 0 1.3 0 2.4-.1 3.2 7.5 4.4 14.6 8.5 21.1 12.3-.1-.7-.1-1.9-.1-3.3-.1-1.2-.1-2.3 0-3zm61.5 34.7-.5-.2h-.1c-.7-.3-1.7-.8-3.2-1.4-.6-.2-1.2-.5-1.9-.8-.9-.4-1.9-.8-3-1.2s-2.3-.9-3.6-1.4c-5.7-2.1-13.2-4.8-22.3-7.8 0 0-.1 0-.1-.1-1.6-.9-3.3-1.9-5.1-3 0-.7.1-2 .1-3.5 0-1.3 0-2.5-.1-3.2l23.6 13.3s.1.1.2.1l9.6 5.4c.4.2.9.5 1.3.7.1.1.3.2.4.2 1.5.9 3.1 1.7 4.5 2.6 0 .2.1.2.2.3zm-104.3-58.8-20.9-11.8v2.1c0 1.1 0 2.1-.1 2.8 7.2 4.2 14.2 8.3 21 12.2 0-.7-.1-1.7-.1-2.7 0-1 .1-1.9.1-2.6zm-21.4-12-20.9-11.8v1.9c0 1 0 1.9-.1 2.5 7.2 4.2 14.2 8.2 20.9 12.2 0-.7-.1-1.6-.1-2.5.1-.8.2-1.7.2-2.3z"
            />
            <path
              className="st1"
              d="M1088.6 1001.3c-7.1-4.1-14.5-8.4-21.9-12.7v-.2c.1.1.3.2.4.2v.2l21 12.2v-.2c.2.1.3.2.5.3v.2zm85.6 49.8c-22.9-13.3-52.4-30.5-85.6-49.8l21 12.2v-.3c.1.1.3.2.4.2v.2l21 12.3v-.3c.1.1.2.1.4.2v.3l21.1 12.3v-.3c.1.1.2.1.3.2v.3l21.1 12.3v-.3c.1 0 .2.1.3.2v.3zm.7.4 13.1 7.7-13.8-8.1c.2.1.5.2.7.4zm-116.1-71.7c.3.2.7.4 1.3.7 1.1.6 2.8 1.5 4.9 2.6 4.3 2.3 10.5 5.6 18 9.7 3.8 2.1 8 4.3 12.4 6.8s9.2 5.2 14.1 8c9.9 5.6 20.9 11.8 32.4 18.3 22.9 13 43.7 24.8 58.7 33.4 7.5 4.3 13.6 7.8 17.8 10.2 1 .6 6.2 3.6 11.5 6.7.1.1.3.2.4.2 1.5.9 3.1 1.8 4.5 2.6.1 0 .2.1.2.1h-.1l-.4-.2h-.1l-5.8-3.3c-4.1-2.4-8.1-4.6-9.7-5.6-.1 0-.1-.1-.2-.1-.2-.1-.4-.2-.5-.3-4.2-2.4-10.3-5.8-17.8-10-15.1-8.5-35.8-20.3-58.8-33.3-11.5-6.5-22.4-12.7-32.3-18.4-5-2.8-9.7-5.5-14.1-8s-8.6-4.7-12.4-6.8c-7.6-4.1-13.7-7.5-18-9.8-2.1-1.2-3.8-2.1-4.9-2.7-.4-.2-.8-.4-1-.6l-.5-.3v-.4l.4.5z"
            />
            <path
              className="st1"
              d="M1058.5 979.8c.2-.1 0-.1 0 0 .2-.1.3-.5.3-.5h-.5l-.2 4.2 8.6 5.1v-.3c-2.7-1.6-5.7-3.3-8.4-4.9.1-1.1.2-2.3.2-3.6zm8.5 8.9 21 12.2v-.2c-6.8-4-13.8-8.1-20.9-12.2-.1.1-.1.2-.1.2zm133.4 77.6s-.1 0 0 0c-.5-.2-.9-.3-1.3-.5l-3.9-2.3v-.3c1.8 1.2 3.6 2.2 5.2 3.1zm-47.9-27.7 21.1 12.3v-.3c-6.5-3.8-13.6-7.9-21.1-12.3v.3zm-64-37.4 21 12.2v-.3c-6.8-4-13.8-8-20.9-12.2-.1.2-.1.3-.1.3zm42.7 25 21.1 12.3v-.3c-6.7-3.9-13.7-8-21-12.3-.1.1-.1.2-.1.3zm42.7 24.6v.3l21.2 12.4v-.3c-6-3.5-12.8-7.5-20.4-11.9-.4-.3-.6-.4-.8-.5zm-64.1-37.1 21 12.3v-.3c-6.7-3.9-13.7-8-21-12.2v.2zm-227.1-12.5 21-12.2v-.2c-7.1 4.1-14.1 8.2-20.9 12.2-.1.1-.1.2-.1.2z"
            />
            <path
              className="st16"
              d="M775.6 1056.7c-.1.8-.1 1.9-.1 3.1v2.8c-12.5 4.6-25 9.7-37.4 15.5-.6.4-1.2.7-1.8 1h-.4c1.6-.9 3.3-1.9 5-2.9l6-3.4c.2-.1.4-.2.6-.4l28-15.9c.1.1.1.2.1.2zm128.1-72.3-20.9 11.8c0 .6.1 1.4.1 2.2s0 1.6-.1 2.3c6.8-4 13.8-8.1 20.9-12.2 0-.5-.1-1.3-.1-2.1s0-1.4.1-2zm-106.9 60.2-21.1 11.9c.1.7.1 1.9.1 3.3s0 2.7-.1 3.4c6-3.5 12.8-7.5 20.5-11.9.2-.1.4-.3.7-.4-.1-.7-.1-2-.1-3.4-.1-1.2 0-2.2 0-2.9zm107.4-58.2c0 .7 0 1.4-.1 1.9 2.7-1.6 5.5-3.2 8.2-4.8v-3.8h-.2c-.1 0-.2.1-.3.2l-7.7 4.3c.1.7.1 1.4.1 2.2zm-22 10.1-20.9 11.8c0 .7.1 1.5.1 2.4 0 1 0 1.8-.1 2.5 6.8-4 13.8-8 20.9-12.2 0-.7-.1-1.6-.1-2.5.1-.8.1-1.4.1-2zm-64 36-21 11.8c0 .7.1 1.8.1 3 0 1.4 0 2.5-.1 3.3 6.5-3.8 13.6-7.9 21.1-12.3-.1-.7-.1-1.9-.1-3.2-.1-.9-.1-1.9 0-2.6zm21.3-12-21 11.8c0 .7.1 1.7.1 2.8 0 1.2 0 2.2-.1 3 6.7-3.9 13.7-8 21-12.3-.1-.7-.1-1.8-.1-2.9.1-.9.1-1.7.1-2.4zm21.4-12-20.9 11.8c0 .7.1 1.6.1 2.6 0 1.1 0 2-.1 2.7 6.7-3.9 13.7-8 21-12.2 0-.7-.1-1.7-.1-2.8-.1-.7-.1-1.5 0-2.1z"
            />
            <path
              className="st1"
              d="M882.7 1001.2c.2-.1.4-.2.7-.4l-.7.4c-33.6 19.5-63.4 36.9-86.4 50.2l-16.8 9.8c-.4.1-.9.3-1.3.5 5.3-3.1 11.3-6.6 17.9-10.4.2-.1.4-.3.7-.4.1 0 .2-.1.3-.1 6.5-3.8 13.6-7.9 21.1-12.3.1-.1.2-.1.3-.2 6.7-3.9 13.7-8 21-12.2.1-.1.2-.2.4-.2 6.7-3.9 13.7-8 21-12.2.1-.1.3-.2.4-.2 6.8-3.9 13.8-8 20.9-12.2.1-.1.3-.2.5-.3v.2zm.7-.4 12.3-7.2-12.3 7.2zm12.3-7.2c2.6-1.5 5.3-3.1 8-4.7l-8 4.7z"
            />
            <path
              className="st1"
              d="M912.7 979.3v4.4l-.1.1c-3 1.7-6 3.5-8.9 5.2v-.2c.1-.1.3-.2.4-.2 2.7-1.6 5.5-3.2 8.2-4.8V980h-.2c-.1 0-.2.1-.3.2-.3.1-.6.3-1 .5-1.1.6-2.8 1.5-4.9 2.7-4.3 2.3-10.4 5.7-18 9.8-3.8 2.1-7.9 4.4-12.4 6.8-4.4 2.5-9.1 5.2-14.1 8-9.9 5.6-20.9 11.8-32.3 18.4-20.4 11.5-39 22.1-53.5 30.3-1.8 1-3.6 2-5.3 3-7.5 4.2-13.6 7.7-17.8 10.1-1.1.6-6.5 3.8-11.7 6.8-.8.5-1.7 1-2.5 1.5h-.1c-.6.3-1.1.6-1.6.9h-.2c.2-.1.4-.2.6-.4 0 0 .1 0 .1-.1 3.1-1.8 6.8-4 9.8-5.8.2-.1.4-.2.6-.4 2.4-1.4 4.3-2.5 4.9-2.8 4.2-2.4 10.3-5.9 17.8-10.2 15-8.6 35.8-20.4 58.7-33.4 11.5-6.5 22.4-12.7 32.3-18.3 5-2.8 9.7-5.5 14.1-8 4.5-2.5 8.6-4.7 12.4-6.8 7.6-4.1 13.8-7.4 18-9.7 2.1-1.1 3.8-2 4.9-2.6.5-.3 1-.5 1.3-.7l.8-.5z"
            />
            <path
              className="st2"
              d="m1576.4 959.7-3.8 3.8h67.9l2.2-3.8h-66.3zm-1455.9 0-3.8 3.8h67.9l2.2-3.8h-66.3zm121.8 0-3.8 3.8h67.9l2.2-3.8h-66.3zm121.7 0-3.8 3.8h67.9l2.2-3.8H364zm1494.7 0-3.8 3.8h65.1v-3.8h-61.3zm-423.5 0-3.8 3.8h67.9l2.2-3.8h-66.3zm-705.9 0-3.8 3.8h67.9l2.2-3.8h-66.3zM0 959.7v3.8h62.9l2.2-3.8H0zm1294 0-3.8 3.8h67.9l2.2-3.8H1294zm-282.3 0-3.8 3.8h67.9l2.2-3.8h-66.3zm-525.9 0-3.8 3.8h67.9l2.2-3.8h-66.3zm667 0-3.8 3.8h67.9l2.2-3.8h-66.3zm564.7 0-3.8 3.8h67.9l2.2-3.8h-66.3zm-1109.9 0-3.8 3.8h67.9l2.2-3.8h-66.3zm262.9 0-3.8 3.8h67.9l2.2-3.8h-66.3z"
            />
            <g id="left_x5F_garden">
              <linearGradient
                id="SVGID_10_"
                gradientUnits="userSpaceOnUse"
                x1={631.924}
                y1={4368.653}
                x2={751.571}
                y2={4282.888}
                gradientTransform="translate(0 -3256)"
              >
                <stop
                  offset={0}
                  style={{
                    stopColor: "#e0e4ea",
                    stopOpacity: 0,
                  }}
                />
                <stop
                  offset={1}
                  style={{
                    stopColor: "#e0e4ea",
                  }}
                />
              </linearGradient>
              <path
                d="M846.6 1001.6 688.1 1079H619l127.7-85.8 98.6 2.3c3.4.2 4.4 4.7 1.3 6.1z"
                style={{
                  fill: "url(#SVGID_10_)",
                }}
              />
              <path
                className="st29"
                d="M760.4 1000.8c-.1 0-.3-.6-.8-1.7-.5-1-1.1-2.5-1.9-4-.8-1.6-1.6-2.9-2.1-3.9-.6-1-.9-1.6-.9-1.6s.5.5 1.1 1.5 1.5 2.3 2.2 3.9c.8 1.6 1.4 3 1.8 4.1.5 1 .7 1.6.6 1.7zm3-13c.1 0-.9 2.4-1 5.5-.2 3.1.7 5.6.5 5.6 0 0-.3-.6-.6-1.6s-.5-2.4-.4-4 .4-3 .7-4c.5-.9.8-1.5.8-1.5zm15.5 17.3s-.1-.3-.2-.9c-.1-.6-.3-1.4-.5-2.3-.4-2-1.1-4.7-2-7.6-.9-2.9-2-5.5-2.8-7.3-.4-.9-.7-1.6-1-2.2-.2-.5-.4-.8-.3-.8 0 0 .2.3.5.7.3.5.7 1.2 1.1 2.1.9 1.8 2 4.4 3 7.3.9 2.9 1.6 5.7 1.9 7.7.2 1 .3 1.8.3 2.4v.9zm.8-19.4c.1 0 .1.9.2 2.2.1 1.4.3 3.3.6 5.4.3 2.1.6 4 .9 5.3.3 1.4.4 2.2.4 2.2-.1 0-.3-.8-.7-2.2-.3-1.4-.7-3.2-1-5.4-.3-2.1-.4-4-.4-5.4-.1-1.2 0-2.1 0-2.1zm4.9 1.4c.1 0-1 2.5-1.4 5.7s.1 5.8 0 5.8c0 0-.2-.6-.4-1.7-.1-1.1-.2-2.6 0-4.2s.6-3.1 1-4.1c.4-.9.7-1.5.8-1.5zm16.5 2.7c.1 0 1 1.7 1.4 4 .5 2.3.3 4.2.2 4.2s-.1-1.9-.6-4.2c-.4-2.2-1.1-3.9-1-4zm4.5-.2c.1 0 0 1.9.5 4.2.4 2.3 1.2 4 1.1 4-.1.1-1.1-1.6-1.5-4-.5-2.2-.2-4.2-.1-4.2zm4.6-.3c.1 0-.6 1.8-.9 4.2-.3 2.3-.1 4.2-.2 4.3-.1 0-.5-1.9-.2-4.3.3-2.5 1.2-4.3 1.3-4.2zm13.9-2.1c.1 0 1.2 2 2.2 4.7s1.5 5 1.3 5.1c-.1 0-.7-2.2-1.7-4.9-.9-2.7-1.9-4.9-1.8-4.9zm7.2 2.3c.1 0-.1 1.6-.2 3.7-.1 2 0 3.7-.1 3.7s-.4-1.6-.3-3.7c.1-2.1.5-3.7.6-3.7z"
              />
              <path
                className="st30"
                d="M766.5 1014s.1.3.1.9v.5l-.2-.5c-.4-.7-.9-1.9-1.5-3.3-1-2.3-1.7-4.2-1.6-4.2.1 0 1 1.8 2 4 .6 1.4 1.1 2.6 1.3 3.4h-.2c0-.5.1-.8.1-.8zm.5-9.5c.1 0 .2 2.3.5 5.2s.6 5.2.5 5.2-.6-2.3-.9-5.1c-.3-2.9-.2-5.3-.1-5.3zm2.6 4.8c.1.1-.2.8-.3 1.7s-.1 1.7-.2 1.7-.4-.8-.2-1.8c.1-.9.6-1.6.7-1.6zm20.8-6.4c.1-.1 1.1 1.8 1.7 4.3.6 2.5.5 4.6.4 4.6s-.2-2.1-.8-4.5c-.6-2.4-1.5-4.3-1.3-4.4zm3.2.9c.1 0 .1 1.4.1 3.1-.1 1.7-.2 3.1-.3 3.1s-.1-1.4-.1-3.1c0-1.7.2-3.1.3-3.1zm3.2 4.1c.1 0-.1 1-.5 2-.4 1.1-.8 1.9-.9 1.9-.1 0 .1-1 .5-2 .4-1.1.8-1.9.9-1.9zm-56.2-5.2c.1 0 .7 1.3 1.5 2.8.9 1.5 1.8 2.7 1.7 2.7-.1.1-1.1-1-2-2.5-.9-1.5-1.3-2.9-1.2-3zm4.8-1.4h-.5l.1-.1c0 .6.1 1.8.4 3.1.5 2 1.3 3.4 1.2 3.4-.1.1-1.2-1.3-1.6-3.3-.3-1.4-.3-2.6-.2-3.2v-.1h.1c.4.1.5.2.5.2zm4.5 3c.1 0 .2 1.3.1 3 0 1.6-.2 3-.3 2.9-.1 0-.2-1.3-.1-3 0-1.5.2-2.9.3-2.9zm64.7 4.3c-.1 0-.6-1-1.2-2.3-.6-1.3-.9-2.4-.8-2.5.1 0 .6 1 1.2 2.3.5 1.4.9 2.5.8 2.5zm1.1-.1c-.1 0-.3-1.5-.4-3.3-.1-1.8-.1-3.3 0-3.3s.3 1.5.4 3.3c.1 1.8.1 3.2 0 3.3zm1.3 0c-.1 0 .2-1.3.6-2.7.4-1.5.9-2.7 1-2.6.1 0-.2 1.3-.6 2.7-.4 1.4-.9 2.6-1 2.6zm-49.2 21.6c-.1 0-.6-1-1.2-2.2-.5-1.3-.9-2.4-.8-2.4.1 0 .6 1 1.2 2.2.6 1.3.9 2.4.8 2.4zm1-.7c-.1 0-.5-1.2-.8-2.6-.4-1.5-.6-2.7-.4-2.7.1 0 .5 1.2.8 2.6.3 1.5.5 2.7.4 2.7zm1.9-.4c-.1 0 0-1.4.3-3.1.3-1.7.6-3 .7-3 .1 0 0 1.4-.3 3.1-.3 1.7-.6 3.1-.7 3z"
              />
            </g>
            <path className="st1" d="m1920 980.4-861.4-.6-.3-.5 861.7.1z" />
            <g id="light">
              <path
                className="st32"
                d="M1079.1 969.9V833.4c0-.7-.4-1.6-1.2-2.3l-22.1-16.6 1.8-2.4 22.2 16.6c1.5 1.3 2.4 3 2.3 4.7v136.4h-3v.1z"
              />
              <path
                className="st32"
                d="m1061.1 812.7-18.9-16.3-1.8 4.3-10.1 1.2.6.4 23.6 16.4h4.6l2.4-3.5c.6-.8.4-1.8-.4-2.5z"
              />
              <path
                className="st33"
                d="m1040.4 800.7-10.1 1.2 24.3 16.8h4.6l.4-1.9z"
              />
              <path className="st12" d="M1077.3 871.9h5.8v3.4h-5.8z" />
              <path
                className="st12"
                d="M1070.2 872.8h8.7v1.5h-8.7zm7.1 19h5.8v3.4h-5.8z"
              />
              <path className="st12" d="M1070.2 892.7h8.7v1.5h-8.7z" />
              <path
                className="st4"
                d="M1072.5 905.2h-13.9c-1.2 0-2.1-.9-2.1-2.1v-41.8c0-1.2.9-2.1 2.1-2.1h13.9c1.2 0 2.1.9 2.1 2.1v41.8c-.1 1.1-1 2.1-2.1 2.1z"
              />
              <path
                className="st10"
                d="M1070.5 868.9c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5 5 2.2 5 5z"
              />
              <path
                className="st34"
                d="M1070.5 882.5c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5 5 2.2 5 5z"
              />
              <path
                className="st35"
                d="M1070.5 896.1c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5 5 2.2 5 5z"
              />
              <path
                className="st36"
                d="M1069.7 871.1c-.1 0 .2-.6.3-1.6 0-1-.2-2.4-1.2-3.4-1-1.1-2.4-1.5-3.4-1.5s-1.6.2-1.6.2.1-.1.4-.2c.3-.1.7-.2 1.2-.2 1 0 2.5.3 3.6 1.5s1.3 2.7 1.2 3.7c0 .5-.2.9-.3 1.2-.1.1-.2.3-.2.3zm0 13.4c-.1 0 .2-.6.3-1.6 0-1-.2-2.4-1.2-3.4-1-1.1-2.4-1.5-3.4-1.5s-1.6.2-1.6.2.1-.1.4-.2c.3-.1.7-.2 1.2-.2 1 0 2.5.3 3.6 1.5s1.3 2.7 1.2 3.7c0 .5-.2.9-.3 1.2-.1.1-.2.3-.2.3zm0 13.7c-.1 0 .2-.6.3-1.6 0-1-.2-2.4-1.2-3.4-1-1.1-2.4-1.5-3.4-1.5s-1.6.2-1.6.2.1-.1.4-.2c.3-.1.7-.2 1.2-.2 1 0 2.5.3 3.6 1.5s1.3 2.7 1.2 3.7c0 .5-.2.9-.3 1.2-.1.2-.2.3-.2.3z"
              />
              <path
                className="st33"
                d="M1029.8 822.1c.1.1-3.2 4.7-7.4 10.4s-7.6 10.3-7.7 10.2c-.1-.1 3.2-4.7 7.4-10.4s7.6-10.2 7.7-10.2zm3.3 21.3c-.1 0 .6-4.2 1.6-9.4s1.9-9.3 2-9.3-.6 4.2-1.6 9.4c-1 5.1-1.9 9.3-2 9.3zm-8.3-28.8c0 .1-.9.4-2.4 1s-3.6 1.4-5.9 2.4c-2.3 1-4.3 1.9-5.8 2.6-1.5.7-2.4 1.1-2.4 1.1s.8-.6 2.3-1.3c1.5-.8 3.5-1.7 5.8-2.7s4.4-1.8 6-2.3c1.4-.6 2.4-.8 2.4-.8z"
              />
              <path className="st12" d="m1076 984.4 1.8-21.3h6.1l2.1 21.3z" />
              <path
                className="st1"
                d="m1042.2 796.4-9.2 1.5-1 .2h-.2c-.8.1-1.4.9-1.4 1.7v2.1l10.1-1.2 1.7-4.3z"
              />
            </g>
          </g>
          <g id="light_house">
            <linearGradient
              id="SVGID_11_"
              gradientUnits="userSpaceOnUse"
              x1={69.5}
              y1={8968.008}
              x2={69.5}
              y2={9009.248}
              gradientTransform="translate(0 -8026)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              style={{
                opacity: 0.2,
                fill: "url(#SVGID_11_)",
                enableBackground: "new",
              }}
              d="m51.2 942.4-40.4 42.3h103.9l13.5-42.3z"
            />
            <path
              className="st34"
              d="M116.7 678.7H64.3l1.6-32.3h49.4zm1.5 34.6H62.6l1.7-33.3h52.5zm1.6 35.4h-59l1.7-34.1h55.8zm1.6 37.5H59l1.8-36.2h59zm1.6 37.4H57.1l1.8-36.1h62.6zm1.7 38.7H55.2l1.8-37.4h66.1zm1.6 36H53.4l1.7-34.7h69.7zm1.9 44.1h-77l2.1-42.8h73z"
            />
            <path
              d="M66.8 646.4v4.7h47.5v-4.7L91 636.1zM91 636.1v-65.2"
              style={{
                fill: "none",
                stroke: "#979da5",
                strokeMiterlimit: 10,
              }}
            />
          </g>
          <g id="petrol_x5F_pump">
            <linearGradient
              id="SVGID_12_"
              gradientUnits="userSpaceOnUse"
              x1={1692.9}
              y1={8945.063}
              x2={1692.9}
              y2={8975.906}
              gradientTransform="translate(0 -8026)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              style={{
                opacity: 0.15,
                fill: "url(#SVGID_12_)",
                enableBackground: "new",
              }}
              d="M1809.1 919h-242.4l10 29.4h242.4z"
            />
            <path className="st2" d="M1568.6 852.6h240v59.8h-240z" />
            <path
              className="st40"
              d="M1796.8 910.6v-37.1h11.8v37.7zm-76.7-26.3c-.2-2.3-.4-4.5-.2-6.8.1-1.8.4-3.6.2-5.4-.3-1.8-1.4-3.6-3.1-4.1-2.4-.7-4.7 1.5-5.9 3.7-.9 1.6-1.4 3.5-1 5.3.3 1.4 1.3 2.5 1.5 3.9.2 1 0 2-.2 3l-.9 5.1c-.2 1.3-.5 2.6-1.1 3.7-1.1 1.8-3 2.8-4.6 4.1s-3.4 12.8-2.6 14.7l21-.8c-.6-7.5-2.5-18.8-3.1-26.4zm-70.9 25.9c-.7-2.8.1-5.9 2-8.1 1-1.1 2.4-2.1 2.9-3.5 1-2.5-.9-5.3-.1-7.9.5-1.7 2.1-2.9 2.9-4.6 1.1-2.2.4-4.9.2-7.3-.2-2.5.5-5.5 2.9-6.3 2.5-.8 5.1 1.7 5.6 4.3s-.2 5.3-.3 7.9c0 2.7.6 5.4.3 8-.3 2.1-1.1 4.1-1.1 6.1 0 3.8 2.5 7.8.5 11l-15.8.4z"
            />
            <g className="st41">
              <path
                className="st13"
                d="m1748.6 890.1 52.3-37.1h7.7v8.1l-60 39.5z"
              />
            </g>
            <g className="st41">
              <path
                className="st13"
                d="m1568.4 896.5 51.4-38.6h13.8l-65.3 49.1z"
              />
            </g>
            <path
              className="st32"
              d="M1568.6 829.3h240V853h-240zm-1.9 80.7h242.4v9h-242.4z"
            />
            <path
              style={{
                fill: "#fafafa",
              }}
              d="M1763.3 898.6h1.1v5.4h-1.1z"
            />
            <path className="st32" d="M1577.3 792h227.9v22.3h-227.9z" />
            <g className="st43">
              <path
                className="st13"
                d="m1622.9 792-21.8 22.2h16.1l21.3-22.2z"
              />
            </g>
            <g className="st43">
              <path
                className="st13"
                d="m1624.5 814.2 20.1-22.2h5l-20.2 22.2z"
              />
            </g>
            <g className="st43">
              <path className="st13" d="m1757 792-21.8 22.2h16.1l21.3-22.2z" />
            </g>
            <g className="st43">
              <path className="st13" d="m1758.7 814.2 20-22.2h5l-20.1 22.2z" />
            </g>
            <path
              className="st12"
              d="M1716.4 919.1c-.1 0-.1-20.1-.1-44.8 0-24.8.1-44.8.1-44.8s.1 20.1.1 44.8 0 44.8-.1 44.8z"
            />
            <g className="st41">
              <path
                className="st13"
                d="m1709.1 853-49.5 37.1-.1 10.5 56.9-39.5V853z"
              />
            </g>
            <path
              className="st12"
              d="M1659.6 919.1c-.1 0-.1-20.1-.1-44.8 0-24.8.1-44.8.1-44.8s.1 20.1.1 44.8 0 44.8-.1 44.8zm27.9.4c-.1 0-.1-14.8-.1-33.1s.1-33.1.1-33.1.1 14.8.1 33.1 0 33.1-.1 33.1z"
            />
            <path
              className="st32"
              d="M1689.2 875.1h2.3v15.5h-2.3zm-6 0h2.3v15.5h-2.3z"
            />
            <g id="reckshaw_x5F_2">
              <circle className="st3" cx={1721.6} cy={913.4} r={5.6} />
              <path
                className="st44"
                d="M1755.5 880.3h-22.8c-.9 0-1.8.5-2.4 1.3l-1.9 2.7-.5.7-5.7 8.1c-.7.9-1 1.9-1 3v2c0 1 .3 1.9.8 2.7l3.9 6.6c-1.2-1.2-2.8-1.9-4.5-1.9-4.1 0-7.4 4.1-7.4 8.2h14.6l2.1 1.2c.3.2.7.3 1.1.3h23.7c2 0 3.7-1.6 3.7-3.7v-27.4c0-2-1.7-3.7-3.7-3.8z"
              />
              <circle className="st3" cx={1750.5} cy={911.8} r={5.6} />
              <path
                className="st45"
                d="m1754.8 889.1-.1 3.7c0 2-1.6 3.7-3.7 3.7h-3c-2 0-3.7 1.6-3.7 3.7v6.7c0 2-1.6 3.7-3.7 3.7-2 0-3.7-1.6-3.7-3.7v-17.8c0-2 1.6-3.7 3.7-3.7h10.5c2 0 3.7 1.6 3.7 3.7zm-23.3-4h-3.7l-5.7 8.1c-.7.9-1 1.9-1 3h10.3c1.3 0 2.4-1.1 2.4-2.4v-6.4c0-1.3-1.1-2.3-2.3-2.3z"
              />
            </g>
            <circle className="st40" cx={1690.4} cy={792.2} r={12.6} />
            <path
              className="st12"
              d="M1703 792.2v-1.7c-.1-.4-.1-.8-.3-1.3-.2-1-.7-2.1-1.4-3.3-.7-1.2-1.8-2.5-3.2-3.5-1.4-1.1-3.2-2-5.3-2.3-.5-.1-1-.2-1.6-.2h-1.6c-.3 0-.6 0-.8.1-.3 0-.6.1-.8.1-.6.2-1.1.3-1.7.5s-1.1.5-1.6.7c-.3.1-.5.3-.8.5-.3.1-.5.3-.8.5-.5.3-1 .8-1.4 1.2-.4.5-.9.9-1.2 1.4-.7 1-1.4 2.2-1.8 3.4-.4 1.3-.6 2.6-.6 3.9 0 1.4.2 2.7.6 3.9.4 1.3 1 2.4 1.8 3.4.4.5.8 1 1.2 1.4.5.4.9.9 1.4 1.2.2.2.5.4.8.5.3.2.5.3.8.5.5.3 1.1.5 1.6.7s1.1.3 1.7.5c.3.1.6.1.8.1.3 0 .6.1.8.1h1.6c.5 0 1.1-.1 1.6-.2 2.1-.4 3.8-1.3 5.3-2.3 1.4-1.1 2.5-2.3 3.2-3.5s1.2-2.4 1.4-3.3c.1-.5.2-.9.3-1.3 0-.2.1-.4.1-.5v-1c-.2-.1-.1-.2-.1-.2v1.2c0 .2 0 .3-.1.5-.1.4-.1.8-.2 1.3-.2 1-.7 2.1-1.4 3.4-.7 1.2-1.8 2.5-3.2 3.6-1.4 1.1-3.2 2-5.3 2.4-.5.1-1.1.2-1.6.2h-1.6c-.3 0-.6 0-.8-.1-.3 0-.6-.1-.9-.1-.6-.2-1.1-.3-1.7-.5s-1.1-.5-1.7-.7c-.3-.1-.5-.3-.8-.5s-.5-.3-.8-.5c-.5-.4-1-.8-1.4-1.2-.4-.5-.9-.9-1.2-1.5-.8-1-1.4-2.2-1.8-3.5s-.6-2.6-.7-4c0-1.4.2-2.7.7-4 .4-1.3 1.1-2.4 1.8-3.5l1.2-1.5c.5-.4.9-.9 1.4-1.2.2-.2.5-.4.8-.5.3-.2.5-.3.8-.5.6-.3 1.1-.5 1.7-.7s1.1-.3 1.7-.5c.3-.1.6-.1.9-.1s.6-.1.8-.1h1.6c.5 0 1.1.1 1.6.2 2.1.4 3.9 1.3 5.3 2.4 1.4 1.1 2.5 2.4 3.2 3.6.7 1.2 1.2 2.4 1.4 3.4.1.5.2.9.2 1.3v1.5c.1.1.1.2.1.2z"
            />
            <path
              className="st12"
              d="M1696.2 788.7c-.2-.1-.4-.1-.5.1-.3.4-.6.8-1 1.2-.1.1-.1.2-.1.3v3.9h-.5v-6.6c0-.3-.1-.6-.2-.8-.2-.2-.4-.3-.6-.4h-5.9c-.2.1-.3.1-.5.2-.3.2-.4.6-.4.9v8.8h-.2c-.3 0-.4 0-.5.4v1.4c.1.3.2.4.5.4h8.3c.3 0 .4-.1.4-.5v-1.2c0-.3-.1-.4-.4-.4h-.3V795c0-.1 0-.1.1-.1h.7c.3 0 .4-.1.4-.4v-3.1h.2c.2 0 .4-.2.4-.4v-1.3c0-.1 0-.2.1-.2.1-.1.2-.2.2-.3 0-.2 0-.4-.2-.5z"
            />
            <path
              className="st13"
              d="M1692.4 787.8h-4.1c-.3 0-.4.1-.4.4v2.4c0 .3.1.4.4.4h4.1c.3 0 .4-.1.4-.4v-2.4c0-.2-.1-.4-.4-.4zm-3.7 4.8h-.4c-.2 0-.4-.2-.4-.4s.1-.4.4-.4h.9c.2 0 .4.2.4.4s-.2.3-.4.3c-.2.1-.4.1-.5.1z"
              id="NCkLls.tif_3_"
            />
            <path
              className="st13"
              d="M1694.4 796.3c0 .1-1.8.1-4 .1s-4-.1-4-.1c0-.1 1.8-.1 4-.1s4 .1 4 .1z"
            />
            <path className="st12" d="M1631.4 873.5h2.2v3.2h-2.2z" />
            <path className="st2" d="M1620.7 882.5h14.7v11.4h-14.7z" />
            <path className="st4" d="M1602.3 823.4h35.4v34.3h-35.4z" />
            <path
              className="st40"
              d="M1625.6 893.6v.3h4.2v-.3h-4.2zm-7.4-21.9v47.5h19.5v-47.5h-19.5zm16.8 1.8v20h-14.1v-20h14.1z"
            />
            <path className="st32" d="M1620.8 893.5h4.8v9.6h-4.8z" />
            <path className="st40" d="M1602.4 919.1h-7.9v-97.8h7.9z" />
            <path
              className="st12"
              d="M1602.4 919.1v-97.8l.1.1h-7.9l.1-.1c0 44.2-.1 82.1-.1 97.7 2.6 0 4.5 0 5.9.1h1.9-7.9c0-15.6 0-53.5-.1-97.7v-.1h8.1v97.5c-.1.2-.1.3-.1.3z"
            />
            <path className="st40" d="M1637.7 819.7h7.9v99.4h-7.9z" />
            <path
              className="st12"
              d="M1645.5 919.1v-99.3l.1.1h-7.9l.1-.1c0 45.1-.1 83.7-.1 99.4h7.4c.3-.1.4-.1.4-.1h-7.9c0-15.7 0-54.3-.1-99.4v-.1h8.1v99c-.1.4-.1.5-.1.5zm-22.9-45.6h2.2v3.2h-2.2zm4.3 0h2.2v3.2h-2.2z"
            />
            <path className="st40" d="M1602.4 901.9h15.8v17.2h-15.8z" />
            <path className="st40" d="M1606.4 871.7h11.7V902h-11.7z" />
            <path className="st12" d="M1622 895.1h2.3v8h-2.3z" />
            <path
              className="st40"
              d="M1623.5 898.6h-.7v-2.5c0-.2.2-.4.4-.4s.4.2.4.4v2.5h-.1z"
            />
            <path className="st46" d="M1620.1 919.1v-12.6h14.8v12.3" />
            <path
              className="st12"
              d="M1621.1 917.3c-1.2 0-2.1-.8-2.1-1.8v-8.8c0-2.4 1.5-10.3 2.7-16.1.4-2.1.8-3.9 1-5s.5-3.7.8-9.4c0-.4 0-.5.2-.5v.2h.2v.3c-.3 5.7-.6 8.3-.8 9.4-.2 1.2-.6 3-1 5.1-1.1 5.7-2.7 13.6-2.7 16v8.8c0 .8.8 1.4 1.7 1.4.5 0 1-.2 1.3-.5s.4-.6.4-.9v-12.8h.4v12.8c0 .5-.2.9-.5 1.3-.4.2-1 .5-1.6.5z"
            />
            <path className="st32" d="M1608 875.9h8.6v6.4h-8.6z" />
            <path
              className="st12"
              d="M1608.9 876.6h6.8v5h-6.8zm3.4 9.1s0-.5-.1-1.1l.1.1h-4c0-.1-.1.1.1-.1v1.1l-.1-.1c1.1 0 2.1 0 2.9.1h1.1s-.4 0-1.1.1h-3v-1.2l.1-.1h4.1v.1c0 .7-.1 1.1-.1 1.1z"
            />
            <path className="st4" d="M1622.5 898.6h1.3v5.2h-1.3z" />
            <path className="st32" d="M1625.3 893.5h4.8v9.6h-4.8z" />
            <path className="st12" d="M1626.5 895.1h2.3v8h-2.3z" />
            <path
              className="st40"
              d="M1628 898.6h-.7v-2.5c0-.2.2-.4.4-.4s.4.2.4.4v2.5h-.1z"
            />
            <path
              className="st12"
              d="M1625.6 917.3c-1.1 0-1.5-.2-1.5-1.2v-8.8c0-2.4 1.5-10.3 2.7-16.1.4-2.1.8-3.9 1-5 .3-1.6.4-5.2.3-10 0-.3 0-.3.1-.4l.2.2v.2-.2h.2v.2c.1 2.8.1 7.8-.3 10.1-.2 1.2-.6 3-1 5-1.1 5.7-2.7 13.6-2.7 16v8.8c0 .7.1.8 1.1.8.5 0 1-.2 1.3-.5s.4-.6.4-.9v-12.8h.4v12.8c0 .5-.2.9-.5 1.3-.5.2-1.1.5-1.7.5z"
            />
            <path
              className="st32"
              d="M1627 898.6h1.3v5.2h-1.3zm2.8-5.1h4.8v9.6h-4.8z"
            />
            <path className="st12" d="M1631 895.1h2.3v8h-2.3z" />
            <path
              className="st40"
              d="M1632.5 898.6h-.7v-2.5c0-.2.2-.4.4-.4s.4.2.4.4v2.5h-.1z"
            />
            <path className="st32" d="M1630.3 884h3.6v3.6h-3.6z" />
            <path
              className="st12"
              d="M1628.6 885.1c0 .1-1.4.1-3.2.1-1.8 0-3.2-.1-3.2-.1 0-.1 1.4-.1 3.2-.1 1.8-.1 3.2 0 3.2.1zm0 .8c0 .1-1.4.1-3.2.1-1.8 0-3.2-.1-3.2-.1 0-.1 1.4-.1 3.2-.1s3.2 0 3.2.1zm0 .8c0 .1-1.4.1-3.2.1-1.8 0-3.2-.1-3.2-.1 0-.1 1.4-.1 3.2-.1s3.2.1 3.2.1zm1.9 30.6h-.4c-1-.2-1.7-.9-1.7-1.8v-8.8c0-2.4 1.5-10.3 2.7-16.1.4-2.1.8-3.9 1-5 .3-1.6.4-5 .4-9.4 0-.3 0-.3.1-.4l.2.2v.2-.2h.2v.2c0 4.5-.1 7.8-.4 9.5-.2 1.2-.6 3-1 5.1-1.1 5.7-2.7 13.6-2.7 16v8.8c0 .7.7 1.3 1.5 1.4.4 0 .8-.2 1.1-.5.3-.3.4-.6.4-.9v-12.8h.4v12.8c0 .5-.2.9-.5 1.3-.4 0-.8.3-1.3.4zm-12.3-45.8c.1 0 .1 10.6.1 23.6s-.1 23.6-.1 23.6-.1-10.6-.1-23.6c0-13.1 0-23.6.1-23.6zm-9.3 5.2s-.3-.1-.5-.3c-.3-.2-.4-.4-.4-.5 0 0 .3.1.5.3.3.2.5.4.4.5zm7.8-.8s-.2.3-.5.6-.6.4-.6.4.2-.3.5-.6.5-.4.6-.4zm-1 5.7s.3.1.5.3c.3.2.4.4.4.5 0 0-.3-.1-.5-.3-.3-.3-.4-.5-.4-.5zm-7.7.7s.2-.3.5-.6.6-.4.6-.4-.2.3-.5.6-.6.5-.6.4z"
            />
            <path
              className="st4"
              d="M1623.6 837.3c0 .1-1.4.1-3.2.1-1.8 0-3.2-.1-3.2-.1 0-.1 1.4-.1 3.2-.1 1.7-.1 3.2 0 3.2.1z"
            />
            <path
              className="st12"
              d="M1658.8 919.1c0 .1-16.6.1-37.1.1s-37.1-.1-37.1-.1c0-.1 16.6-.1 37.1-.1s37.1 0 37.1.1z"
            />
            <path className="st2" d="M1631.5 898.6h1.3v5.2h-1.3z" />
            <path className="st40" d="M1654.2 814.2v4.9h-69.1v-4.9h69.1z" />
            <path
              className="st12"
              d="M1654.3 814.2v5.1h-.5c-31.4 0-58.3-.1-68.6-.1h-.1 38.9c9.2 0 19.4 0 30.1-.1v-4.7h-69v-.1h69.2v-.1z"
            />
            <path className="st40" d="m1593.8 823.6-8.7-4.3 69.1-.2-8.6 4.5z" />
            <path
              className="st12"
              d="M1591.6 822.5c-1.5-.7-3.8-1.8-6.5-3.2 2.7 1.3 5 2.4 6.5 3.2zm1.7.9c-.4-.2-1-.5-1.7-.9.8.3 1.3.6 1.7.9.2 0 .3.1.5.2-.2 0-.3-.1-.5-.2zm61-4.4v.2h-.1c-.1 0-.1.1-.2.1-2.9 1.4-5.6 2.9-8.2 4.2h-.2c2.7-1.3 5.3-2.8 8-4.2h-7.9c-25.8 0-48.3 0-60.3-.1h-.3v-.2h38.9c6.8 0 14.1 0 21.7-.1l8.6.1zm-41.3 24.6c1.3 0 2.2.9 2.2 2.1 0 1.2-.9 2.1-2.2 2.1h-1.7v-4.2h1.7zm-.8 3.4h.9c.7 0 1.2-.5 1.2-1.3s-.5-1.3-1.3-1.3h-.8v2.6zm4.6-3.3c0 .3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5zm-1 4.1v-3.2h.9v3.2h-.9zm4.8-1.3h-2.3c.1.4.4.6.8.6.3 0 .6-.1.8-.3l.5.5c-.3.4-.8.6-1.4.6-1 0-1.7-.7-1.7-1.6 0-1 .7-1.7 1.7-1.7 1.2 0 1.7.7 1.6 1.9zm-.8-.6c0-.4-.3-.7-.7-.7-.4 0-.7.3-.8.7h1.5zm3.8-1-.3.6c-.4-.2-.7-.3-1-.3-.2 0-.4.1-.4.2 0 .5 1.7.2 1.7 1.4 0 .7-.6 1-1.3 1-.5 0-1-.2-1.4-.5l.3-.6c.3.3.8.4 1.1.4.2 0 .4-.1.4-.3 0-.5-1.7-.2-1.7-1.4 0-.7.6-1 1.3-1 .5.1.9.3 1.3.5zm3.6 1.6h-2.3c.1.4.4.6.8.6.3 0 .6-.1.8-.3l.5.5c-.3.4-.8.6-1.4.6-1 0-1.7-.7-1.7-1.6 0-1 .7-1.7 1.7-1.7 1.1 0 1.7.7 1.6 1.9zm-.9-.6c0-.4-.3-.7-.7-.7-.4 0-.7.3-.8.7h1.5zm1.5 1.9v-4.4h.9v4.4h-.9zm-3.9-15.2c-.1-.1-.3-.1-.4 0-.2.3-.5.6-.7.9 0 .1-.1.2-.1.2v2.9h-.3v-4.9c0-.2 0-.4-.2-.6-.1-.2-.3-.2-.5-.3h-4.4c-.1 0-.3.1-.4.2-.2.2-.3.4-.3.7v6.6h-.2c-.2 0-.3 0-.4.3v1.1c.1.2.1.3.4.3h6.2c.2 0 .3-.1.3-.3v-.9c0-.2-.1-.3-.3-.3h-.2v-1c0-.1 0-.1.1-.1h.5c.1 0 .1 0 .2-.1.1 0 .1-.1.1-.2v-2.5h.2c.2 0 .3-.1.3-.3v-1c0-.1 0-.1.1-.2s.1-.2.2-.2c-.1 0-.1-.2-.2-.3z"
            />
            <path
              className="st13"
              d="M1621 832h-3.1c-.2 0-.3.1-.3.3v1.8c0 .2.1.3.3.3h3.1c.2 0 .3-.1.3-.3v-1.8c0-.2 0-.3-.3-.3zm-2.7 3.5h-.3c-.2 0-.3-.1-.3-.3 0-.1.1-.3.3-.3h.7c.2 0 .3.1.3.3 0 .1-.1.3-.3.3h-.4z"
              id="NCkLls.tif_1_"
            />
            <path
              className="st4"
              d="M1622.4 838.3c0 .1-1.3.1-3 .1s-3 0-3-.1 1.3-.1 3-.1 3 .1 3 .1z"
            />
            <path className="st12" d="M1777.5 873.5h2.2v3.2h-2.2z" />
            <path className="st2" d="M1766.8 882.5h14.7v11.4h-14.7z" />
            <path className="st4" d="M1748.4 823.4h35.4v34.3h-35.4z" />
            <path
              className="st40"
              d="M1764.3 871.7v47.5h19.5v-47.5h-19.5zm2.7 1.8h14.1v20H1767v-20z"
            />
            <path className="st32" d="M1766.9 893.5h4.8v9.6h-4.8z" />
            <path className="st40" d="M1748.5 919.1h-7.9v-97.8h7.9z" />
            <path
              className="st12"
              d="M1748.5 919.1v-97.8l.1.1h-7.8l.1-.1c0 44.2-.1 82.1-.1 97.7 2.6 0 4.4 0 5.8.1h1.9-7.8c0-15.6 0-53.5-.1-97.7v-.1h8v97.5c-.1.2-.1.3-.1.3z"
            />
            <path className="st40" d="M1783.7 819.7h7.9v99.4h-7.9z" />
            <path
              className="st12"
              d="M1791.6 919.1v-99.3l.1.1h-7.9l.1-.1c0 45.1-.1 83.7-.1 99.4h7.4c.2-.1.4-.1.4-.1h-7.9c0-15.7 0-54.3-.1-99.4v-.1h8.1v99c-.1.4-.1.5-.1.5zm-23-45.6h2.2v3.2h-2.2zm4.4 0h2.2v3.2h-2.2z"
            />
            <path className="st40" d="M1748.5 901.9h15.8v17.2h-15.8z" />
            <path className="st40" d="M1752.5 871.7h11.7V902h-11.7z" />
            <path className="st12" d="M1768.1 895.1h2.3v8h-2.3z" />
            <path
              className="st40"
              d="M1769.6 898.6h-.7v-2.5c0-.2.2-.4.4-.4s.4.2.4.4v2.5h-.1z"
            />
            <path className="st46" d="M1766.2 919.1v-12.6h14.8v12.3" />
            <path
              className="st12"
              d="M1767.2 917.3c-1.2 0-2.1-.8-2.1-1.8v-8.8c0-2.4 1.5-10.3 2.7-16.1.4-2.1.8-3.9 1-5s.5-3.7.8-9.3c0-.4 0-.5.2-.5v.2h.2v.3c-.3 5.7-.6 8.3-.8 9.4-.2 1.2-.6 3-1 5-1.1 5.7-2.7 13.6-2.7 16v8.8c0 .8.8 1.4 1.7 1.4.5 0 1-.2 1.3-.5s.4-.6.4-.9v-12.8h.4v12.8c0 .5-.2.9-.5 1.3-.4.2-1 .5-1.6.5z"
            />
            <path className="st32" d="M1754.1 875.9h8.6v6.4h-8.6z" />
            <path
              className="st12"
              d="M1755 876.6h6.8v5h-6.8zm3.4 9.1s0-.5-.1-1.1l.1.1h-4c0-.1-.1.1.1-.1v1.1l-.1-.1c1.1 0 2.1 0 2.9.1h1.1s-.4 0-1.1.1h-3v-1.2l.1-.1h4.1v.1c-.1.7-.1 1.1-.1 1.1z"
            />
            <path className="st4" d="M1768.6 898.6h1.3v5.2h-1.3z" />
            <path className="st32" d="M1771.4 893.5h4.8v9.6h-4.8z" />
            <path className="st12" d="M1772.6 895.1h2.3v8h-2.3z" />
            <path
              className="st40"
              d="M1774.1 898.6h-.7v-2.5c0-.2.2-.4.4-.4s.4.2.4.4v2.5h-.1z"
            />
            <path
              className="st12"
              d="M1771.7 917.3c-1.1 0-1.5-.2-1.5-1.2v-8.8c0-2.4 1.5-10.3 2.7-16.1.4-2.1.8-3.9 1-5 .4-2.2.3-7.2.3-10 0-.3 0-.3.1-.4l.2.2v.2-.2h.2v.2c.1 2.8.1 7.8-.3 10.1-.2 1.2-.6 3-1 5.1-1.1 5.7-2.7 13.6-2.7 16v8.8c0 .7.1.8 1.1.8.5 0 1-.2 1.3-.5s.4-.6.4-.9v-12.8h.4v12.8c0 .5-.2.9-.5 1.3-.5.1-1.1.4-1.7.4z"
            />
            <path
              className="st32"
              d="M1773.1 898.6h1.3v5.2h-1.3zm2.8-5.1h4.8v9.6h-4.8z"
            />
            <path className="st12" d="M1777.1 895.1h2.3v8h-2.3z" />
            <path
              className="st40"
              d="M1778.6 898.6h-.7v-2.5c0-.2.2-.4.4-.4s.4.2.4.4v2.5h-.1z"
            />
            <path className="st32" d="M1776.4 884h3.6v3.6h-3.6z" />
            <path
              className="st12"
              d="M1774.7 885.1c0 .1-1.4.1-3.2.1-1.8 0-3.2-.1-3.2-.1 0-.1 1.4-.1 3.2-.1 1.8-.1 3.2 0 3.2.1zm0 .8c0 .1-1.4.1-3.2.1-1.8 0-3.2-.1-3.2-.1 0-.1 1.4-.1 3.2-.1s3.2 0 3.2.1zm0 .8c0 .1-1.4.1-3.2.1-1.8 0-3.2-.1-3.2-.1 0-.1 1.4-.1 3.2-.1s3.2.1 3.2.1zm1.9 30.6h-.4c-1-.2-1.7-.9-1.7-1.8v-8.8c0-2.4 1.5-10.3 2.7-16.1.4-2.1.8-3.9 1-5 .3-1.6.4-5 .4-9.4 0-.3 0-.3.1-.4l.2.2v.2-.2h.2v.2c0 4.5-.1 7.8-.4 9.5-.2 1.2-.6 3-1 5-1.1 5.7-2.7 13.6-2.7 16v8.8c0 .7.7 1.3 1.5 1.4.4 0 .8-.2 1.1-.5.3-.3.4-.6.4-.9v-12.8h.4v12.8c0 .5-.2.9-.5 1.3-.5.1-.9.4-1.3.5zm-12.3-45.8c.1 0 .1 10.6.1 23.6s-.1 23.6-.1 23.6-.1-10.6-.1-23.6c-.1-13.1 0-23.6.1-23.6zm-9.3 5.2s-.3-.1-.5-.3c-.3-.2-.4-.4-.4-.5 0 0 .3.1.5.3.3.2.5.4.4.5zm7.8-.8s-.2.3-.5.6-.6.4-.6.4.2-.3.5-.6c.2-.3.5-.4.6-.4zm-1 5.7s.3.1.5.3c.3.2.4.4.4.5 0 0-.3-.1-.5-.3-.3-.3-.5-.5-.4-.5zm-7.8.7s.2-.3.5-.6.6-.4.6-.4-.2.3-.5.6c-.2.3-.5.5-.6.4zm50.9 36.8c0 .1-16.6.1-37.1.1s-37.1-.1-37.1-.1c0-.1 16.6-.1 37.1-.1s37.1 0 37.1.1z"
            />
            <path className="st2" d="M1777.6 898.6h1.3v5.2h-1.3z" />
            <path className="st40" d="M1731.2 814.2h69.1v4.9h-69.1z" />
            <path
              className="st12"
              d="M1731.2 814.2h69.2v5.1h-.1c-31.7 0-58.8-.1-69.1-.1v-5 4.9c10.3 0 37.4 0 69.1-.1l-.1.1v-4.9l.1.1h-68.7c-.3-.1-.4-.1-.4-.1z"
            />
            <path className="st40" d="m1739.9 823.6-8.7-4.5h69.2l-8.7 4.5z" />
            <path
              className="st12"
              d="M1739.9 823.6h51.8c2.8-1.4 5.7-2.9 8.6-4.4l.1.2h-8.6c-25.9 0-48.6 0-60.5-.1v-.1c2.8 1.4 4.9 2.5 6.4 3.3.7.4 1.3.7 1.7.9.2.1.3.2.5.2-.1-.1 0 0 0 0-.2-.1-.3-.2-.5-.3-.4-.2-.9-.5-1.7-.8-1.5-.7-3.6-1.8-6.4-3.3l-.2-.1h.2c11.9 0 34.5 0 60.5-.1h9.1l-.4.2c-3 1.5-5.9 3-8.6 4.4h-52zm19.3 20.2c1.1 0 1.7.5 1.7 1.5s-.6 1.5-1.7 1.5h-.8v1.2h-.9v-4.2h1.7zm-.9 2.2h.8c.5 0 .8-.2.8-.7s-.3-.7-.8-.7h-.8v1.4zm6.1.6h-2.3c.1.4.4.6.8.6.3 0 .6-.1.8-.3l.5.5c-.3.4-.8.6-1.4.6-1 0-1.7-.7-1.7-1.6 0-1 .7-1.7 1.7-1.7 1.2 0 1.7.7 1.6 1.9zm-.9-.5c0-.4-.3-.7-.7-.7-.4 0-.7.3-.8.7h1.5zm3.5 1.7c-.2.1-.5.2-.8.2-.6 0-1-.3-1-1v-1.5h-.5v-.6h.5v-.9h.9v.9h.9v.6h-.9v1.3c0 .3.1.4.3.4.1 0 .3 0 .4-.1l.2.7zm1.5-2.5c.2-.4.6-.6 1.1-.6v.9c-.7-.1-1.1.3-1.1.8v1.6h-.9v-3.2h.9v.5zm4.8 1c0 1-.7 1.6-1.7 1.6s-1.7-.7-1.7-1.6c0-1 .7-1.6 1.7-1.6s1.7.7 1.7 1.6zm-2.6.1c0 .5.3.9.8.9s.8-.4.8-.9-.3-.9-.8-.9-.8.3-.8.9zm3.2 1.6v-4.4h.9v4.4h-.9zm-3.9-15.4c-.1-.1-.3-.1-.4 0-.2.3-.5.6-.7.9-.1.1-.1.2-.1.2v2.9h-.3v-4.9c0-.2-.1-.4-.2-.6-.1-.2-.3-.2-.5-.3h-4.4c-.1 0-.3.1-.4.2-.2.2-.3.4-.3.7v6.6h-.2c-.2 0-.3 0-.4.3v1.1c.1.2.1.3.4.3h6.2c.2 0 .3-.1.3-.3v-.9c0-.2-.1-.3-.3-.3h-.2v-1c0-.1 0-.1.1-.1h.5c.2 0 .3-.1.3-.3v-2.5h.2c.2 0 .3-.1.3-.3v-1c0-.1 0-.1.1-.2s0-.2.1-.2c-.1 0 0-.2-.1-.3z"
            />
            <path
              className="st13"
              d="M1767.1 832h-3.1c-.2 0-.3.1-.3.3v1.8c0 .2.1.3.3.3h3.1c.2 0 .3-.1.3-.3v-1.8c0-.2-.1-.3-.3-.3zm-2.8 3.5h-.3c-.2 0-.3-.1-.3-.3 0-.1.1-.3.3-.3h.7c.2 0 .3.1.3.3 0 .1-.1.3-.3.3h-.4z"
              id="NCkLls.tif_2_"
            />
            <path
              className="st4"
              d="M1768.6 838.3c0 .1-1.3.1-3 .1s-3 0-3-.1 1.3-.1 3-.1 3 .1 3 .1z"
            />
          </g>
          <g id="house">
            <linearGradient
              id="SVGID_13_"
              gradientUnits="userSpaceOnUse"
              x1={1326.064}
              y1={3089.271}
              x2={1335.263}
              y2={3119.81}
              gradientTransform="translate(0 -2174)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              style={{
                opacity: 0.1,
                fill: "url(#SVGID_13_)",
                enableBackground: "new",
              }}
              d="m1269.9 922.4 26.2 22.5h97.2l-30.9-22.5z"
            />
            <path className="st1" d="M1269.9 822.4h92.5v100h-92.5z" />
            <path
              d="M1289.4 852.6h-10.1c-.1 0-.3-.1-.3-.2v-13.9c0-.1.1-.2.3-.2h10.1c.1 0 .2.1.2.2v13.9c0 .1-.1.2-.2.2zm21.4 0h-10.1c-.1 0-.3-.1-.3-.2v-13.9c0-.1.1-.2.3-.2h10.1c.1 0 .2.1.2.2v13.9c0 .1-.1.2-.2.2zm21.4 0h-10.1c-.1 0-.2-.1-.2-.2v-13.9c0-.1.1-.2.2-.2h10.1c.1 0 .3.1.3.2v13.9c0 .1-.2.2-.3.2zm21.4 0h-10.1c-.1 0-.2-.1-.2-.2v-13.9c0-.1.1-.2.2-.2h10.1c.1 0 .2.1.2.2v13.9c.1.1 0 .2-.2.2zm-64.2 24.5h-10.1c-.1 0-.3-.1-.3-.2V863c0-.1.1-.2.3-.2h10.1c.1 0 .2.1.2.2v13.9c0 .1-.1.2-.2.2zm21.4 0h-10.1c-.1 0-.3-.1-.3-.2V863c0-.1.1-.2.3-.2h10.1c.1 0 .2.1.2.2v13.9c0 .1-.1.2-.2.2zm21.4 0h-10.1c-.1 0-.2-.1-.2-.2V863c0-.1.1-.2.2-.2h10.1c.1 0 .3.1.3.2v13.9c0 .1-.2.2-.3.2zm21.4 0h-10.1c-.1 0-.2-.1-.2-.2V863c0-.1.1-.2.2-.2h10.1c.1 0 .2.1.2.2v13.9c.1.1 0 .2-.2.2zm-64.2 24.5h-10.1c-.1 0-.3-.1-.3-.2v-13.9c0-.1.1-.2.3-.2h10.1c.1 0 .2.1.2.2v13.9c0 .1-.1.2-.2.2zm64.2 0h-10.1c-.1 0-.2-.1-.2-.2v-13.9c0-.1.1-.2.2-.2h10.1c.1 0 .2.1.2.2v13.9c.1.1 0 .2-.2.2z"
              style={{
                stroke: "#fff",
                strokeWidth: 1.0002,
                strokeMiterlimit: 10,
                fill: "none",
              }}
            />
            <path className="st13" d="M1304.3 899.5h23.3v24.2h-23.3z" />
            <path
              style={{
                fill: "#999fa7",
              }}
              d="M1315.3 899.5h1.5v24.2h-1.5z"
            />
            <path
              className="st10"
              d="M1301.1 899.5c0-8.3 6.7-15 15-15s15 6.7 15 15h-30z"
            />
            <g id="grass_1_">
              <path
                className="st50"
                d="M1287 922.4h-76.7s1.8-12.2 14.1-5c0 0 .6-1.1 1.7-2.6.1-.2.3-.3.4-.5 1.6-1.9 4.1-4.1 7.4-5.2.2-.1.5-.2.8-.2 4.2-1.1 9.7-.5 16.5 4.7 0 0 3.7-1.8 8-1.3.2 0 .4 0 .6.1 2.4.4 4.9 1.4 7.2 3.8 0 0 2.6-1.7 6.2-2 .2 0 .5 0 .7-.1 2.6-.1 5.6.5 8.5 2.8.2.1.3.3.5.4 1.5 1.2 2.9 2.9 4.1 5.1z"
              />
              <path
                className="st51"
                d="M1234.6 922.4h-.8c-1.1-1.4-4.4-5.5-7.6-7.6.1-.2.3-.3.4-.5 3.7 2.5 7.4 7.4 8 8.1zm7.7 0h-.6c-.4-1.9-2.5-9.8-7.6-13.3.2-.1.5-.2.8-.2 5.1 3.8 7 11.8 7.4 13.5zm17.7-10.1-2.8 10.1h-.7l2.8-10.2c.2.1.5.1.7.1zm14 1.7-3.2 8.4h-.7l3.2-8.3c.3 0 .5 0 .7-.1zm9 3.3-4.8 5.2h-.9l5.1-5.6c.3.1.4.2.6.4z"
              />
            </g>
          </g>
          <g id="tent">
            <linearGradient
              id="SVGID_14_"
              gradientUnits="userSpaceOnUse"
              x1={673.85}
              y1={3097.113}
              x2={673.85}
              y2={3118.199}
              gradientTransform="translate(0 -2174)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              style={{
                opacity: 0.2,
                fill: "url(#SVGID_14_)",
                enableBackground: "new",
              }}
              d="m735.6 923-26.2 22.5h-97.3l29.8-22.5z"
            />
            <path
              className="st53"
              d="M690.9 841.9v-3.1c1.1-.4 1.9-1.5 1.9-2.8 0-1.7-1.4-3-3-3-1.7 0-3 1.4-3 3 0 1.3.8 2.3 1.9 2.8v3.2c-27.1 27.1-59.7 32.6-59.7 32.6v2h12.9v46.5h93.7v-46.5h15v-2c-39.9-9-59.7-32.7-59.7-32.7z"
            />
            <path
              className="st54"
              d="M706.8 873.4h-35c-.6 0-1-.4-1-1v-10c0-.6.4-1 1-1h35c.6 0 1 .4 1 1v10c0 .5-.5 1-1 1zm22 21.1h-79"
            />
            <path
              style={{
                opacity: 0.5,
                fill: "none",
                stroke: "#fff",
                strokeWidth: 0.9873,
                strokeMiterlimit: 10,
                enableBackground: "new",
              }}
              d="M688.7 884v38.5"
            />
            <path
              className="st54"
              d="M729.3 922.6h-80v-37.1c0-1.1.9-2 2-2h76c1.1 0 2 .9 2 2v37.1z"
            />
            <g id="grass_2_">
              <path
                className="st3"
                d="M762.9 923.1h-42.7s2.4-6.1 6.9-10.2c.1-.1.3-.3.5-.4 3-2.6 6.9-4.2 11.6-2.9.2.1.4.1.6.2 2.7.9 5.6 2.8 8.8 6.1 0 0 3.7-1.4 7.5-.4.2.1.4.1.6.2 2.4.9 4.8 3 6.2 7.4z"
              />
              <path
                d="m756.6 915.7-5.9 7.4h-.7l6-7.6c.2.1.4.1.6.2zm-16.5 7.4h-.6l-.3-13.5c.2.1.4.1.6.2l.3 13.3zm-6.8 0h-.7l-5.5-10.2c.1-.1.3-.3.5-.4l5.7 10.6z"
                style={{
                  fill: "#b9bec3",
                }}
              />
            </g>
          </g>
          <g id="reckshaw">
            <linearGradient
              id="shadow_x5F_2_3_"
              gradientUnits="userSpaceOnUse"
              x1={1890.286}
              y1={-6173.335}
              x2={1882.615}
              y2={-6195.534}
              gradientTransform="matrix(1 0 0 -1 0 -5220)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              id="shadow_x5F_2_1_"
              style={{
                opacity: 0.2,
                fill: "url(#shadow_x5F_2_3_)",
                enableBackground: "new",
              }}
              d="M1872.6 954h46.3l-12.7 23-52.9-.1z"
            />
            <circle className="st3" cx={1877.9} cy={949.3} r={6.3} />
            <path
              className="st44"
              d="M1920 916.5v30.6c0 2.4-1.9 4.1-4.1 4.1h-26.6c-.4 0-.9-.1-1.3-.3l-2.4-1.4h-16.3c0-4.5 3.8-9.2 8.3-9.2 1.9 0 3.8.9 5.1 2.1l-4.4-7.3c-.5-.9-.9-1.9-.9-3v-2.3c0-1.3.4-2.4 1.1-3.3l6.4-9.1.5-.9 2.2-3c.6-.9 1.6-1.4 2.7-1.4h25.6c2.3.2 4.1 2.1 4.1 4.4z"
            />
            <path
              className="st45"
              d="M1915.1 922.1c0-2.4-1.9-4.1-4.1-4.1h-11.7c-2.4 0-4.1 1.9-4.1 4.1V942c0 2.4 1.9 4.1 4.1 4.1 2.4 0 4.1-1.9 4.1-4.1v-7.4c0-2.4 1.9-4.1 4.1-4.1h3.3c2.4 0 4.1-1.9 4.1-4.1l.2-4.3zm-23.5-1.9v7.1c0 1.5-1.2 2.7-2.7 2.7h-11.6v-.1c0-1.3.4-2.4 1.1-3.3l6.4-9.1h4.1c1.6.1 2.7 1.2 2.7 2.7z"
            />
            <circle className="st3" cx={1910.3} cy={950.9} r={6.3} />
          </g>
          <g id="car">
            <linearGradient
              id="shadow_x5F_2_4_"
              gradientUnits="userSpaceOnUse"
              x1={18033.264}
              y1={-6185.754}
              x2={18020.389}
              y2={-6223.009}
              gradientTransform="rotate(180 9948.6 -2610)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              id="shadow_x5F_2_2_"
              style={{
                opacity: 0.2,
                fill: "url(#shadow_x5F_2_4_)",
                enableBackground: "new",
              }}
              d="M1895.9 964.7h-74l23.4 43 74.7-.3z"
            />
            <path
              className="st4"
              d="M1820 960.2c0-7.4 6.1-13.5 13.5-13.5h65.4v13.5c0 1.6-1.3 3.1-3.1 3.1h-72.7c-1.8 0-3.1-1.5-3.1-3.1z"
            />
            <path className="st3" d="m1839.1 946.7 13.5-19h33.9l12.4 19z" />
            <path className="st4" d="M1863.9 927.7h12.7v23.5h-12.7z" />
            <path className="st34" d="M1854.5 950.8h9.4v.9h-9.4z" />
            <circle className="st3" cx={1834.6} cy={962.8} r={6.2} />
            <circle className="st3" cx={1880.8} cy={962.8} r={6.2} />
          </g>
          <g id="bus">
            <linearGradient
              id="SVGID_15_"
              gradientUnits="userSpaceOnUse"
              x1={8902.293}
              y1={3144.728}
              x2={8902.293}
              y2={3181.561}
              gradientTransform="matrix(-1 0 0 1 8969.693 -2174)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              style={{
                opacity: 0.2,
                fill: "url(#SVGID_15_)",
                enableBackground: "new",
              }}
              d="M134.8 973.1H25.4L0 1010.8h112z"
            />
            <path
              className="st3"
              d="M23.4 926.3v34.9c0 3.2 2.6 5.9 5.8 6h99.4c3.2-.1 5.8-2.8 5.8-6v-13.5c0-.9-.1-1.7-.3-2.5-.2-.8-.5-1.5-.9-2.2l-8.5-15.8-.5-.8c-1.1-1.9-3.1-3.2-5.3-3.2H26.3c-1.6 0-2.9 1.4-2.9 3.1z"
            />
            <path
              d="M23.4 926.3v4.1h103l-1.7-3.2-.5-.8c-1.1-1.9-3.1-3.2-5.3-3.2H26.3c-1.6 0-2.9 1.4-2.9 3.1z"
              style={{
                fill: "#dadce0",
              }}
            />
            <path
              className="st45"
              d="M68.4 962.4h18.3c1.7 0 3-1.3 3-3v-32.2H65.4v32.2c0 1.7 1.4 3 3 3zm-15.9-35.2h12v18h-12z"
            />
            <path className="st3" d="M51.5 927.2h1v18h-1z" />
            <path className="st45" d="M39.4 927.2h12v18h-12z" />
            <path className="st3" d="M38.4 927.2h1v18h-1z" />
            <path className="st45" d="M23.3 927.2h15.1v18H23.3z" />
            <path className="st3" d="M77 927.2h1v35.2h-1zm-12.5 0h1v35.2h-1z" />
            <path className="st45" d="M90.7 927.2h12v18h-12z" />
            <path className="st3" d="M89.7 927.2h1v34.6h-1zm13 0h1v18h-1z" />
            <path
              className="st45"
              d="M103.7 927.2h12v18h-12zm13 0v18H134c-.2-.8-.5-1.5-.9-2.2l-8.5-15.8h-7.9z"
            />
            <path className="st3" d="M115.7 927.2h1v18h-1z" />
            <path
              className="st45"
              d="M23.4 952.2v6h1c1.6 0 3-1.3 3-3 0-1.6-1.3-3-3-3h-1zm108.8 6h2.2v-9h-2.2c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1z"
            />
            <circle className="st61" cx={111.8} cy={966.7} r={8.5} />
            <circle className="st61" cx={44.8} cy={966.7} r={8.5} />
          </g>
          <g id="blue_x5F_car">
            <path
              className="st3"
              d="M1004.1 997.1s-.6-3.7 3.4-2.7c4 .9 5.3.8 5.2 4.7-.1 1.7-9.3.9-9.3.9l-1.7-2.8 2.4-.1z"
            />
            <path
              className="st4"
              d="M1012.3 998.5v.5c-.1 0-.2.2-1.3.4-.6.1-1.6.2-3 .2h-.1c-1.7 0-3.5-.1-4.1-.2l-.2-.4-.3-.5-.5-.9 1.9-.1h.2v-.1l-.1-.5s-.2-1.1.4-1.7c.2-.4.7-.5 1.3-.5.3 0 .7 0 1 .1l.7.1.4.1c.7.2 1.2.3 1.7.4 1 .3 1.5.6 1.7 1.3.2.5.3 1 .3 1.8z"
            />
            <path
              className="st3"
              d="M951.3 997.1s.6-3.7-3.4-2.7c-4 .9-5.3.8-5.2 4.7.1 1.7 9.3.9 9.3.9l1.7-2.8-2.4-.1z"
            />
            <path
              className="st4"
              d="m952.7 997.7-1.1 1.8c-.6.1-2.3.2-4.1.2-2 0-3-.1-3.7-.3-.6-.2-.7-.3-.7-.4-.1-2.4.3-3.1 2.1-3.6.5-.1 1-.3 1.7-.4l.3-.1.7-.1c.4-.1.8-.1 1.1-.1.6 0 1 .2 1.3.5.6.7.4 1.8.4 1.8l-.1.4v.2h.2l1.9.1z"
            />
            <linearGradient
              id="SVGID_2_"
              gradientUnits="userSpaceOnUse"
              x1={1007.965}
              y1={3172.25}
              x2={1012.285}
              y2={3172.25}
              gradientTransform="translate(0 -2174)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
            </linearGradient>
            <path
              d="m1012.3 998.5-1.3 1c-.6.1-1.6.2-3 .2l4-2.9c.2.4.3.9.3 1.7z"
              style={{
                opacity: 0.3,
                fill: "url(#SVGID_2_)",
                enableBackground: "new",
              }}
            />
            <linearGradient
              id="SVGID_3_"
              gradientUnits="userSpaceOnUse"
              x1={1003.494}
              y1={2088.9}
              x2={1010.235}
              y2={2088.9}
              gradientTransform="translate(0 -1092)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
            </linearGradient>
            <path
              d="m1010.2 995.4-4.8 3.5h-1.7l-.3-.5 1.2-.9.1-.1.1-.1h.1l3.2-2.4.4.1c.8.2 1.3.3 1.7.4z"
              style={{
                opacity: 0.3,
                fill: "url(#SVGID_3_)",
                enableBackground: "new",
              }}
            />
            <linearGradient
              id="SVGID_4_"
              gradientUnits="userSpaceOnUse"
              x1={943.131}
              y1={3172.15}
              x2={947.451}
              y2={3172.15}
              gradientTransform="translate(0 -2174)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              d="m943.1 998.5 1.3 1c.6.1 1.6.2 3 .2l-4-3.1c-.2.4-.3 1.1-.3 1.9z"
              style={{
                opacity: 0.3,
                fill: "url(#SVGID_4_)",
                enableBackground: "new",
              }}
            />
            <linearGradient
              id="SVGID_5_"
              gradientUnits="userSpaceOnUse"
              x1={945.2}
              y1={2089}
              x2={951.961}
              y2={2089}
              gradientTransform="translate(0 -1092)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              d="m952 998.5-.3.5H950l-4.8-3.5c.5-.1 1-.3 1.7-.4l.3-.1 3.2 2.4.2.1.2.1 1.2.9z"
              style={{
                opacity: 0.3,
                fill: "url(#SVGID_5_)",
                enableBackground: "new",
              }}
            />
            <path
              className="st3"
              d="M948.5 1045h-5.2c-1.3 0-2.3-1-2.3-2.3v-15.2c0-1.3 1-2.3 2.3-2.3h5.2c1.3 0 2.3 1 2.3 2.3v15.2c0 1.3-1 2.3-2.3 2.3zm63.6 0h-5.2c-1.3 0-2.3-1-2.3-2.3v-15.2c0-1.3 1-2.3 2.3-2.3h5.2c1.3 0 2.3 1 2.3 2.3v15.2c0 1.3-1 2.3-2.3 2.3z"
            />
            <path
              className="st9"
              d="M998.3 1035.8H957c-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6h41.3c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6z"
            />
            <path
              className="st3"
              d="m942.2 1013 10.8-25.8c.5-1.3 1.8-2.2 3.3-2.2h42.1c1.4 0 2.6.8 3.2 2.1l11.6 25.8-71 .1z"
            />
            <path
              className="st4"
              d="M1013.2 1013v19.8c0 2.4-1.9 4.6-4.6 4.6h-7c-1.3 0-2.4-1.1-2.4-2.4 0-1.3-1.1-2.4-2.4-2.4h-38.4c-1.3 0-2.4 1.1-2.4 2.4 0 1.3-1.1 2.4-2.4 2.4h-7c-2.6 0-4.6-2.2-4.6-4.6V1013h71.2z"
            />
            <path
              className="st9"
              d="M999.4 1004.3H956c-.6 0-1-.4-1.1-.9v-.2c0-.2 0-.4.2-.6l.7-1.4 4.8-9.3c.8-1.2 2.2-1.9 3.6-1.9h27c1.4 0 2.8.7 3.6 1.9l.4.7.5 1 .8 1.5 2 4 .1.1.7 1.4 1 2c.5.7 0 1.7-.9 1.7z"
            />
            <path
              className="st10"
              d="M956.9 1021h-9.6c-.4 0-.7-.3-.7-.7v-3.7c0-.4.3-.7.7-.7h9.6c.4 0 .7.3.7.7v3.7c.1.3-.2.7-.7.7zm51.2 0h-9.6c-.4 0-.7-.3-.7-.7v-3.7c0-.4.3-.7.7-.7h9.6c.4 0 .7.3.7.7v3.7c0 .3-.3.7-.7.7z"
            />
            <g id="number_x5F_plate_4_">
              <g className="st11">
                <path
                  className="st12"
                  d="M984.8 1021.8v5.2c0 .6-.5 1.1-1.1 1.1h-13.2c-.6 0-1.1-.5-1.1-1.1v-5.2c0-.6.5-1.1 1.1-1.1h13.2c.6 0 1.1.5 1.1 1.1z"
                />
              </g>
              <path
                className="st3"
                d="M984.8 1021.6v5.2c0 .6-.5 1.1-1.1 1.1h-13.2c-.6 0-1.1-.5-1.1-1.1v-5.2c0-.6.5-1.1 1.1-1.1h13.2c.6 0 1.1.5 1.1 1.1z"
              />
              <path
                className="st13"
                d="M983.6 1027.7h-13c-.5 0-.9-.4-.9-.9v-5.1c0-.5.4-.9.9-.9h13c.5 0 .9.4.9.9v5.1c0 .5-.4.9-.9.9zm-13.1-6.7c-.4 0-.7.3-.7.7v5.1c0 .4.3.7.7.7h13c.4 0 .7-.3.7-.7v-5.1c0-.4-.3-.7-.7-.7h-13z"
              />
              <path
                className="st13"
                d="m973.9 1023.3-.1.3h-.4l.7-1.7h.4l.7 1.7h-.4l-.1-.3h-.8zm.4-.9-.3.6h.5l-.2-.6zm1.9-.4c.4 0 .6.2.6.4s-.1.3-.3.4c.2 0 .3.2.3.4 0 .3-.2.5-.6.5h-.8v-1.7h.8zm-.4.7h.4c.1 0 .2-.1.2-.2s-.1-.2-.2-.2h-.4v.4zm0 .7h.4c.2 0 .3-.1.3-.2s-.1-.2-.3-.2h-.4v.4zm3.2-.6c0 .5-.3.8-.7.8-.5 0-.7-.3-.7-.8s.3-.8.7-.8c.5 0 .7.3.7.8zm-1 0c0 .4.1.6.3.6s.3-.2.3-.6c0-.4-.1-.6-.3-.6-.2.1-.3.2-.3.6zm2.7 0c0 .5-.3.8-.7.8-.5 0-.7-.3-.7-.8s.3-.8.7-.8.7.3.7.8zm-1.1 0c0 .4.1.6.3.6s.3-.2.3-.6c0-.4-.1-.6-.3-.6-.2.1-.3.2-.3.6zm-6.8 2-.3.3c-.1-.2-.3-.2-.5-.2-.3 0-.6.3-.6.6s.3.6.6.6c.2 0 .4-.1.5-.2l.3.3c-.2.2-.5.3-.8.3-.6 0-1-.4-1-1s.4-1 1-1c.3 0 .6.1.8.3zm1.1-.3c.6 0 1 .4 1 1s-.4 1-1 1h-.9v-1.9l.9-.1zm-.4 1.6h.4c.3 0 .6-.2.6-.6 0-.4-.2-.6-.6-.6h-.4v1.2zm3.9-.6c0 .6-.3 1-.8 1s-.8-.3-.8-1c0-.6.3-1 .8-1s.8.4.8 1zm-1.2 0c0 .5.1.6.4.6.3 0 .4-.2.4-.6 0-.4-.1-.6-.4-.6-.3 0-.4.1-.4.6zm3.1 0c0 .6-.3 1-.8 1s-.8-.3-.8-1c0-.6.3-1 .8-1s.8.4.8 1zm-1.2 0c0 .5.1.6.4.6.3 0 .4-.2.4-.6 0-.4-.1-.6-.4-.6-.3 0-.4.1-.4.6zm3.1 0c0 .6-.3 1-.8 1s-.8-.3-.8-1c0-.6.3-1 .8-1s.8.4.8 1zm-1.2 0c0 .5.1.6.4.6.3 0 .4-.2.4-.6 0-.4-.1-.6-.4-.6-.3 0-.4.1-.4.6zm3.1 0c0 .6-.3 1-.8 1s-.8-.3-.8-1c0-.6.3-1 .8-1s.8.4.8 1zm-1.2 0c0 .5.1.6.4.6.3 0 .4-.2.4-.6 0-.4-.1-.6-.4-.6-.3 0-.4.1-.4.6z"
              />
            </g>
            <g
              style={{
                opacity: 0.7,
              }}
            >
              <path
                d="m970.7 990-13.4 10-1.5 1.2 4.8-9.3c.8-1.2 2.2-1.9 3.6-1.9h6.5zm4.9 0-19.2 14.2-.1.1h-.3c-.6 0-1-.4-1.1-.9v-.2l2-1.5 15.9-11.7h2.8zm20.9 5.1-12.4 9.2h-2.8l14.4-10.7zm2.9 5.6-4.9 3.6h-2.8l6.9-5.1.7 1.4zm-4.2-8.1-15.7 11.7h-9.7l19.3-14.3h2.1c1.4 0 2.8.7 3.6 1.9l.4.7z"
                style={{
                  opacity: 0.2,
                  fill: "#fff",
                  enableBackground: "new",
                }}
              />
            </g>
          </g>
          <g id="rto_x5F_road">
            <path
              className="st16"
              d="M676.9 986.3v.2l6.3-3.6-.1-3h-.1s0 .1-.1.1l-.1.1s-.1 0-.1.1l-.4.2c-.1 0-.2.1-.3.2-.1.1-.2.1-.3.2-.2.1-.4.2-.7.4l-4 2.2c.1.4.1 1 .1 1.6-.1.4-.1.9-.2 1.3zm-79.6 45.9c-.1-.5-.1-1.5-.1-2.5v-2.1l-15.5 8.6-.1.1c0 .5.1 1.2.1 2v.4c0 1 0 1.4-.1 1.9v.2h.2l15.6-8.4c-.1 0-.1-.1-.1-.2zm47.6-27.4c0-.5-.1-1.2-.1-2.1v-1.6l-15.5 8.7v1.9c0 .8 0 1.5-.1 2v.2l15.6-9c.1 0 .1 0 .1-.1zm31.7-18.3c0-.4-.1-1-.1-1.6v-1.4l-15.5 8.6v3.5l15.6-9.1c.1.1 0 0 0 0zm-63.5 36.6c0-.6-.1-1.4-.1-2.3v-1.9l-15.6 8.7c0 .5.1 1.3.1 2.2 0 1 0 1.9-.1 2.4v.2l15.7-9.1c.1-.1.1-.1 0-.2zm15.9-9.2c0-.5-.1-1.3-.1-2.2v-1.8l-15.6 8.7c0 .5.1 1.3.1 2.1 0 .9 0 1.6-.1 2.2v.2l15.6-9c.1 0 .1-.1.1-.2zm31.7-18.2c0-.5-.1-1.2-.1-1.9v-1.4l-15.5 8.6v3.9l15.6-9c.1-.1 0-.2 0-.2z"
            />
            <path
              className="st1"
              d="M683.3 979.8v3.2h-.1c-33.9 19.5-64.4 37-86.4 49.7l-15.2 8.2-.1.1v-.3l.1-.1c4.4-2.6 9.5-4.9 15-8.1.2-.1.3-.2.5-.3.1 0 .1-.1.2-.1 4.8-2.8 10.1-5.8 15.7-9 .1-.1.2-.1.2-.1 4.9-2.8 10.2-5.9 15.6-9 .1 0 .2-.1.3-.2 5-2.9 10.2-5.9 15.6-9 .1 0 .2-.1.3-.2 5-2.9 10.2-5.9 15.5-9 .1-.1.2-.1.3-.2 5.1-2.9 10.3-5.9 15.6-9 .1-.1.2-.1.3-.2 2-1.1 4-2.3 6.1-3.5v-2.8h-.2s-.1 0-.1.1l-.4.2c-.1 0-.2.1-.3.2-.1.1-.2.1-.3.2-.2.1-.4.2-.7.4-.7.4-1.6.8-2.6 1.4-3.2 1.7-7.7 4.2-13.3 7.2-2.8 1.5-5.9 3.2-9.2 5s-6.8 3.8-10.5 5.9c-7.4 4.2-15.5 8.7-24 13.5-15 8.4-28.8 16.1-39.5 22.1l-.1.1v-.3l.1-.1c10.7-6 24.4-13.7 39.4-22.1 8.5-4.8 16.6-9.3 24-13.5 3.7-2.1 7.2-4 10.5-5.9 3.3-1.8 6.4-3.5 9.2-5 5.6-3 10.2-5.4 13.4-7.1 1.6-.8 2.8-1.5 3.7-1.9.4-.2.7-.4 1-.5l.1-.1H0v-.1h683.3v.2z"
            />
            <path className="st1" d="M0 980.2v-1l683.3.4-.5.3z" />
            <g className="st62">
              <path className="st63" d="M361.7 1038.4h12.5" />
              <path
                style={{
                  fill: "none",
                  stroke: "#1a2e35",
                  strokeWidth: 4,
                  strokeMiterlimit: 10,
                  strokeDasharray: "26.6393,1.0656",
                }}
                d="M375.3 1038.4h193.4"
              />
              <path className="st63" d="M569.2 1038.4h12.5" />
            </g>
            <path
              className="st1"
              d="M581.2 1036.4v4h-219v-4h219m.5-.5h-220v5h220v-5z"
            />
            <path
              style={{
                fill: "none",
                stroke: "#d6d7da",
                strokeWidth: 0.4,
                strokeMiterlimit: 10,
              }}
              d="M348.1 1065.5h264l136.2-85.6 164.3-.4"
            />
            <g className="st62">
              <path className="st66" d="M358.6 1050.8h25" />
              <path
                d="M431.9 1050.8h157.3c3.9 0 7.7-1.1 11.1-3l71.6-42.6"
                style={{
                  fill: "none",
                  stroke: "#1a2e35",
                  strokeWidth: 2,
                  strokeMiterlimit: 10,
                  strokeDasharray: "43.8645,48.251",
                }}
              />
              <path className="st66" d="M692.6 992.7 714 980" />
            </g>
          </g>
          <g id="green_x5F_tree_x5F_3">
            <path className="st30" d="M855.7 944.5h4.6v57.1h-4.6z" />
            <path
              className="st30"
              d="m858.03 965.254 5.937-19.413 2.2.673-5.937 19.412zm-14.457-26.464 1.852-1.364 13.34 18.12-1.852 1.363z"
            />
            <path
              className="st35"
              d="M891.9 907.7c-1.6-2.2-4.7-3.3-7.2-2.3 1.2-1.9 2.5-4 2.7-6.3.3-2.3-.8-4.9-2.9-5.7-1.2-.5-2.7-.3-3.8-.9-1.9-1.1-2-3.7-1.8-5.9.2-2.4.6-4.8.3-7.2s-1.3-4.8-3.2-6.2c-2.2-1.6-5.2-1.7-7.9-1.4-11.4 1.3-21.7 8.4-28.1 17.9-6.4 9.5-9.7 21-9.2 32.4.2 5.1 1.9 10.7 4.7 14.9 2.7 4 6.3 7.5 10.7 9.3 2.8 1.1 4.1 1.6 5.8 2 2.3.5 4.6.8 6.9.8h1.9c7.3-.3 12-3.6 17.5-8.4 5.4-4.8 8.9-11.2 12.3-17.7 1.3-2.4 2.4-4.9 2.9-7.6.4-2.6 0-5.5-1.6-7.7z"
            />
          </g>
          <g id="green_x5F_tree_x5F_2">
            <path className="st30" d="M1115.1 944.5h4.6v57.1h-4.6z" />
            <path
              className="st30"
              d="m1117.7 965.5 5.9-19.4 2.2.6-6.3 19.5zm-14.722-26.71 1.852-1.364 13.34 18.12-1.852 1.363z"
            />
            <path
              className="st35"
              d="M1151.2 907.7c-1.6-2.2-4.7-3.3-7.2-2.3 1.2-1.9 2.5-4 2.7-6.3.3-2.3-.8-4.9-2.9-5.7-1.2-.5-2.7-.3-3.8-.9-1.9-1.1-2-3.7-1.8-5.9.2-2.4.6-4.8.3-7.2s-1.3-4.8-3.2-6.2c-2.2-1.6-5.2-1.7-7.9-1.4-11.4 1.3-21.7 8.4-28.1 17.9s-9.7 21-9.2 32.4c.2 5.1 1.9 10.7 4.7 14.9 2.7 4 6.3 7.5 10.7 9.3 2.8 1.1 4.1 1.6 5.8 2 2.3.5 4.6.8 6.9.8h1.9c7.3-.3 12-3.6 17.5-8.4 5.4-4.8 8.9-11.2 12.3-17.7 1.3-2.4 2.4-4.9 2.9-7.6.4-2.6 0-5.5-1.6-7.7z"
            />
          </g>
          <g id="rto_x5F_ofiice">
            <linearGradient
              id="SVGID_16_"
              gradientUnits="userSpaceOnUse"
              x1={299.55}
              y1={9032.858}
              x2={299.55}
              y2={9088.317}
              gradientTransform="translate(0 -8026)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </linearGradient>
            <path
              style={{
                opacity: 0.2,
                fill: "url(#SVGID_16_)",
                enableBackground: "new",
              }}
              d="M89.1 1008.3h483.6l-67.3 70.8h-479z"
            />
            <path className="st53" d="M364.5 751.9h208.2v256.4H364.5z" />
            <path className="st4" d="M360.3 748.3h216.2v7.2H360.3z" />
            <path
              className="st12"
              d="M477.9 914.2h94.8v62.6h-94.8zm0-92.2h94.8v62.6h-94.8z"
            />
            <path
              className="st69"
              d="M522.2 884.6h-31.4l13.7-62.6h31.4zm-16.8 29.6-13.8 62.5h-13.7v-62.5zm67.3-92.2v62.6h-34.5l15.3-62.6z"
            />
            <path className="st3" d="M385.3 764.5h187.4v27.9H385.3z" />
            <path className="st13" d="M387.3 766h185.4v24.6H387.3z" />
            <path
              d="M572.7 766v24.6h-16l6-24.6zm-33.4 0-5.4 24.6h-19.5l5.4-24.6zm-42.3 0-5.4 24.6h-19.5l5.4-24.6zm-42.3 0-5.4 24.6h-19.5l5.4-24.6zm-42.4 0-5.4 24.6h-19.5l5.5-24.6z"
              style={{
                opacity: 0.17,
                fill: "#bdc1c6",
                enableBackground: "new",
              }}
            />
            <path className="st69" d="M550 976.7h-31.4l13.7-62.5h31.4z" />
            <path
              className="st3"
              d="M432.7 766h2.6v24.6h-2.6zm52.7 0h2.6v24.6h-2.6zm51.5 0h2.6v24.6h-2.6z"
            />
            <path
              className="st1"
              d="M89.1 834.5H231v78.7H89.1zm0 95.1H231v78.7H89.1z"
            />
            <path
              className="st32"
              d="M108.7 913.2h122.2v16.4H108.7zm-28.5-79.1H231v7.8H80.2z"
            />
            <path className="st13" d="M105.7 862.8h15.7v24.8h-15.7z" />
            <path
              className="st32"
              d="M104.8 862v26.4h17.3V862h-17.3zm15.7 24.8h-14.1v-23.2h14.1v23.2z"
            />
            <path
              className="st32"
              d="M106.2 871.1h14.5v1.2h-14.5zm0 8.2h14.5v1.2h-14.5z"
            />
            <path className="st32" d="M112.8 862.6h1.2v24.9h-1.2z" />
            <path className="st13" d="M151.1 862.8h15.7v24.8h-15.7z" />
            <path
              className="st32"
              d="M150.1 862v26.4h17.3V862h-17.3zm1.6 1.6h14.1v23.2h-14.1v-23.2z"
            />
            <path
              className="st32"
              d="M151.5 871.1H166v1.2h-14.5zm0 8.2H166v1.2h-14.5z"
            />
            <path className="st32" d="M158.2 862.6h1.2v24.9h-1.2z" />
            <path className="st13" d="M196.5 862.8h15.7v24.8h-15.7z" />
            <path
              className="st32"
              d="M195.5 862v26.4h17.3V862h-17.3zm1.6 1.6h14.1v23.2h-14.1v-23.2z"
            />
            <path
              className="st32"
              d="M196.9 871.1h14.5v1.2h-14.5zm0 8.2h14.5v1.2h-14.5z"
            />
            <path className="st32" d="M203.6 862.6h1.2v24.9h-1.2z" />
            <path className="st13" d="M105.7 947.9h15.7v24.8h-15.7z" />
            <path
              className="st32"
              d="M104.8 947.1v26.4h17.3v-26.4h-17.3zm15.7 24.8h-14.1v-23.2h14.1v23.2z"
            />
            <path
              className="st32"
              d="M106.2 956.2h14.5v1.2h-14.5zm0 8.2h14.5v1.2h-14.5z"
            />
            <path className="st32" d="M112.8 947.7h1.2v24.9h-1.2z" />
            <path className="st13" d="M151.1 947.9h15.7v24.8h-15.7z" />
            <path
              className="st32"
              d="M150.1 947.1v26.4h17.3v-26.4h-17.3zm15.8 24.8h-14.1v-23.2h14.1v23.2z"
            />
            <path
              className="st32"
              d="M151.5 956.2H166v1.2h-14.5zm0 8.2H166v1.2h-14.5z"
            />
            <path className="st32" d="M158.2 947.7h1.2v24.9h-1.2z" />
            <path className="st13" d="M196.5 947.9h15.7v24.8h-15.7z" />
            <path
              className="st32"
              d="M195.5 947.1v26.4h17.3v-26.4h-17.3zm1.6 1.6h14.1v23.2h-14.1v-23.2z"
            />
            <path
              className="st32"
              d="M196.9 956.2h14.5v1.2h-14.5zm0 8.2h14.5v1.2h-14.5z"
            />
            <path className="st32" d="M203.6 947.7h1.2v24.9h-1.2z" />
            <path className="st12" d="M231 809.6h235.1v198.7H231z" />
            <path className="st4" d="M225.2 802.4h244.6v7.2H225.2z" />
            <path
              d="m231 812.1 235.1 7v-9.5H231zm36.6 109.6h165.2v86.3H267.6z"
              style={{
                opacity: 0.15,
                fill: "#fff",
                enableBackground: "new",
              }}
            />
            <path className="st13" d="M273.1 927.8H428v80.6H273.1z" />
            <path
              className="st12"
              d="M279 932.9h143.4v18.5H279zm0 23.5h41.9v51.6H279zm45.9 0h51.6v51.6h-51.6zm55.1 0h42.4v51.6H380z"
            />
            <path className="st69" d="M341.8 956.4h34.7v19.1l-6.2 32.5H332z" />
            <path className="st13" d="M331.7 966.2h38.6v41.8h-38.6z" />
            <path className="st34" d="M333.5 968.1h34.9v39.9h-34.9z" />
            <path
              className="st13"
              d="M350.3 968.1h1.3v39.9h-1.3zm-3.1 20c0-.5.4-.8.8-.8.5 0 .8.4.8.8 0 .5-.4.8-.8.8s-.8-.4-.8-.8zm5.9 0c0-.5.4-.8.8-.8.5 0 .8.4.8.8 0 .5-.4.8-.8.8-.5 0-.8-.4-.8-.8z"
            />
            <path
              className="st69"
              d="M292.3 956.4h21.3l-6.8 51.6h-21.3zm24.3-23.5-2.4 18.5H293l2.4-18.5zm73.5 23.5h21.2l-6.8 51.6h-21.2zm24.3-23.5-2.4 18.5h-21.3l2.5-18.5zm-29.8 0-3.5 18.5h-38.3l3.5-18.5z"
            />
            <path
              className="st13"
              d="M227.3 893.9H473v8.6H227.3zm71.2-62.3h100v46h-100z"
            />
            <path
              className="st12"
              d="M324.6 869.1H319v-28.9h11.2l4 3.8v7.5l-2.8 3 3.2 3v11.7H329v-10.7l-1.9-1.9h-2.5v12.5zm0-16.8h4.4v-7h-4.4v7zm26.3 16.8h-5.6v-23.8H341v-5.1h14.2v5.1h-4.3v23.8zm16.3 0-5.3-5.1v-18.8l5.2-5h5.6l5.2 5V864l-5.3 5.1h-5.4zm.3-24v18.8h4.8v-18.8h-4.8z"
            />
            <path
              className="st72"
              d="M313.9 1000.1c2.6-1.4 3.3 1.6 2.3 4.2-1 2.5-6.3 11-6.6 14.4-.1 1.3-.4 1.2-.6.2-1-4.6 1.2-16.9 4.9-18.8z"
            />
            <path
              className="st73"
              d="M308.3 988.5c-3-2.7-4.9 1.1-4.4 4.8s4.7 16.6 3.9 21.2c-.3 1.8.1 1.7.7.5 2.8-5.8 3.9-22.8-.2-26.5z"
            />
            <path
              className="st74"
              d="M307.7 1015.7c.1.2.2.1.4-.2 3.2-10.5-1.8-26.2-1.8-26.2 0-.1-.1-.1-.2-.1s-.1.1-.1.2c.1 0 5.1 15.9 1.7 26.3z"
            />
            <path
              className="st75"
              d="M301.7 997.2c-2.9-1.3-3.4 2-2.1 4.6s7.6 11.2 8.2 14.8c.2 1.4.5 1.2.6.2.7-4.9-2.7-17.8-6.7-19.6z"
            />
            <path
              className="st74"
              d="M308.1 1017.6c.1.1.2 0 .2-.2-.3-8.6-7.8-19.1-7.9-19.1 0-.1-.1-.1-.2 0-.1 0-.1.1 0 .2.1-.1 7.7 10.5 7.9 19.1z"
            />
            <radialGradient
              id="SVGID_17_"
              cx={308.611}
              cy={55303.598}
              r={5.218}
              gradientTransform="matrix(1 0 0 .1447 0 -6980.75)"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </radialGradient>
            <ellipse
              cx={308.6}
              cy={1021.7}
              rx={5.2}
              ry={0.9}
              style={{
                opacity: 0.7,
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "url(#SVGID_17_)",
                enableBackground: "new",
              }}
            />
            <path
              className="st74"
              d="M305.8 1015.7h5.6l1.5 1.3-1.2 4.7h-6.2l-1.2-4.7z"
            />
            <path
              className="st74"
              d="M304.3 1014h8.6c.3 0 .5.2.5.5v2.1c0 .3-.2.5-.5.5h-8.6c-.3 0-.5-.2-.5-.5v-2.1c.1-.3.3-.5.5-.5z"
            />
            <path className="st77" d="m312.9 1017-.2 1h-8.1l-.3-1z" />
            <path
              className="st72"
              d="M400.3 1000.1c2.6-1.4 3.3 1.6 2.3 4.2-1 2.5-6.3 11-6.6 14.4-.1 1.3-.4 1.2-.6.2-1-4.6 1.3-16.9 4.9-18.8z"
            />
            <path
              className="st73"
              d="M394.7 988.5c-3-2.7-4.9 1.1-4.4 4.8s4.7 16.6 3.9 21.2c-.3 1.8.1 1.7.7.5 2.9-5.8 4-22.8-.2-26.5z"
            />
            <path
              className="st74"
              d="M394.2 1015.7c.1.2.2.1.4-.2 3.2-10.5-1.8-26.2-1.8-26.2 0-.1-.1-.1-.2-.1s-.1.1-.1.2c0 0 5 15.9 1.7 26.3z"
            />
            <path
              className="st75"
              d="M388.1 997.2c-2.9-1.3-3.4 2-2.1 4.6s7.6 11.2 8.2 14.8c.2 1.4.5 1.2.6.2.8-4.9-2.7-17.8-6.7-19.6z"
            />
            <path
              className="st74"
              d="M394.5 1017.6c.1.1.2 0 .2-.2-.3-8.6-7.8-19.1-7.9-19.1 0-.1-.1-.1-.2 0-.1 0-.1.1 0 .2.1-.1 7.8 10.5 7.9 19.1z"
            />
            <radialGradient
              id="SVGID_18_"
              cx={395.043}
              cy={55303.598}
              r={5.218}
              gradientTransform="matrix(1 0 0 .1447 0 -6980.75)"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </radialGradient>
            <ellipse
              cx={395}
              cy={1021.7}
              rx={5.2}
              ry={0.9}
              style={{
                opacity: 0.7,
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "url(#SVGID_18_)",
                enableBackground: "new",
              }}
            />
            <path
              className="st74"
              d="M392.2 1015.7h5.7l1.4 1.3-1.2 4.7H392l-1.2-4.7z"
            />
            <path
              className="st74"
              d="M390.8 1014h8.6c.3 0 .5.2.5.5v2.1c0 .3-.2.5-.5.5h-8.6c-.3 0-.5-.2-.5-.5v-2.1c0-.3.2-.5.5-.5z"
            />
            <path className="st77" d="m399.3 1017-.2 1H391l-.2-1z" />
          </g>
          <g id="tree_x5F_1">
            <radialGradient
              id="SVGID_19_"
              cx={125.8}
              cy={23932.588}
              r={7.087}
              gradientTransform="matrix(1 0 0 .3452 0 -7199.106)"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </radialGradient>
            <ellipse
              cx={125.8}
              cy={1062.4}
              rx={7.3}
              ry={2.5}
              style={{
                opacity: 0.4,
                fill: "url(#SVGID_19_)",
                enableBackground: "new",
              }}
            />
            <ellipse className="st3" cx={141} cy={1036.2} rx={16.5} ry={9.7} />
            <ellipse className="st3" cx={113.1} cy={1045.3} rx={7.9} ry={6.3} />
            <path
              className="st3"
              d="M135.7 1023c0 .3 0 .7-.1 1 0 .2-.1.5-.1.7-1.1 5-6.9 8.9-13.9 8.9-2.6 0-5-.5-7.1-1.5l-.6-.3c-3.8-1.9-6.3-5.1-6.3-8.8 0-3.3 2-6.3 5.1-8.2.1-.1.3-.2.4-.3.2-.1.4-.2.7-.4 2.2-1.1 4.9-1.8 7.8-1.8 7.1 0 13 4 13.9 9.1v.9c.2.4.2.6.2.7z"
            />
            <path
              className="st36"
              d="M135.6 1024c0 .2-.1.5-.1.7-1-.1-1.9-.1-2.9-.1-8.1 0-15.1 3.1-18 7.6l-.6-.3c3-4.7 10.3-8 18.7-8 .9 0 1.9 0 2.9.1z"
            />
            <ellipse
              className="st3"
              cx={107.3}
              cy={1030.4}
              rx={10.8}
              ry={7.3}
            />
            <path
              className="st32"
              d="m132.6 1045.7 11.9-6.9-.4-.7-10.2 5.9 6-7.9-.8-.6-13.2 17.4-4.9-22.9-.9.2 4.8 22.6-15.4-19.5v-7.3h-.8v6.2l-4.1-5.1-.7.6 21.2 26.8v7.9h1.1v-8.3z"
            />
            <path
              className="st36"
              d="M135.6 1021.8v-.2h-.6c-3.3 0-6.5-1.1-9.1-3 .1-.2.2-.4.2-.6.5-1.2.5-2.2 0-3.2-.5-.9-1.5-1.1-2.2-.7-.7.3-1.2 1.1-.8 2.1.3.8 1 1.6 2.1 2.5-.8 1.3-2.3 2.2-4 2.3-2.7.2-4.9-.9-6.5-3.3-.8-1.2-1.2-2.4-1.4-3.1-.2.1-.3.2-.5.3.7 2.1 2.9 7.2 8.5 6.7 1.8-.2 3.4-1.1 4.3-2.5 2.6 2 5.9 3.1 9.3 3.1h.7v-.4zm-10.2-3.6c-.9-.8-1.6-1.5-1.9-2.2s.1-1.2.6-1.4c.2-.1.4-.1.6-.1.4 0 .7.2 1 .6.4.8.4 1.7 0 2.8l-.3.3z"
            />
          </g>
          <g id="car_2_">
            <path
              className="st4"
              d="M456.7 1021c0-4.6 3.8-8.4 8.4-8.4H506v8.4c0 1-.8 1.9-1.9 1.9h-45.4c-1.2.1-2-.9-2-1.9z"
            />
            <path className="st3" d="m468.6 1012.6 8.4-11.9h21.2l7.8 11.9z" />
            <path className="st4" d="M484.1 1000.7h7.9v14.7h-7.9z" />
            <path className="st34" d="M478.2 1015.2h5.9v.6h-5.9z" />
            <circle className="st3" cx={465.8} cy={1022.7} r={3.9} />
            <circle className="st3" cx={494.7} cy={1022.7} r={3.9} />
          </g>
          <g id="tunnel">
            <path
              className="st13"
              d="m1235.1 1079.1-499-.1c.3-.1.5-.2.8-.4.4-.2.8-.4 1.2-.5.5-.2 1-.4 1.5-.7 12-5.5 24-10.4 36-14.8.9-.3 1.8-.7 2.7-1 195.8-70.6 393.5-6.5 444.4 12.6 1.3.5 2.5 1 3.6 1.4 1.1.4 2.1.8 3 1.2.7.3 1.3.5 1.9.8 2.1.6 3.4 1.3 3.9 1.5z"
            />
            <linearGradient
              id="SVGID_20_"
              gradientUnits="userSpaceOnUse"
              x1={985.55}
              y1={4335.1}
              x2={985.55}
              y2={4285.239}
              gradientTransform="translate(0 -3256)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#e9ebeb",
                  stopOpacity: 0,
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#e9ebeb",
                }}
              />
            </linearGradient>
            <path
              d="M1235.1 1079.1H736c.3-.1.6-.2.9-.4l.2-.1c.4-.2.6-.4 1-.5.5-.2 1-.4 1.5-.7 12-5.5 24-10.4 36-14.8.9-.3 1.8-.7 2.7-1 195.8-70.6 393.5-6.5 444.4 12.6 1.3.5 2.5 1 3.6 1.4 1.1.4 2.1.8 3 1.2.7.3 1.3.5 1.9.8 2.1.6 3.4 1.3 3.9 1.5z"
              style={{
                fill: "url(#SVGID_20_)",
              }}
            />
            <linearGradient
              id="SVGID_21_"
              gradientUnits="userSpaceOnUse"
              x1={1234.85}
              y1={4335.1}
              x2={1234.85}
              y2={4334.86}
              gradientTransform="translate(0 -3256)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#e9ebeb",
                  stopOpacity: 0,
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#e9ebeb",
                }}
              />
            </linearGradient>
            <path
              d="m1235.1 1079.1-.5-.2c.2 0 .3.1.5.2z"
              style={{
                fill: "url(#SVGID_21_)",
              }}
            />
            <linearGradient
              id="SVGID_22_"
              gradientUnits="userSpaceOnUse"
              x1={737}
              y1={4335.1}
              x2={737}
              y2={4334.05}
              gradientTransform="translate(0 -3256)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#e9ebeb",
                  stopOpacity: 0,
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#e9ebeb",
                }}
              />
            </linearGradient>
            <path
              d="m736.9 1078.6 1.2-.6c-.6.4-1.2.7-1.8 1h-.4c.3-.1.7-.2 1-.4z"
              style={{
                fill: "url(#SVGID_22_)",
              }}
            />
            <linearGradient
              id="SVGID_23_"
              gradientUnits="userSpaceOnUse"
              x1={776.85}
              y1={4319.11}
              x2={776.85}
              y2={4317.56}
              gradientTransform="translate(0 -3256)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#e9ebeb",
                  stopOpacity: 0,
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#e9ebeb",
                }}
              />
            </linearGradient>
            <path
              d="M778.2 1061.6c-.9.5-1.8 1-2.6 1.5 0-.2 0-.3-.1-.6l2.7-.9z"
              style={{
                fill: "url(#SVGID_23_)",
              }}
            />
            <path
              className="st1"
              d="M1235.1 1079.1c-2.4-1.1-4.9-2-7.4-3l-7.5-2.7c-5-1.8-10-3.5-15.1-5.1-10.1-3.3-20.3-6.3-30.5-9.2-20.5-5.7-41.1-10.6-62-14.6-41.7-8-84-12.9-126.4-13.7-21.2-.5-42.4 0-63.6 1.6-21.1 1.6-42.2 4.4-63.1 8.2-41.7 7.7-82.6 20.2-121.4 37.4l-2.1.9c.7-.3 1.3-.7 2-1h.2c4.8-2.3 9.6-4.5 14.5-6.6 4.9-2.1 9.8-4.2 14.7-6.1 9.9-3.9 19.9-7.6 30-10.9 20.3-6.5 40.9-11.9 61.8-16 41.8-8.2 84.5-11.3 127.1-10.5 21.3.5 42.6 2 63.7 4.4 21.1 2.4 42.2 5.7 63 10 20.8 4.3 41.5 9.4 61.9 15.4 10.2 3 20.3 6.3 30.4 9.8 5 1.8 10 3.6 15 5.5 2.5.9 5 1.9 7.4 2.9 2.6 1.1 5 2.1 7.4 3.3z"
            />
          </g>
          <g id="grass">
            <path
              className="st50"
              d="M1850.6 995.7h-81.9s1.9-13.1 15.1-5.4c0 0 .6-1.2 1.9-2.7.1-.2.3-.3.4-.5 1.7-2 4.3-4.4 7.9-5.6.3-.1.6-.2.8-.2 4.5-1.2 10.4-.5 17.6 5 0 0 3.9-1.9 8.6-1.4.2 0 .4.1.7.1 2.5.4 5.3 1.5 7.7 4 0 0 2.8-1.8 6.6-2.2.2 0 .5-.1.7-.1 2.8-.1 6 .5 9 3 .2.1.3.3.5.4 1.5 1.4 3 3.2 4.4 5.6z"
            />
            <path
              className="st51"
              d="M1794.6 995.7h-.8c-1.1-1.5-4.7-5.9-8.1-8.1.1-.2.3-.3.4-.5 3.9 2.5 7.8 7.7 8.5 8.6zm8.2 0h-.7c-.4-2-2.6-10.5-8.1-14.2.3-.1.6-.2.8-.2 5.5 4 7.6 12.6 8 14.4zm18.8-10.8-2.9 10.8h-.7l3-10.9c.2 0 .4 0 .6.1zm15.1 1.8-3.4 9h-.7l3.4-8.9c.2 0 .4-.1.7-.1zm9.5 3.4-5.1 5.5h-.9l5.5-6c.2.3.4.4.5.5z"
            />
          </g>
          <g id="grass_3_">
            <path
              className="st50"
              d="M529.4 1008.3h70.2s-3.9-10-11.4-16.8c-.2-.2-.5-.5-.8-.7-4.9-4.2-11.3-6.9-19-4.7-.3.1-.7.2-1 .3-4.4 1.5-9.2 4.6-14.4 10 0 0-6.1-2.3-12.2-.6-.3.1-.7.2-1 .3-4.1 1.5-8.2 4.9-10.4 12.2z"
            />
            <path
              className="st51"
              d="m539.8 996.1 9.7 12.2h1.2l-9.9-12.5c-.4.1-.7.2-1 .3zm27.1 12.2h1l.5-22.2c-.3.1-.7.2-1 .3l-.5 21.9zm11.2 0h1.1l9-16.8c-.2-.2-.5-.5-.8-.7l-9.3 17.5z"
            />
          </g>
          <g id="Board">
            <radialGradient
              id="SVGID_24_"
              cx={1451.529}
              cy={23872.16}
              r={16.728}
              gradientTransform="matrix(1 0 0 .3452 0 -7199.106)"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </radialGradient>
            <ellipse
              cx={1451.5}
              cy={1041.5}
              rx={17.2}
              ry={5.9}
              style={{
                opacity: 0.4,
                fill: "url(#SVGID_24_)",
                enableBackground: "new",
              }}
            />
            <radialGradient
              id="SVGID_25_"
              cx={1600.266}
              cy={23872.16}
              r={16.72}
              gradientTransform="matrix(1 0 0 .3452 0 -7199.106)"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#9aa0a6",
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#9aa0a6",
                  stopOpacity: 0,
                }}
              />
            </radialGradient>
            <ellipse
              cx={1600.3}
              cy={1041.5}
              rx={17.2}
              ry={5.9}
              style={{
                opacity: 0.4,
                fill: "url(#SVGID_25_)",
                enableBackground: "new",
              }}
            />
            <path
              className="st53"
              d="M1445.5 1041.4V853.8l.4-.2c.2 0 2.4-1.1 5.6-1.1 1.9 0 4 .4 5.8 1.1l.4.2v187.8h-12.1v-.2h-.1zm148.7 0V853.8l.4-.2c.2 0 2.4-1.1 5.6-1.1 1.9 0 4 .4 5.8 1.1l.4.2v187.8h-12.1v-.2h-.1z"
            />
            <path className="st53" d="M1418.8 861.4h214.4v121h-214.4z" />
            <path className="st12" d="M1423.5 866.3h205v111.5h-205z" />
            <path className="st13" d="M1426.3 868.9h199.5V975h-199.5z" />
            <path
              className="st12"
              d="M1585.3 948.2c2-1.3 3.3-3.8 3.3-6.4 0-2.7-1.2-5.2-3.4-6.5 2.2-1.3 3.4-3.6 3.4-6.4 0-2.7-1.3-5.2-3.5-6.5 2.2-1.3 3.4-3.7 3.4-6.5 0-4.3-3.7-7.8-8.1-7.5-3.5.2-6.6 3.1-7 6.6-.3 3.1 1 6 3.4 7.5-2.2 1.3-3.3 3.6-3.3 6.4 0 2.7 1.2 5.2 3.4 6.5-2.2 1.3-3.4 4.3-3.4 7 0 2.5 1.3 4.4 3.3 5.7-2 1.3-3.4 4.1-3.4 6.6v6h5.2v-6.6c.1-.9.5-1.4 1.5-2.1l1.1-.8 1.3.9c.8.5 1.2 1.1 1.3 2v6.6h4.9v-6c-.1-2.9-1.5-5.1-3.4-6.5zm-6.2-33.6c.5-.5 1.2-.8 1.9-.8s1.2.2 1.8.7c.5.5.9 1.3.9 2 0 .5-.2 1.2-.7 1.6l-1.9 1.5-1.9-1.4c-1.1-1-1.1-2.6-.1-3.6zm2.2 11.4 1.5 1.1c1.1 1.3 1.1 2.7-.1 4l-1.4 1.1c-.1.1-.3.1-.4 0l-1.6-1.2c-1-1.2-1-2.6.1-3.7l1.5-1.2c0-.2.2-.2.4-.1zm-.5 18.8-1.6-1.1c-1-1.2-1-2.6.1-3.7l1.5-1.2c.1-.1.3-.1.4 0l1.5 1.1c1.1 1.2 1.1 2.6-.1 3.8l-1.4 1.1c-.1.1-.3.1-.4 0z"
            />
            <path
              className="st4"
              d="M1598.2 890.7c0-10.9-7.8-20.1-20-20H1477c-10.7 0-20 7.4-22.3 17.8-.4 1.9-.7 3.8-.7 5.8l-.2 26.6c0 2.2.1 4.4.4 6.6.4 2.2 1.2 4.9 3.3 7.9 1.5 2.4 3.8 4.8 7.3 7 2.5 1.6 5.2 2.6 8.1 3.2 1.4.2 3 .3 4.6.3.9 0 1.8 0 2.6-.1 7.6 8 24.2 8.6 24.2 8.6l30.3-.2c2.2 0 4.4.7 6.2 2l6.9 5.1 5.2-7.3-7.1-5.2c-4.2-2.5-5.6-4.9-6.5-8.6-.3-1.2-.4-2.2-.4-2.5s-.1-.7-.1-1c-.1-4.4 1.6-7.6 1.6-7.6 3.3-5.2 4.8-10.8 5.1-12.3 0-.2.9-6.9-1.2-11.9l3.3 1.2 1.1.4c2.9 1.1 11.3 5.5 14.1 14.5.5 1.6.8 3.4.8 5.2l.1 34.7h9l-.2-36.3c0-.9-.1-1.9-.3-2.9-1.2-7.8-5.1-13.4-9.2-17.1-4-3.6-8.9-5.6-10.9-6.4l-1.1-.4c-1.3-.5-2.7-1.1-4.1-1.6l-26.3-10-3.4 7.9 8.7 3.5c2.3.9 4.7 1.3 6.5 3 .8.8 1.9 3.1 1.9 3.1s3.3 5.3 2.5 10.7c0 .2-.1 1.4-.3 2.5-.1.8-.9 3.1-3.3 6.9-.1.1-3.5 6.3-3.2 13.1v.7c0 1.2.2 4 1.8 7.7H1506c-1.6 0-3.4-.2-5.1-.4-4.4-.8-7.1-1.3-11.1-2.5 5.3-2.1 9.2-5.3 11.1-9.8 1.2-2.9 1.3-6.1.6-9.1l-1.8-7.6 5.5-1.4c2.4-.6 4.6-1.6 6.6-3.1 1.5-1.1 2.6-2.4 3.5-3.7 1.6-2.5 2.4-5.5 2.4-9.2 0-1.3-.2-2.7-.5-4-1.9-6.3-7.8-10.9-14.6-11-9.1-.1-16.3 6.4-16.3 15.6 0 1.2.1 2.3.4 3.5l1.9 7.2c-2.5.8-4.1 1-6.3 1.6-6.6 2.2-10.8 6.4-11.8 13.2-.7 4.4.8 9.2 3.3 12.3.1.2-1.9-.4-2-.5l-.4-.2c-3.6-1.9-5.5-4.1-6.7-5.9-1.8-2.7-2-4.8-2-5.3l-.2-15.8h5.9v-12.5h-5.9v-2c0-8.1 6.6-14.7 14.7-14.7h101.7c5.8 0 10.5 4.7 10.5 10.5l.3 70.8h8.8l-.3-70.6zm-98.2 1.4c.7-.2 1.2-.2 1.9-.2 3 0 5.7 2 6.6 4.9.2.7.2 1.2.2 1.9 0 3-2 5.7-4.9 6.6l-6.2 1.8c-.2 0-.4-.1-.5-.3l-1.8-6.2c-1.1-3.7 1-7.5 4.7-8.5zm-15.9 27.6 6.6-1.9 1.9 6.6c1 3.6-1.1 7.1-4.6 8.6l-4.6 2.3-2.9-4.7c-.2-.3-.3-.7-.5-1l-.3-.8c-.3-.7-.5-1.4-.5-2.2-.3-3 1.7-6 4.9-6.9zm32.9-25.6s0 .1 0 0z"
            />
            <path
              className="st12"
              d="M1530.5 894.7c6.6 3.5 9.1 10 9.1 10.1-.1-.1-2.6-6.6-9.1-10.1z"
            />
            <path
              className="st12"
              d="M1539.6 904.8c2.9 7.3 1.2 14.4-1.2 18.7-.8 1.4-1.3 2.4-1.3 2.4-2 2.5-2.6 8.1-2.6 8.1-.9 8.9 4.3 15 5.5 16.3l.2.2c-.1 0-.2-.1-.3-.1l-.2-.2c-.6-.7-1.7-2.1-2.8-4.1-1.4-2.6-3-6.8-2.5-12.1 0-.1.8-5.7 2.6-8.2 0 0 .5-1 1.3-2.4.7-1.2 2-3.8 2.5-7.5.6-3.8.1-7.5-1.2-11.1z"
            />
            <path
              className="st12"
              d="M1568.1 926c0-2.6-.4-5.3-1.3-7.7-1.8-4.8-4.6-8.9-8.7-12-3.4-2.5-6.6-3.6-7.9-4.2-1-.3-2-.7-3.2-1.2l-17.6-6.9v.1l1.2.6 16.2 6.3c1.2.5 2.2.9 3.2 1.2 8.4 3.1 13.8 8.5 16.5 16.2.9 2.4 1.3 5.1 1.3 7.7l.2 34.8.1-34.9z"
            />
            <g className="st41">
              <path
                className="st12"
                d="M1566.3 879.6v.1h-.1v-.1l-1.4-4.5h-.1l.1-.1 1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1565.2 879.6v.1h-.1v-.1l-1.4-4.5h-.1l.1-.1 1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1564.1 879.6v.1h-.1v-.1l-1.3-4.5h-.1l.1-.1 1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1563 879.6v.1h-.1v-.1l-1.3-4.5h-.1l.1-.1 1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1562 879.6v.1h-.1v-.1l-1.4-4.5h-.1l.1-.1 1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1560.9 879.6v.1h-.1v-.1l-1.4-4.5h-.1l.1-.1 1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1559.8 879.6v.1h-.1v-.1l-1.3-4.5v-.1l1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1558.9 879.6v.1h-.2v-.1l-1.4-4.5v-.1l1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1557.8 879.6v.1h-.2v-.1l-1.4-4.5v-.1l1.3-4.3h.1l-1.3 4.3v.1zm-2.5-4.6-.1.1v-.1l1.3-4.3h.2zm1.2 4.6-1.3-4.5h.1l1.4 4.5.1.1h-.3zm-2.3-4.6-.1.1v-.1l1.3-4.3h.2zm1.5 4.6v.1h-.1v-.1l-1.5-4.5h.1zm-2.6-4.6-.1.1v-.1l1.3-4.3h.2zm1.5 4.6v.1h-.1v-.1l-1.5-4.5h.1zm-2.6-4.6-.1.1v-.1l1.3-4.3h.2zm1.5 4.6v.1h-.1v-.1l-1.5-4.5h.1z"
              />
              <path
                className="st12"
                d="M1552.6 879.6v.1h-.1v-.1l-1.4-4.5h-.2l.2-.1 1.2-4.3h.2l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1551.5 879.6v.1h-.1v-.1l-1.4-4.5h-.2l.2-.1 1.2-4.3h.2l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1550.5 879.6v.1h-.1v-.1l-1.4-4.5h-.1l.1-.1 1.2-4.3h.1l-1.2 4.3v.1z"
              />
              <path
                className="st12"
                d="M1549.4 879.6v.1h-.1v-.1l-1.3-4.5v-.1l1.2-4.3h.2l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1548.4 879.6v.1h-.1v-.1l-1.4-4.5v-.1l1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1547.3 879.6v.1h-.1v-.1l-1.4-4.5v-.1l1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1546.3 879.6v.1h-.1v-.1l-1.4-4.5v-.1l1.3-4.3h.2l-1.4 4.3v.1z"
              />
              <path
                className="st12"
                d="M1545.2 879.6v.1h-.1v-.1l-1.4-4.5v-.1l1.3-4.3h.2l-1.4 4.3v.1zm-2.4-4.6-.1.1v-.1l1.3-4.3h.2zm1.4 4.6v.1h-.1v-.1l-1.4-4.5h.1z"
              />
              <path
                className="st12"
                d="M1543.1 879.6v.1h-.1v-.1l-1.3-4.5h-.1l.1-.1 1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1542.2 879.6v.1h-.2v-.1l-1.4-4.5h-.1l.1-.1 1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1541.1 879.6v.1h-.2v-.1l-1.4-4.5h-.1l.1-.1 1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1540 879.6v.1h-.2v-.1l-1.4-4.5.1-.1 1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1539.1 879.6v.1h-.1v-.1l-1.6-4.5h.1v-.1l1.3-4.3h.1l-1.3 4.3v.1z"
              />
              <path
                className="st12"
                d="M1538 879.6v.1h-.1v-.1l-1.6-4.5h.1v-.1l1.3-4.3h.1l-1.3 4.3v.1zm-2.4-4.6-.2.1v-.1l1.3-4.3h.2zm1.2 4.6-1.4-4.5 1.5 4.5.1.1h-.2zm-2.3-4.6-.2.1v-.1l1.3-4.3h.2zm1.4 4.6v.1h-.1v-.1l-1.5-4.5zm30.3-3-.5-1.5h.1l.5-1.4-.4 1.4z"
              />
            </g>
            <g className="st41">
              <path
                className="st12"
                d="M1521.9 879.6v.1l-1.5-4.7 1.4-4.3h.1l-1.3 4.3z"
              />
              <path
                className="st12"
                d="m1521.9 876.6-.5-1.6.5-1.5v.2l-.3 1.3.3 1.4zm-1.1 3v.1l-1.5-4.7 1.4-4.3h.1l-1.3 4.3z"
              />
              <path
                className="st12"
                d="M1519.8 879.6v.1l-1.6-4.7 1.4-4.3h.1l-1.3 4.3z"
              />
              <path
                className="st12"
                d="M1518.7 879.6v.1l-1.5-4.7 1.3-4.3h.1l-1.3 4.3z"
              />
              <path
                className="st12"
                d="M1517.6 879.6v.1l-1.4-4.7 1.4-4.3-1.3 4.3z"
              />
              <path
                className="st12"
                d="M1516.7 879.6v.1h-.1l-1.5-4.7 1.4-4.3-1.3 4.3z"
              />
              <path
                className="st12"
                d="M1515.6 879.6v.1h-.1l-1.5-4.7 1.4-4.3-1.3 4.3z"
              />
              <path
                className="st12"
                d="M1514.5 879.6v.1h-.1l-1.4-4.7 1.4-4.3-1.3 4.3z"
              />
              <path
                className="st12"
                d="M1513.5 879.6v.1l-1.6-4.7 1.4-4.3-1.3 4.3z"
              />
              <path
                className="st12"
                d="M1512.4 879.6v.1l-1.6-4.7 1.4-4.4-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1511.3 879.6v.1l-1.6-4.7 1.4-4.4-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1510.2 879.6v.1l-1.5-4.7 1.4-4.4-1.2 4.4z"
              />
              <path
                className="st12"
                d="M1509.2 879.6v.1l-1.6-4.7 1.4-4.4-1.2 4.4z"
              />
              <path
                className="st12"
                d="M1508.2 879.6v.1l-1.5-4.7 1.4-4.4h.1l-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1507.1 879.6v.1l-1.5-4.7 1.4-4.4h.1l-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1506.1 879.6v.1l-1.5-4.7 1.4-4.4h.1l-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1505.1 879.6v.1l-1.5-4.7 1.3-4.4h.1l-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1504 879.6v.1l-1.4-4.7 1.3-4.4h.1l-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1503 879.6v.1l-1.5-4.7 1.3-4.4h.1l-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1501.9 879.6v.1l-1.4-4.7 1.4-4.4-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1500.8 879.6v.1l-1.4-4.7 1.4-4.4-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1499.8 879.6v.1l-1.4-4.7 1.4-4.4-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1498.9 879.6v.1h-.1l-1.5-4.7 1.4-4.4-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1497.8 879.6v.1h-.1l-1.4-4.7 1.4-4.4-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1496.8 879.6v.1l-1.6-4.7 1.4-4.4-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1495.7 879.6v.1l-1.6-4.7 1.4-4.4-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1494.7 879.6v.1l-1.6-4.7 1.4-4.4-1.3 4.4z"
              />
              <path
                className="st12"
                d="M1493.6 879.6v.1l-1.5-4.7 1.4-4.4-1.2 4.4z"
              />
              <path
                className="st12"
                d="M1492.6 879.6v.1l-1.5-4.7 1.3-4.4-1.2 4.4z"
              />
              <path
                className="st12"
                d="M1491.5 879.6v.1l-1.5-4.7 1.3-4.4h.1l-1.3 4.4z"
              />
            </g>
            <path
              className="st13"
              d="M1576.5 944c.4.8 1.1 1.6 1.9 2.2l2.5 1.8h.1l-2.7-2c-.7-.6-1.4-1.3-1.8-2zm4.6-21.3h.1-.1zm-4.6 8.7c.3.7.8 1.3 1.4 1.7l.4.3-.5-.4c-.5-.4-.9-1-1.3-1.6zm8-11.3-3.4 2.6.1.1 3.2-2.5c.1-.1.8-.8 1.3-1.9-.6 1-1.2 1.7-1.2 1.7zm-8-1.3c.4.8 1.1 1.5 2.2 2.1l2 1.6.6.2-2.7-2.1c-1-.4-1.6-1.1-2.1-1.8zm9.7 23.8c.1-.5.1-1 0-1.5-.2-1.3-1-2.5-2.2-3.4l-2.9-2.2 3.2-2.4c2.5-2.6 2.1-4.9 1.2-6.5-.4-.7-1-1.3-1.8-2l-2.5-1.9-.1.1 2.6 1.9c.8.5 1.3 1.2 1.8 1.9.9 1.4 1.3 3.7-1.2 6.3l-3.2 2.4-2.7-1.8 2.6 1.9c-.7.4-1.3.9-1.9 1.3l-.2.1c-.7.4-1.6 1.3-2.3 2.4-.8 1.4-.9 2.9-.2 4.4.1.1.1.3.2.4 0-.1-.1-.1-.1-.2-.4-1.1-1.2-4.1 2.4-6.7l.2-.1c.7-.4 1.3-.9 2-1.4l3 2.2c1.2.9 1.9 2.1 2.1 3.3.1.5.1 1 0 1.5-.3 2.5-2.3 3.6-2.3 3.6l-2.9 1.8.1.1 2.9-1.8c-.1 0 1.9-1.1 2.2-3.7zm-.1 12.6v5.6h.1v-5.6c0-2.7-1.2-4.2-1.9-4.6.7.6 1.8 2 1.8 4.6zm-9.6-36.4c-.8-1.4-.5-2.8-.5-2.8.2-3.7 4.1-4.5 4.1-4.6h.9c3.6 0 4.8 3.4 4.8 3.5.4 1.3.2 2.5-.2 3.5.4-1 .7-2.4.3-3.8 0 0-1.4-4.1-5.8-3.5 0 0-4 .9-4.2 4.6 0 0-.1.9.1 1.9.1.3.3.8.5 1.2zm7.8 31.8-3.3-2.5-.1.1 3.4 2.4zm-3.2-27.9h-.1m-3.6 27.9-.3.3c-.8 1-1.2 2.3-1.2 3.7v6.2h.1v-6.2c0-1.4.4-2.6 1.2-3.6l.3-.3 3.5-2.6-.2-.1-3.4 2.6zm.1-25.6c-1.2.9-2.3 2.6-1.3 5.7.1.2.2.5.3.7-.1-.2-.2-.3-.2-.5-1-3 .1-4.6 1.3-5.6l3.5-2.7-.3-.1-3.3 2.5z"
            />
            <path
              className="st12"
              d="M1549 956.4c-1.6-1.5-4.9-4.4-8.9-5.9-.1 0-.2-.1-.3-.1-1.6-.6-3.3-1-5-1h-.9c-1.4.1-2.9.1-4.3.1h-26.3v-.1h26.3c1.4 0 2.9-.1 4.3-.1h.3c1.2-.1 3.1.1 5.4.9.1 0 .2.1.3.1h.1c3.1 1.1 6.1 3.2 9 6.1zm-44.9-46.6c.9-.3 1.8-.6 2.6-1 .9-.5 1.7-1 2.4-1.5-.7.5-1.4 1-2.3 1.4-.9.4-1.8.7-2.6 1-.2.1-.4.1-.7.2l-9.4 2.4v.1l9.3-2.4c.3 0 .5-.1.7-.2z"
            />
            <path
              className="st12"
              d="m1480.9 939.7-3.6-5.8c-1.1-1.8-1.9-3.5-2.2-5.2-.7-3.1-.2-5.8 1.3-8.4.8-1.2 1.8-2.3 3-3.1 1.3-1 3-1.6 4.7-2.2l9.9-2.6-3-11.1s-1.9-6.6 3.4-11.1c2.2-1.9 4.8-2.9 7.6-2.9 1.6 0 3.3.3 4.8 1.1 2.7 1.3 4.5 3.3 5.6 6.2.2.5.3 1 .4 1.5.2.9.4 2.4.2 4.1-.2 1.8-.9 4-2.9 6 2.1-2 2.8-4.3 3-6.1.2-1.7 0-3.2-.2-4.1-.1-.5-.2-1-.4-1.5-1.1-2.9-3-5-5.7-6.3-4.2-2-9-1.3-12.5 1.8-2.6 2.3-3.5 5.2-3.7 7.1-.2 1.5 0 2.9.1 3.5.1.3.1.6.2 1l2.9 10.6-9.9 2.6c-1.9.4-3.4 1.2-4.8 2.2-1.2.9-2.2 1.9-3 3.1-1.5 2.5-2 5.3-1.3 8.5.3 1.8 1.1 3.5 2.2 5.2l3.4 5.4c.2.3.4.5.6.8.1.2.3.3.4.5h.2c-.4-.3-.7-.8-.7-.8z"
            />
            <path
              className="st12"
              d="M1509.2 907.3c.4-.3.7-.6 1-.9-.3.3-.6.6-1 .9z"
            />
            <path
              className="st12"
              d="M1594.1 961h-.1l-.2-69.5c0-1.3-.1-2.6-.4-3.9-.3-1.4-.9-3.3-2-5.1-1.1-2.1-2.6-3.8-4.5-5.1-2.3-1.5-5.2-2.3-8.6-2.3H1534l-56-.1h-2.2c-.3 0-.5 0-.8.1-.3 0-.7.1-1.1.1-.2 0-.4.1-.6.1h-.2c-.2 0-.4.1-.5.1-.4.1-.8.2-1.3.3-1.1.3-2.4.8-3.7 1.5-7 3.7-9.1 11.1-9.6 16.6v27.6c0 .5 0 1.4.2 2.6.2 1.2.4 2.6.9 4.2 1.2 3.5 3.8 8.3 9.6 11.1.2.1.3.1.5.2 1 .4 6 2.6 12.2 1.1 0 0 .2-.1.2 0-5.8 1.4-11-.4-12.4-.9-.3-.1-.5-.2-.8-.3-5.8-2.9-8.3-7.6-9.5-11-1.3-3.8-1.1-7-1.1-7.1v-4.9l-.1-3.7V894c.5-5.6 2.7-13 9.7-16.8 4.2-2.3 8.3-2.1 8.3-2.1h2.4l56 .1h44.3c3.3 0 6.3.8 8.6 2.3 2 1.3 3.4 3 4.6 5.2 2 3.7 2.1 7.5 2.1 7.5l.4 70.8z"
            />
            <path
              className="st12"
              d="M1481.7 940.7c.1 0 1.7-.5 2.6-.8-.9.3-2.6.8-2.6.8z"
            />
            <path
              className="st12"
              d="M1482.4 941.5c2 2.1 6.5 6.8 20.7 8 .1 0 .2.1.3.1v-.1c-.1 0-.2.1-.3 0-14.1-1.3-18.7-6-20.6-8.1-.2-.2-.4-.5-.6-.7 0 0 0-.1-.1-.1h-.1l.1.1c.1.2.3.6.6.8zm13.9-20.9s0 .1.1.2l.4 1.4c.4 2 .8 5.4-.8 8.8-1.9 4-5.8 6.9-11.7 8.8v.1c5.9-1.9 9.9-4.8 11.8-8.8 2.5-5.3.4-10.5.3-10.6l-.1.1-2.1-8.2h-.1l2.2 8.2z"
            />
            <path
              d="M1591.1 966.7c0 .1.1.2.2.2h.4v5.5c0 .5.4.8.8.8h3c.5 0 .8-.4.8-.8v-5.5h.4c.1 0 .2-.1.2-.2s-.1-.2-.2-.2h-.4v-1.2c0-.5-.4-.8-.8-.8h-3c-.5 0-.8.4-.8.8v1.2h-.4c-.1-.1-.2 0-.2.2zm1.1 0s.4-.4 1.8-.4c1.5 0 1.8.4 1.8.4l-.4 1.4s-1.5-.5-2.8 0l-.4-1.4zm.5 3.8h2.8l.4.9h-3.6l.4-.9zm3.5-5.1s-1 .1-1.2-.9c0 0 .8 0 1 .2.1.2.2.2.2.7zm-.4 4.8v-2.3l.4-.9v3.7l-.4-.5zm-3.6 2.2h3.7v.2h-3.7v-.2zm-.3-5.5.4.9v2.3l-.4.5v-3.7zm-.1-1.6c0-.4.1-.5.2-.7.2-.2.9-.2.9-.2-.2 1.1-1.1.9-1.1.9zm-65.6-87.3c.1 0 .2-.1.2-.2v-.4h5.5c.5 0 .8-.4.8-.8v-3c0-.5-.4-.8-.8-.8h-5.5v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2v.4h-1.2c-.5 0-.8.4-.8.8v3c0 .5.4.8.8.8h1.2v.4c0 .1.1.2.2.2zm0-1.1s-.4-.4-.4-1.8c0-1.5.4-1.8.4-1.8l1.4.4s-.5 1.5 0 2.8l-1.4.4zm3.9-.5v-2.8l.9-.4v3.6l-.9-.4zm-5.2-3.5s.1 1-.9 1.2c0 0 0-.8.2-1 .2-.1.2-.2.7-.2zm4.8.4h-2.3l-.9-.4h3.7l-.5.4zm2.3 3.6v-3.7h.2v3.7h-.2zm-5.5.3.9-.4h2.3l.5.4h-3.7zm-1.6.1c-.4 0-.5-.1-.7-.2-.2-.2-.2-.9-.2-.9 1 .2.9 1.1.9 1.1zm2.2 12.9c-.1 0-.2 0-.3.1l-.1.3-5-2.2c-.4-.2-.9 0-1.1.4l-1.2 2.8c-.2.4 0 .9.4 1.1l5 2.2-.2.4c0 .1 0 .2.1.3.1 0 .2 0 .3-.1l.2-.4 1.1.5c.4.2.9 0 1.1-.4l1.2-2.8c.2-.4 0-.9-.4-1.1l-1.1-.5.1-.3c0-.1 0-.2-.1-.3zm-.5 1.1s.2.5-.4 1.8c-.6 1.3-1.1 1.5-1.1 1.5l-1.1-1s1-1.2 1.1-2.5l1.5.2zm-3.7-1.2-1.1 2.6h-1l1.5-3.3.6.7zm3.3 5.4s.3-.9 1.3-.7c0 0-.3.7-.5.8-.4 0-.4 0-.8-.1zm-4.3-2.4 2.1 1 .7.7-3.4-1.5.6-.2zm-.6-4.2-1.5 3.3-.2-.1 1.5-3.3.2.1zm5.2 1.9h-1l-2.1-1-.3-.5 3.4 1.5zm1.5.7c.4.2.4.3.5.5.1.2-.2.9-.2.9-.8-.7-.3-1.4-.3-1.4zm-60 13.2c0-.1-.1-.2-.2-.2h-.4V899c0-.5-.4-.8-.8-.8h-3c-.5 0-.8.4-.8.8v5.5h-.4c-.1 0-.2.1-.2.2s.1.2.2.2h.4v1.2c0 .5.4.8.8.8h3c.5 0 .8-.4.8-.8V905h.4c.1 0 .2-.1.2-.3zm-1.1 0s-.4.4-1.8.4-1.8-.4-1.8-.4l.4-1.4s1.5.5 2.8 0l.4 1.4zm-.5-3.8h-2.8l-.4-.9h3.6l-.4.9zm-3.5 5.1s1-.1 1.2.9c0 0-.8 0-1-.2-.2-.2-.2-.2-.2-.7zm.4-4.8v2.3l-.4.9v-3.7l.4.5zm3.6-2.2h-3.7v-.2h3.7v.2zm.3 5.5-.4-.9v-2.3l.4-.5v3.7zm.1 1.6c0 .4-.1.5-.2.7-.2.2-.9.2-.9.2.1-1.1 1.1-.9 1.1-.9zm97.8 65h.4v1.2c0 .5.4.8.8.8h3c.5 0 .8-.4.8-.8v-1.2h.4c.1 0 .2-.1.2-.2s-.1-.2-.2-.2h-.4v-5.5c0-.5-.4-.8-.8-.8h-3c-.5 0-.8.4-.8.8v5.5h-.4c-.1 0-.2.1-.2.2s.1.2.2.2zm1.4-1.6c1.3.5 2.8 0 2.8 0l.4 1.4s-.4.4-1.8.4c-1.5 0-1.8-.4-1.8-.4l.4-1.4zm-.4-3.4h3.6l-.4.9h-2.8l-.4-.9zm3.7 6.8c-.2.2-1 .2-1 .2.2-1 1.2-.9 1.2-.9.1.5 0 .5-.2.7zm.2-6v3.7l-.4-.9v-2.3l.4-.5zm-4-2h3.7v.2h-3.7v-.2zm-.3 2 .4.5v2.3l-.4.9v-3.7zm1.1 6.2s-.8 0-.9-.2c-.2-.2-.2-.2-.2-.7 0 0 .9-.1 1.1.9z"
              style={{
                fill: "#7c8289",
              }}
            />
            <path className="st87" d="M1586.6 966.4h.3v.1h-.3z" />
            <g />
            <circle className="st88" cx={1587} cy={966.4} r={0.1} />
            <defs>
              <path
                id="SVGID_26_"
                d="M1587 966.4h-.2c0 .1.1.2.1.2s.1-.1.1-.2c.1 0 0 0 0 0z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_26_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_27_">
              <use
                xlinkHref="#SVGID_26_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path
              className="st87"
              d="M1586.8 966.3h.3v.1h-.3zm-1.112.28h-.3v-.1h.3z"
            />
            <g />
            <circle className="st88" cx={1585.3} cy={966.4} r={0.1} />
            <defs>
              <path
                id="SVGID_28_"
                d="M1585.3 966.4h.2c0 .1-.1.2-.1.2s-.1-.1-.1-.2c-.1 0 0 0 0 0z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_28_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_29_">
              <use
                xlinkHref="#SVGID_28_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path className="st87" d="M1585.44 966.434h-.3v-.1h.3z" />
            <path
              className="st89"
              d="M1586.9 968.4c0-.3-.2-.5-.4-.7-.1-.1-.2-.1-.4-.2v.1c.1.1.2.1.3.2 0 0 .1.1.1.2.1.1.2.3.2.5l.1 1.9v.1h.1c.1 0 .1 0 .1-.1l-.1-2z"
            />
            <defs>
              <path
                id="SVGID_30_"
                d="M1587 973.1v-.6l.1-.2v-2c0-.1-.1-.2-.2-.2s-.2.1-.2.2v2l.1.2v.6h.2z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_30_"
              style={{
                overflow: "visible",
                fill: "#bdbfc9",
              }}
            />
            <clipPath id="SVGID_31_">
              <use
                xlinkHref="#SVGID_30_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path className="st87" d="M1585.7 972.6h.2v.1h-.2z" />
            <defs>
              <path
                id="SVGID_32_"
                d="M1585.5 972.8h.1c0-.1-.1-.2-.1-.2-.1 0-.1.1-.1.2h.1z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_32_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_33_">
              <use
                xlinkHref="#SVGID_32_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path className="st87" d="M1586.636 972.716h-.2v-.1h.2z" />
            <defs>
              <path
                id="SVGID_34_"
                d="M1586.7 972.8h-.1c0-.1.1-.2.1-.2.1 0 .1.1.1.2h-.1z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_34_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_35_">
              <use
                xlinkHref="#SVGID_34_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path
              className="st90"
              d="M1585.8 972.3v.8c0 .1.2.1.2.1h.1s.2 0 .2-.1v-.8h-.5z"
            />
            <path
              className="st91"
              d="M1585.5 971.8s.1.9.6.9h.1c.5 0 .6-.9.6-.9h-1.3z"
            />
            <path className="st92" d="m1586.6 969.6.1-.1v-.5l-.1-.1v.7z" />
            <path className="st93" d="m1586.6 969.8.1-.1v-.7l-.2-.2.1 1z" />
            <path className="st92" d="m1585.7 969.6-.1-.1v-.5l.1-.1v.7z" />
            <path className="st93" d="m1585.8 969.8-.1-.1v-.7l.2-.2-.1 1z" />
            <path
              className="st87"
              d="M1586.9 971.5c0-.2-.1-1-.2-1.4-.1-.4-.1-1.2-.1-1.2l-.9.1s0 .7-.1 1.1c-.1.4-.2 1.2-.2 1.4 0 .2 0 .5.2.7.3.1.7.1 1 0 .4-.3.3-.5.3-.7z"
            />
            <path className="st94" d="M1585.4 970.6h1.5v.2h-1.5z" />
            <path className="st95" d="M1586.6 965.9h-.8v-.1h.8v.1z" />
            <path
              className="st91"
              d="M1586.1 967.1s.5 0 .6.4c.1.3.1.7.1.9v.2c0 .2-.3.6-.5.7-.1.1-.2.1-.2.1h-.1s-.1 0-.2-.1-.4-.5-.5-.7v-.2c0-.2 0-.6.1-.9.3-.4.7-.4.7-.4z"
            />
            <circle className="st12" cx={1586.1} cy={967.9} r={0.3} />
            <circle className="st13" cx={1586.1} cy={967.9} r={0.1} />
            <path className="st96" d="M1586.1 969.3z" />
            <path
              className="st90"
              d="M1585.4 968.4c.1.2.3.3.4.5.1.2.2.4.3.4 0 0-.1 0-.2-.1s-.4-.5-.5-.7v-.1z"
            />
            <path className="st96" d="M1586.1 969.3z" />
            <path
              className="st90"
              d="M1586.9 968.4v.2c0 .2-.3.6-.5.7-.1.1-.2.1-.2.1.1 0 .2-.2.3-.4.1-.4.2-.4.4-.6z"
            />
            <path
              className="st87"
              d="M1586.4 966.8v-2.1c0-.1-.1-.2-.2-.2h-.1c-.1 0-.2.1-.2.2v2.1c.1 0 .3-.1.5 0z"
            />
            <path
              className="st91"
              d="M1586.4 966.9h-.6s-.1 0-.1-.1l.1-1.6c0-.1 0-.1.1-.1h.4s.1 0 .1.1l.1 1.6c0 .1 0 .1-.1.1z"
            />
            <path
              className="st97"
              d="M1585.7 967c-.1 0-.1 0-.1-.1v-1.1s0-.1.1-.1c0 0 .1 0 .1.1l-.1 1.2c0-.1 0 0 0 0z"
            />
            <defs>
              <path
                id="SVGID_36_"
                d="M1586.2 966.2h-.3c0 .2.1.4.3.4.2 0 .3-.2.3-.4h-.3z"
              />
            </defs>
            <clipPath id="SVGID_37_">
              <use
                xlinkHref="#SVGID_36_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path
              className="st98"
              d="M1587.3 966.7s.3.1.6.1h-.5l-.1.1-.1-.1.1-.1z"
            />
            <path className="st99" d="m1586.9 966.9.3.1v-.1l-.2-.1z" />
            <path className="st100" d="m1587.3 967.1.4.2.1-.2-.4-.2z" />
            <path className="st101" d="M1587.1 967h.1l.1-.1-.1-.1z" />
            <path className="st102" d="M1587.2 967.1h.1l.1-.1v-.1h-.1l-.1.2z" />
            <path className="st103" d="m1586.6 966.8.2-.1.1.1-.2.2z" />
            <path
              className="st101"
              d="m1586.8 966.8.2.1.1-.2-.2-.1h-.1v.2c-.1 0-.1 0 0 0z"
            />
            <path className="st104" d="M1587.8 967.3v-.1h-.1v.1h.1z" />
            <path
              className="st98"
              d="M1585 966.7s-.3.1-.6.1h.5l.1.1.1-.1-.1-.1z"
            />
            <path className="st99" d="m1585.4 966.9-.2.1-.1-.1.3-.1z" />
            <path className="st100" d="m1585 967.1-.4.2v-.2l.4-.2z" />
            <path className="st101" d="M1585.2 967h-.1v-.1l.1-.1z" />
            <path
              className="st102"
              d="M1585.1 967.1h-.1l-.1-.1v-.1h.1l.1.2c.1 0 0 0 0 0z"
            />
            <path
              className="st105"
              d="M1585.6 966.3v.6c0 .1 0 .1.1.1s.1 0 .1-.1v-.6h-.2z"
            />
            <path
              className="st97"
              d="M1586.6 967c.1 0 .1 0 .1-.1v-1.1s0-.1-.1-.1c0 0-.1 0-.1.1l.1 1.2c-.1-.1 0 0 0 0z"
            />
            <path
              className="st105"
              d="M1586.7 966.3v.6c0 .1 0 .1-.1.1s-.1 0-.1-.1v-.6h.2z"
            />
            <path className="st103" d="m1585.7 966.8-.1-.1-.1.1.1.2z" />
            <path
              className="st106"
              d="M1586.7 966.9c0-.1-.1-.1-.1-.1h-.9s-.1 0-.1.1c0 0 0 .1.1.1l.4.1h.3l.4-.1c-.1.1-.1 0-.1-.1 0 .1 0 0 0 0z"
            />
            <circle className="st97" cx={1585.6} cy={966.9} r={0.1} />
            <path className="st101" d="M1585.7 966.9v.1h-.1v-.2z" />
            <circle className="st97" cx={1586.6} cy={966.9} r={0.1} />
            <path
              className="st101"
              d="M1586.7 966.9v.1h-.1l-.1-.1.1-.1zm-1.1-.1-.2.1-.1-.2.2-.1h.1v.2z"
            />
            <path
              className="st104"
              d="M1584.5 967.3v-.1h.1v.1h-.1c.1 0 0 0 0 0z"
            />
            <path
              className="st100"
              d="m1585.2 966.8-.1-.2-.1-.1h-.3.3c.1 0 .1 0 .1.1l.1.2z"
            />
            <path
              className="st100"
              d="m1584.8 966.6-.5-.1c0-.1.1-.1.1-.1h.3c0 .1.1.2.1.2zm.4.2v.1l-.1-.1.1-.1zm2 0 .1-.2.1-.1h.3-.3s-.1 0-.1.1l-.1.2z"
            />
            <path
              className="st100"
              d="m1587.6 966.6.5-.1c0-.1-.1-.1-.1-.1h-.3c-.1.1-.1.2-.1.2zm-.5.2.1.1v-.2z"
            />
            <circle className="st97" cx={1586.2} cy={967.2} r={0.1} />
            <path
              className="st101"
              d="m1586.2 967.1.1.1-.1.1h-.1l-.1-.1.1-.1z"
            />
            <path
              className="st107"
              d="M1586.3 973s-.1.1-.2.1-.2 0-.2-.1c0 0 .1-.1.2-.1s.2 0 .2.1z"
            />
            <defs>
              <path
                id="SVGID_38_"
                d="M1586.1 973h.2c0-.2-.1-.3-.2-.3s-.2.1-.2.3c.1 0 .1-.1.2 0z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_38_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_39_">
              <use
                xlinkHref="#SVGID_38_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path className="st87" d="M1586.366 973.032h-.4v-.1h.4z" />
            <defs>
              <path
                id="SVGID_40_"
                d="M1586.2 966.2h-.4c0 .3.2.5.4.5s.4-.2.4-.5h-.4z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_40_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_41_">
              <use
                xlinkHref="#SVGID_40_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path className="st87" d="M1585.8 966.1h.8v.1h-.8z" />
            <path
              className="st108"
              d="M1586.6 966.4h-.8c-.1 0-.1.1-.1.2v.1l.1.1h.8l.1-.1v-.1c0-.1-.1-.2-.1-.2z"
            />
            <circle className="st109" cx={1585.9} cy={966.6} r={0.2} />
            <circle className="st110" cx={1585.9} cy={966.6} r={0.2} />
            <circle className="st109" cx={1586.4} cy={966.6} r={0.2} />
            <circle className="st110" cx={1586.4} cy={966.6} r={0.2} />
            <path className="st111" d="M1585.7 966.9h.1v.1h.7v-.1h.1z" />
            <path className="st87" d="M1576.4 971h.3v.1h-.3z" />
            <g />
            <circle className="st88" cx={1576.8} cy={971.2} r={0.1} />
            <defs>
              <path
                id="SVGID_42_"
                d="M1576.8 971.2h-.2c0-.1.1-.2.1-.2s.1.1.1.2c.1 0 0 0 0 0z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_42_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_43_">
              <use
                xlinkHref="#SVGID_42_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path
              className="st87"
              d="M1576.6 971.2h.3v.1h-.3zm-1.152-.026h-.3v-.1h.3z"
            />
            <g />
            <circle className="st88" cx={1575.1} cy={971.2} r={0.1} />
            <defs>
              <path
                id="SVGID_44_"
                d="M1575.1 971.2h.2c0-.1-.1-.2-.1-.2s-.1.1-.1.2c-.1 0-.1 0 0 0z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_44_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_45_">
              <use
                xlinkHref="#SVGID_44_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path className="st87" d="M1575.2 971.22h-.3v-.1h.3z" />
            <path
              className="st89"
              d="M1576.6 969.2c0 .3-.2.5-.4.7-.1.1-.2.1-.4.2v-.1c.1-.1.2-.1.3-.2 0 0 .1-.1.1-.2.1-.1.2-.3.2-.5l.1-1.9v-.1h.1c.1 0 .1 0 .1.1l-.1 2z"
            />
            <defs>
              <path
                id="SVGID_46_"
                d="M1576.8 964.4v.6l.1.2v2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-2l.1-.2v-.6h.2z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_46_"
              style={{
                overflow: "visible",
                fill: "#bdbfc9",
              }}
            />
            <clipPath id="SVGID_47_">
              <use
                xlinkHref="#SVGID_46_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path className="st87" d="M1575.4 964.9h.2v.1h-.2z" />
            <defs>
              <path
                id="SVGID_48_"
                d="M1575.3 964.8h.1c0 .1-.1.2-.1.2-.1 0-.1-.1-.1-.2h.1z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_48_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_49_">
              <use
                xlinkHref="#SVGID_48_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path className="st87" d="M1576.396 964.936h-.2v-.1h.2z" />
            <defs>
              <path
                id="SVGID_50_"
                d="M1576.5 964.8h-.1c0 .1.1.2.1.2s.1-.1.1-.2h-.1z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_50_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_51_">
              <use
                xlinkHref="#SVGID_50_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path
              className="st90"
              d="M1575.6 965.3v-.8c0-.1.2-.1.2-.1h.1s.2 0 .2.1v.8h-.5z"
            />
            <path
              className="st91"
              d="M1575.2 965.8s.1-.9.6-.9h.1c.5 0 .6.9.6.9h-1.3z"
            />
            <path className="st92" d="m1576.4 967.9.1.1v.5l-.1.1v-.7z" />
            <path className="st93" d="m1576.3 967.8.1.1v.7l-.2.2.1-1z" />
            <path className="st92" d="m1575.4 967.9-.1.1v.5l.1.1v-.7z" />
            <path className="st93" d="m1575.5 967.8-.1.1v.7l.2.2-.1-1z" />
            <path
              className="st87"
              d="M1576.7 966.1c0 .2-.1 1-.2 1.4-.1.4-.1 1.2-.1 1.2l-.9-.1s0-.7-.1-1.1c-.1-.4-.2-1.2-.2-1.4 0-.2 0-.5.2-.7.3-.1.7-.1 1 0 .3.3.2.5.3.7z"
            />
            <path className="st94" d="M1575.2 966.8h1.5v.2h-1.5z" />
            <path
              className="st95"
              d="M1576.3 971.7h-.8v.1h.8c.1 0 .1 0 0-.1.1 0 .1 0 0 0z"
            />
            <path
              className="st91"
              d="M1575.9 970.5s.5 0 .6-.4c.1-.3.1-.7.1-.9v-.2c0-.2-.3-.6-.5-.7-.1-.1-.2-.1-.2-.1h-.1s-.1 0-.2.1-.4.5-.5.7v.2c0 .2 0 .6.1.9.3.4.7.4.7.4z"
            />
            <circle className="st12" cx={1575.9} cy={969.7} r={0.3} />
            <circle className="st13" cx={1575.9} cy={969.7} r={0.1} />
            <path className="st96" d="M1575.9 968.3z" />
            <path
              className="st90"
              d="M1575.2 969.2c.1-.2.3-.3.4-.5.1-.2.2-.4.3-.4 0 0-.1 0-.2.1s-.4.5-.5.7v.1z"
            />
            <path className="st96" d="M1575.9 968.3z" />
            <path
              className="st90"
              d="M1576.7 969.2v-.2c0-.2-.3-.6-.5-.7-.1-.1-.2-.1-.2-.1.1 0 .2.2.3.4.1.3.2.4.4.6z"
            />
            <path
              className="st87"
              d="M1576.2 970.8v2.1c0 .1-.1.2-.2.2h-.1c-.1 0-.2-.1-.2-.2v-2.1h.5z"
            />
            <path
              className="st91"
              d="M1576.2 970.7h-.6s-.1 0-.1.1l.1 1.6c0 .1 0 .1.1.1h.4s.1 0 .1-.1l.1-1.6c0-.1-.1-.1-.1-.1z"
            />
            <path
              className="st97"
              d="M1575.4 970.6c-.1 0-.1 0-.1.1v1.1s0 .1.1.1c0 0 .1 0 .1-.1l-.1-1.2c.1.1.1 0 0 0z"
            />
            <defs>
              <path
                id="SVGID_52_"
                d="M1576 971.4h-.3c0-.2.1-.4.3-.4.2 0 .3.2.3.4h-.3z"
              />
            </defs>
            <clipPath id="SVGID_53_">
              <use
                xlinkHref="#SVGID_52_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path
              className="st98"
              d="M1577.1 970.9s.3-.1.6-.1h-.5l-.1-.1-.1.1.1.1z"
            />
            <path className="st99" d="m1576.7 970.7.2-.1.1.1-.2.1z" />
            <path className="st100" d="m1577.1 970.5.4-.2v.1l-.3.2z" />
            <path className="st101" d="m1576.9 970.6.1-.1.1.2h-.1z" />
            <path className="st102" d="M1577 970.5h.1l.1.1v.1h-.1l-.1-.2z" />
            <path className="st103" d="m1576.4 970.7.1.2.2-.1-.2-.2z" />
            <path
              className="st101"
              d="m1576.6 970.7.2-.1.1.2-.2.1h-.1v-.2c-.1.1-.1.1 0 0z"
            />
            <path className="st104" d="M1577.6 970.3v.1h-.1v-.1h.1z" />
            <path
              className="st98"
              d="M1574.8 970.9s-.3-.1-.6-.1h.5l.1-.1.1.1-.1.1z"
            />
            <path className="st99" d="m1575.2 970.7-.2-.1-.1.1.2.1z" />
            <path className="st100" d="m1574.8 970.5-.4-.2v.1l.3.2z" />
            <path className="st101" d="m1575 970.6-.1-.1-.1.2h.1z" />
            <path className="st102" d="M1574.9 970.5h-.1l-.1.1v.1h.1l.1-.2z" />
            <path
              className="st105"
              d="M1575.3 971.3v-.6c0-.1 0-.1.1-.1s.1 0 .1.1v.6h-.2z"
            />
            <path
              className="st97"
              d="M1576.4 970.6c.1 0 .1 0 .1.1v1.1s0 .1-.1.1c0 0-.1 0-.1-.1l.1-1.2c-.1.1 0 0 0 0z"
            />
            <path
              className="st105"
              d="M1576.5 971.3v-.6c0-.1 0-.1-.1-.1s-.1 0-.1.1v.6h.2z"
            />
            <path className="st103" d="m1575.5 970.7-.1.2-.2-.1.2-.2z" />
            <path
              className="st106"
              d="M1576.5 970.6c0 .1-.1.1-.1.1h-.9s-.1 0-.1-.1c0 0 0-.1.1-.1l.4-.1h.3l.4.1c-.1 0-.1.1-.1.1z"
            />
            <circle className="st97" cx={1575.4} cy={970.6} r={0.1} />
            <path className="st101" d="M1575.5 970.7v-.1l-.1-.1v.1l-.1.1h.1z" />
            <circle className="st97" cx={1576.4} cy={970.6} r={0.1} />
            <path
              className="st101"
              d="M1576.5 970.7v-.1l-.1-.1-.1.1v.1h.1zm-1.2 0-.2-.1-.1.2.2.1h.1v-.2c.1.1.1.1 0 0z"
            />
            <path className="st104" d="M1574.3 970.3v.1h.1v-.1h-.1z" />
            <path
              className="st100"
              d="m1575 970.7-.1.2-.1.1h-.3.3c.1 0 .1 0 .1-.1l.1-.2zm-.5.2-.5.1c0 .1.1.1.1.1h.3c.1-.1.1-.1.1-.2zm.5-.2-.1.1zm1.9 0 .1.2.1.1h.3-.3s-.1 0-.1-.1l-.1-.2z"
            />
            <path
              className="st100"
              d="m1577.4 970.9.5.1c0 .1-.1.1-.1.1h-.3c-.1-.1-.2-.1-.1-.2zm-.5-.2.1.1h-.1z"
            />
            <circle className="st97" cx={1575.9} cy={970.4} r={0.1} />
            <path className="st101" d="M1576 970.5v-.2h-.2v.1l.1.1z" />
            <path
              className="st107"
              d="M1576.1 964.6s-.1-.1-.2-.1-.2 0-.2.1c0 0 .1.1.2.1s.2-.1.2-.1z"
            />
            <defs>
              <path
                id="SVGID_54_"
                d="M1575.9 964.6h.2c0 .2-.1.3-.2.3s-.2-.1-.2-.3h.2z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_54_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_55_">
              <use
                xlinkHref="#SVGID_54_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path className="st87" d="M1576.126 964.62h-.4v-.1h.4z" />
            <defs>
              <path
                id="SVGID_56_"
                d="M1576 971.4h-.4c0-.3.2-.5.4-.5s.4.2.4.5h-.4z"
              />
            </defs>
            <use
              xlinkHref="#SVGID_56_"
              style={{
                overflow: "visible",
                fill: "#d6d8e6",
              }}
            />
            <clipPath id="SVGID_57_">
              <use
                xlinkHref="#SVGID_56_"
                style={{
                  overflow: "visible",
                }}
              />
            </clipPath>
            <path className="st87" d="M1575.5 971.3h.8v.1h-.8z" />
            <path
              className="st108"
              d="M1576.3 971.2h-.8c-.1 0-.1-.1-.1-.2v-.1l.1-.1h.8l.1.1v.1c0 .1 0 .1-.1.2z"
            />
            <circle className="st109" cx={1575.7} cy={970.9} r={0.2} />
            <circle className="st110" cx={1575.7} cy={970.9} r={0.2} />
            <circle className="st109" cx={1576.2} cy={970.9} r={0.2} />
            <circle className="st110" cx={1576.2} cy={970.9} r={0.2} />
            <path className="st111" d="M1575.5 970.7h.1v-.1h.6l.1.1z" />
            <path
              className="st34"
              d="M1467.8 914.7h-4.7c-.2 0-.4-.2-.4-.4v-4.6c0-.2.2-.4.4-.4h4.7c.2 0 .4.2.4.4v4.6c0 .2-.2.4-.4.4z"
            />
            <path
              className="st13"
              d="M1467.7 914.4h-4.5c-.1 0-.3-.1-.3-.3v-4.3c0-.2.1-.3.3-.3h4.5c.1 0 .3.1.3.3v4.3c0 .2-.2.3-.3.3zm-4.5-4.8c-.1 0-.1.1-.1.2v4.3c0 .1.1.2.1.2h4.5c.1 0 .1-.1.1-.2v-4.3c0-.1-.1-.2-.1-.2h-4.5z"
            />
            <path
              className="st13"
              d="M1466.1 910.7c.2.1.3.2.4.4.1.2.1.3.1.6 0 .2 0 .4-.1.6-.1.2-.2.3-.4.4-.2.1-.4.1-.6.1h-.4v.8h-.7v-2.9h1.1c.2-.2.4-.1.6 0zm-.3 1.2c.1-.1.1-.2.1-.3 0-.1 0-.2-.1-.3-.1-.1-.2-.1-.3-.1h-.4v.8h.4c.1 0 .2 0 .3-.1z"
            />
            <circle className="st10" cx={1568} cy={960.3} r={1.6} />
            <circle className="st13" cx={1568} cy={960.3} r={1.5} />
            <path className="st10" d="M1567 960h1.9v.6h-1.9z" />
            <circle className="st10" cx={1575.9} cy={960.3} r={1.6} />
            <circle className="st13" cx={1575.9} cy={960.3} r={1.5} />
            <path className="st10" d="M1575 960h1.9v.6h-1.9z" />
            <circle className="st10" cx={1594.1} cy={960.3} r={1.6} />
            <circle className="st13" cx={1594.1} cy={960.3} r={1.5} />
            <path
              className="st10"
              d="m1594.7 959.7-.6-.6-.6.6v.4l.4-.2v1.6h.5v-1.6l.3.2z"
            />
            <circle className="st10" cx={1586.2} cy={960.3} r={1.6} />
            <circle className="st13" cx={1586.2} cy={960.3} r={1.5} />
            <path
              className="st10"
              d="m1586.7 959.7-.6-.6-.6.6v.4l.4-.2v1.6h.5v-1.6l.3.2z"
            />
            <circle className="st10" cx={1487.2} cy={904.6} r={3.5} />
            <circle className="st13" cx={1487.2} cy={904.6} r={3.2} />
            <path
              className="st10"
              d="m1488.3 903.1-1.5-1-1.1 1.4.2.8.7-.4.5 3.2 1-.2-.5-3.2.8.2z"
            />
            <circle className="st10" cx={1505.4} cy={914.7} r={3.5} />
            <circle className="st13" cx={1505.4} cy={914.7} r={3.2} />
            <path
              className="st10"
              d="m1504.6 916.3-1.6-.8.8-1.6.7-.3v.8l3.1-1 .3 1-3.1 1 .5.7z"
            />
            <circle className="st10" cx={1581.3} cy={891.9} r={5.5} />
            <circle className="st13" cx={1581.3} cy={891.9} r={5} />
            <path
              className="st10"
              d="M1581.5 889.5h-1.4l.3-.8h-.7l-1.2 1.3 1.2 1.3h.7l-.3-.8h1.4c.5 0 .9.4.9.9v3.7h1v-3.7c0-1-.9-1.9-1.9-1.9z"
            />
            <circle className="st10" cx={1481.2} cy={882.2} r={4.4} />
            <circle className="st13" cx={1481.2} cy={882.2} r={4} />
            <path
              className="st10"
              d="M1481.3 880.3h-1.1l.2-.6h-.6l-1 1 1 1h.6l-.2-.6h1.1c.4 0 .7.3.7.7v3h.8v-3c.1-.9-.6-1.5-1.5-1.5z"
            />
            <path
              className="st34"
              d="m1576.4 955.8-.4.4-.4-.4h-.4l1 1 1-1h-.8zm10.9.7-1-1-1 1h.4l.4-.4.4.4h.8zm-3.7-7.4h-1.3v1.3l.3-.3v-.7h.7l.3-.3zm-4.9-3.7h-1.3v1.3l.3-.3v-.7h.7l.3-.3zm.5-7.5.1-1.3-1.3-.1.3.3h.7v.7l.2.4zm4.9-3.6.1-1.3-1.3-.1.3.3h.7v.7l.2.4zm2-8.4-1.3-.4-.4 1.3.4-.2.2-.7.7.2.4-.2zm-8.9 5.9v.7h-.7l-.3.3h1.3v-1.3l-.3.3zm7.6 6v.7h-.7l-.3.3h1.3v-1.3l-.3.3zm-.8 8.9h-.7v-.7l-.3-.3-.1 1.3 1.3.1-.2-.4zm-4-26-1.3.3.3 1.3.2-.4-.1-.7.7-.1.2-.4zm-3.3-4.2-.8-1.1-1.1.8.4.1.5-.3.3.5h.7zm4.4-4.1.9-1.1-1.1-.9v.5l.5.4-.4.5.1.6zm2.9 6.8-.2 1.3 1.3.2-.3-.4-.7-.1.1-.7-.2-.3zm-6.7 5.1-.2 1.3 1.3.2-.3-.4-.7-.1.1-.7-.2-.3z"
              id="Bike_Arrow"
            />
            <g id="Car_Arrow">
              <path
                className="st34"
                d="m1595.3 930.4-1.2-.7-1.2.7 1.2-2.7 1.2 2.7z"
              />
              <path className="st112" d="m1595.3 930.4-1.2-2.7v2.1l1.2.6z" />
              <path
                className="st34"
                d="m1595.1 893.4-1.2-.7-1.2.7 1.2-2.7 1.2 2.7z"
              />
              <path className="st112" d="m1595.1 893.4-1.2-2.7v2.1l1.2.6z" />
              <path
                className="st34"
                d="m1539.3 873.9-.7 1.2.7 1.2-2.7-1.2 2.7-1.2z"
              />
              <path className="st112" d="m1539.3 873.9-2.7 1.2h2.1l.6-1.2z" />
              <path
                className="st34"
                d="m1516.4 873.9-.7 1.2.7 1.2-2.7-1.2 2.7-1.2z"
              />
              <path className="st112" d="m1516.4 873.9-2.7 1.2h2.1l.6-1.2z" />
              <path
                className="st34"
                d="m1503.2 949.5-2.9.9.8-1.1-.5-1.3 2.6 1.5z"
              />
              <path className="st112" d="m1501.1 949.2 2.1.3-2.6-1.5.5 1.2z" />
              <path className="st34" d="m1533.4 950.5.7-1.1-.5-1.3 2.7 1.3z" />
              <path className="st112" d="M1536.3 949.4h-2.2l-.5-1.3z" />
              <path
                className="st34"
                d="m1534.3 934.1 1.3 2.7-1.3-.7-1.2.8 1.2-2.8z"
              />
              <path
                className="st112"
                d="m1534.3 936.2-.1-2.1-1.2 2.7 1.3-.6z"
              />
              <path
                className="st34"
                d="m1538.8 903 2.3 1.9-1.4-.1-.8 1.1-.1-2.9z"
              />
              <path className="st112" d="m1539.6 904.9-.9-1.9.1 3 .8-1.1z" />
              <path className="st34" d="m1546.4 902.3 1.1-1-.2-1.5 2.1 2.1z" />
              <path className="st112" d="m1549.4 901.9-1.9-.6-.2-1.5z" />
              <path className="st34" d="m1569 922-1.1 2.8-1.4-2.6 1.3.6z" />
              <path className="st112" d="m1569 922-1.1 2.8-.1-2z" />
              <path className="st34" d="m1569.2 956.2-1.2 2.8-1.2-2.8 1.2.7z" />
              <path className="st112" d="m1569.2 956.2-1.2 2.8v-2.1z" />
              <path
                className="st34"
                d="m1547.6 955.2-2.9-.8 1.3-.5.3-1.4 1.3 2.7z"
              />
              <path className="st112" d="m1546 953.9 1.6 1.3-1.3-2.7-.3 1.4z" />
              <path
                className="st34"
                d="m1482.8 873.8-.7 1.2.7 1.2-2.7-1.2 2.7-1.2z"
              />
              <path className="st112" d="m1482.8 873.8-2.7 1.2h2.1l.6-1.2z" />
              <path
                className="st34"
                d="m1463.4 878.9.3 1.4 1.3.4-2.9 1 1.3-2.8z"
              />
              <path
                className="st112"
                d="m1463.4 878.9-1.2 2.9 1.5-1.4-.3-1.5z"
              />
              <path className="st34" d="m1459.4 920.5-1.4 2.7-1.2-2.9 1.2.8z" />
              <path className="st112" d="M1458 921.1v2.1l-1.2-2.9z" />
              <path
                className="st34"
                d="m1466.5 939.7 1.2-.8-.1-1.4 1.9 2.3-3-.1z"
              />
              <path className="st112" d="M1466.5 939.7h3l-1.8-.8-1.2.8z" />
              <path className="st34" d="m1483 941.8.1-1.4-1.1-.9h3l-2 2.3z" />
              <path className="st112" d="m1483 941.8 2-2.3-1.9.9-.1 1.4z" />
              <path
                className="st34"
                d="m1497.8 920.9-1.4-.3-1 1.1.5-3.1 1.9 2.3z"
              />
              <path className="st112" d="m1497.8 920.9-2-2.3.6 2 1.4.3z" />
              <path
                className="st34"
                d="m1474.8 931.8 1.4.1.8-1.2.1 3-2.3-1.9z"
              />
              <path className="st112" d="m1474.8 931.8 2.3 1.9-.9-1.9h-1.4z" />
              <path
                className="st34"
                d="m1493.5 905.6-1.4-.3-1 1.1.5-3.1 1.9 2.3z"
              />
              <path className="st112" d="m1493.5 905.6-2-2.3.6 2 1.4.3z" />
              <path
                className="st34"
                d="m1501.4 887.3-.1.1-2.2 1.4-.2.2.4-1.3-.8-1.1z"
              />
              <path
                className="st112"
                d="m1501.4 887.3-.1.1-2.2 1.4-.2.2.4-1.3z"
              />
              <path
                className="st34"
                d="m1510.6 892.9 1.4.2 1-1.1-.3 3-2.1-2.1z"
              />
              <path
                className="st112"
                d="m1510.6 892.9 2.1 2.1-.7-1.9-1.4-.2z"
              />
              <path
                className="st34"
                d="m1503.7 908.8-.4 1.3 1 1.1-3-.7 2.4-1.7z"
              />
              <path className="st112" d="m1503.7 908.8-2.4 1.8 2-.4.4-1.4z" />
              <path className="st34" d="m1487 913-.4 1.3 1.1 1-3-.5 2.3-1.8z" />
              <path className="st112" d="m1487 913-2.3 1.9 1.9-.6.4-1.3z" />
            </g>
          </g>
          <g id="People">
            <path className="st113" d="M1097.7 993.4h1v.8h-1z" />
            <path
              d="M1097.7 994.2h1.1v1.1h-2.6s-.2-.3.4-.6c.4-.3 1.1-.5 1.1-.5z"
              style={{
                fill: "#dd3131",
              }}
            />
            <path
              d="M1096.2 976.6s.4 6.5.4 8.5c-.1 2.2.9 8.6.9 8.6h1.2s1.3-6.4 1.5-8.5c.3-3.6.5-8.6.5-8.6h-4.5z"
              style={{
                fill: "#3c7edd",
              }}
            />
            <path
              className="st113"
              d="M1100.6 956.8c-1.1-1.8-4.1-1-3.9 1.5v1.1c0 .1 0 .2-.1.4s.1.2.2.2.2-.1.2-.1v.1c.1.2.1.4.2.5.3.6.8.6 1.2.6v1.4l1.6-.3s-.5-.7-.5-1.1c0-.2.4-.5.5-.6.3-.3.5-.6.7-1.1.4-1.2.3-1.9-.1-2.6zm-1 36.6h1v.8h-1z"
            />
            <path
              className="st10"
              d="M1099.5 994.2h1.1v1.1h-2.6s-.2-.3.4-.6c.5-.3 1.1-.5 1.1-.5z"
            />
            <path
              className="st34"
              d="M1098.1 976.6s.4 6.5.4 8.5c-.1 2.2.9 8.6.9 8.6h1.2s1.3-6.4 1.5-8.5c.3-3.6.5-8.6.5-8.6h-4.5z"
            />
            <path
              className="st10"
              d="M1100.1 962s1.8.7 2.3 4.8.6 12.4.6 12.4h-6.6s-.8-6.5.7-10.9l1.4-5.9 1.6-.4z"
            />
            <path
              className="st34"
              d="M1106.6 968.8c0-1.4-.5-3.4-1.3-3.5-.5 0-1.4 0-1.6.9-.2 1.1-1.1 5.1-1.3 6.2-.3 1.4 1 1.9 1.7 1.9h.8c.8 0 1.5-.4 1.5-1.1.2-1.5.2-3.4.2-4.4z"
            />
            <path
              className="st34"
              d="M1103 973.7c-4.7-.3-5.8-3.6-6.4-5.2-1.1-3.1.5-4.9 1.2-5.5 1-.9 2-.2 3 .6l.3.2c1.6 1.1 3 2.2 3.1 2.2l-.3.4s-1.4-1.1-3-2.2l-.3-.2c-1.1-.8-1.7-1.2-2.3-.6-.6.6-2 2.1-1 4.9.5 1.6 1.6 4.6 5.9 4.9l-.2.5z"
            />
            <path
              className="st116"
              d="m1089.286 962.937.612-.34 1.31 2.36-.612.34z"
            />
            <path
              className="st113"
              d="M1093.7 968.9c.2.4.1.9-.3 1.2-.4.2-.9.1-1.2-.3 0 0-.7-1.3-.9-1.7-.3-.6-.9-2.4-.9-2.4l.4-.3s.9 1.4 1.3 1.8c.4.4 1.6 1.7 1.6 1.7z"
            />
            <path
              className="st113"
              d="M1090.4 965.7s-1.1-.5-1-1.8c0-.3.4-.3.6.4.1.4.5.9.5.6 0-.1.1-.4.2-.4.2 0 .1.9.1.9l-.4.3z"
            />
            <path
              className="st10"
              d="M1098.9 962.5c-1-.5-2 1.4-3.1 3.3-.3.6-1.2 1.9-1.8 2.6-.5.6-1.1-.2-1.3-.6-.4-.6-1.7-2.3-1.7-2.3l-.7.4s1.3 5.1 3.3 5.5c.4.1 1-.2 1.6-.6.6-.5 1.5-1.1 2-1.9 1.7-2.5 3.3-5.6 1.7-6.4z"
            />
            <path
              className="st116"
              d="M1100.8 956.7c-.8-1.1-2.1-1-2.7-.9-.5.1-1.1.5-1.4 1.4 0 .1-.1.4-.1.6 0 0-.1.4.3.4s.5-.6.9-.4c.5.2.4.9 1 1 .1 0 .4-.1.4-.4 0-.2.5-.1.5.2 0 .2-.1.9-.4.7-.2-.2-.6.2-.2.5.3.2 0 .8.5.8.3 0 1-.3 1.3-1 .4-.5.8-1.7-.1-2.9z"
            />
            <path
              className="st10"
              d="M1101 956.8s-.4-.7-.7-1.1c-.4-.5-1.2-.6-2-.3l-1.1.5c-.6.2-.9.6-1 1.7v1l-.9.4c-.1.1-.2.2-.1.3 0 .1.2.2.3.1l5.4-2.3c.1-.1.1-.2.1-.3z"
            />
            <path
              className="st113"
              d="m1420.8 1064.4-.1.4-.1.4c0 .3-.1.5-.1.8-.1.5-.1 1-.2 1.5 0 .5-.1 1-.1 1.5v.7c0 .2 0 .5.1.6.1.4-.1.8-.6 1-.4.1-.8-.1-.9-.5-.1-.3-.2-.6-.2-.9s-.1-.6-.1-.9v-1.7c0-.5.1-1.1.1-1.6 0-.3 0-.5.1-.8v-.4c0-.1 0-.3.1-.4.1-.5.6-.9 1.1-.8.7 0 1 .5.9 1.1 0-.1 0-.1 0 0zm-6.9 0-.1.4-.1.4c0 .3-.1.5-.1.8-.1.5-.1 1-.2 1.5 0 .5-.1 1-.1 1.5v.7c0 .2 0 .5.1.6.1.4-.1.8-.6 1-.4.1-.8-.1-.9-.5-.1-.3-.2-.6-.2-.9s-.1-.6-.1-.9v-1.7c0-.5.1-1.1.1-1.6 0-.3 0-.5.1-.8v-.4c0-.1 0-.3.1-.4.1-.5.6-.9 1.1-.8.6 0 1 .5.9 1.1 0-.1 0-.1 0 0z"
            />
            <path
              className="st117"
              d="M1408.9 1009.3v-1.1c0-.4 0-.8.1-1.2v-2.5c.1-.7.7-1.3 1.5-1.2.5 0 1 .4 1.1.8l.2.5v.4l.1.6.2 1.2c.1.4.1.8.2 1.3 0 .2.1.4.1.7v.8c-.2 1-1.1 1.8-2.2 1.6-.8-.1-1.4-.8-1.6-1.5l.3-.4z"
            />
            <path
              className="st118"
              d="M1415.2 1037.1v9.7l-.1 2.4-.1 2.4v2.4c-.1 1.6-.1 3.2-.2 4.8l-.1 1.2-.1 1.2c-.1.8-.1 1.6-.2 2.4-.1.8-.1 1.6-.2 2.4 0 .2 0 .4-.1.6 0 .2 0 .4-.1.6l-.1.6-.1.3c0 .1 0 .1-.1.2-.1 0-.1.1-.3.1-.6.1-1.2 0-1.8-.2l-.2-.1c-.2-.1-.2-.1-.3-.2-.1-.1 0-.1 0-.1v-2c0-.8-.1-1.5-.1-2.3-.1-1.6-.2-3.1-.4-4.7-.1-1.6-.3-3.1-.4-4.7l-.2-2.4-.2-2.4-.6-5.8-.3-2.9-.1-.8-.2-2.4c-.1-.8-.2-1.6-.2-2.3v-4.8c0-1.8 1.5-3.2 3.3-3.2 1.6 0 2.9 1.1 3.2 2.6l.1.3c0 .1 0 .2.1.4.1.3.1.5.1.8l.1.6c0 .2 0 .4.1.6 0 .2 0 .4.1.6v1.8c-.3.8-.3 1.6-.3 2.3z"
            />
            <path
              className="st118"
              d="M1424.2 1047.8v1.5l-.4 2.4-.4 2.3-.2 1.2-.2 1.2c-.1.8-.2 1.5-.4 2.3-.1.8-.2 1.5-.3 2.3l-.2 1.2-.2 1.1-.1.6-.1.6-.2 1.1-.2 1.1c0 .2-.1.4-.1.6v.4h-2.4c-.1 0-.2-.1-.2-.1l-.1-.1v-2.2c0-.4 0-.8.1-1.2v-1.2l.1-1.2.1-1.2c.1-.8.1-1.6.2-2.3.1-.8.1-1.6.2-2.3 0-.4.1-.8.1-1.2l.1-1.2c0-.4.1-.8.1-1.2v-4.2l-.3-.9c-.2-.6-.5-1.2-.9-1.8-.3-.5-.7-1.1-1.1-1.6l-.1-.1-1.2-1.8c-.1-.2-.2-.4-.4-.5-.1-.1-.2-.3-.3-.4-.2-.4-.5-.8-.7-1.2-.1-.1-.1-.2-.2-.3-.3-.5-.5-1-.7-1.5-.2-.4-.3-.7-.4-1.1-.1-.4-.2-.8-.2-1.2 0-.4 0-.9.1-1.4 0-.1.1-.2.1-.4l.1-.2v-.2c.1-.2.2-.5.3-.8l1.1-1.9.5-1c.7-1.2 2.2-1.6 3.3-.9.6.4 1 1 1.2 1.6.3 1.4.8 2.9 1.3 4.4.3 1 .7 2 1 3.1.2.5.3.9.5 1.4.1.4.2.8.4 1.2l.2.6.2.6c.2.8.4 1.6.6 2.5.1.4.2.9.2 1.4 0 .4.1.8.1 1.2v.9z"
            />
            <path
              className="st119"
              d="M1415.5 1041.1c-.1-.1-.2-.3-.3-.4v4.4c-1-.7-2.8-2.1-3.5-2.2-.8-.2-1.8-.3-2.5.7l-.3-2.9 1-1.1h5.4c0-.1.1.6.2 1.5z"
            />
            <path
              className="st119"
              d="M1424.1 1045.2c-.8-1.1-2.2-2.6-3.8-3.1-1.1-.4-2.5-.2-3.1 1.5l-.1-.1-1.2-1.8c-.1-.2-.2-.4-.4-.5-.1-.1-.2-.3-.3-.4v1.5l-.5-.4-.4-2.2-.1-.3.9-.2 6.9-1.4c.2.5.3.9.5 1.4.1.4.2.8.4 1.2l.2.6.2.6c.2.8.4 1.6.6 2.5 0 .2.1.6.2 1.1z"
            />
            <path
              className="st113"
              d="M1409.4 1027c0 .3-.1.6-.3.9-.5.7-1.5.9-2.2.4l-.8-.6c-.2-.2-.5-.3-.7-.5-.5-.3-.9-.7-1.4-1.1-.5-.4-.9-.8-1.4-1.2-.2-.2-.5-.5-.7-.8l-.1-.1v-.2c-.1-.1-.1-.2-.2-.3s-.1-.3-.2-.5-.1-.4-.1-.5v-.7c0-.2 0-.4.1-.5 0-.3.1-.6.2-1 .1-.6.3-1.2.5-1.7.2-.6.3-1.1.5-1.7.1-.3.2-.5.3-.8l.1-.4.2-.4c.3-.8 1.2-1.2 2-.9.7.3 1.1.9 1 1.6v.5c0 .1 0 .3-.1.4 0 .1-.1.3-.1.4-.1.3-.1.5-.2.8-.2.5-.3 1-.5 1.5l-.1.2-.1.2-.1.4c0 .1-.1.2-.1.4 0 .1-.1.2-.1.4-.1.2-.1.5-.2.7 0 .1 0 .2-.1.3v.1c.1 0 .1.1.2.2s.2.2.2.3c.3.3.7.7 1.2 1 .3.2.6.5.9.7.1.1.3.2.4.3.2.2.4.3.7.5l.3.2.3.2c.4.3.7.8.7 1.3z"
            />
            <path
              className="st120"
              d="M1407 1024.5c-.7-.3-1.9-.7-2.7-.6-.9.1-1.6.4-1.7 1v.1c-.2-.3-.5-.5-.7-.8l-.1-.1v-.2c-.1-.1-.1-.2-.2-.3s-.1-.3-.2-.5v-.1l.8-.5 2.3-.2c.1 0 .1.1.2.2s.2.2.2.3c.3.3.7.7 1.2 1 .3.2.6.5.9.7z"
            />
            <path
              className="st121"
              d="M1404.7 1010.7c2-3 9.8-5 14.1-1.4.3 6.7-.3 14.2-.3 14.2l5.5 14.5s-9.2 6.7-16.4 3c-2.4-1.2.6-15.5.3-16.6s-3.2-13.7-3.2-13.7z"
            />
            <path
              className="st122"
              d="m1423.9 1037.9-5.5-14.5s.1-.9.1-2.3c-.3-.9-.8-2.5-1.1-5.1-.1.3-.9 1.4-.9.9 0-3.6.4-6.5 1-7.6.1-.2.2-.3.4-.3.1 0 .2-.1.2-.2-.1-.1-.2-.1-.3-.2-.2.1-.4.2-.6.5-.9 1.5-1.2 6.1-.9 10.5-.7 2.2-1.3 4.7-.6 5.7 1.2 1.9 3.5 6.4 3.8 8.1.2 1.6 1.4 4.3.8 6.5 2.2-.9 3.6-2 3.6-2zm-15.9-22.1c1.6 3.9 3.4 4.2 4.4 3.8s2.1-3.4 2.7-5.8c.6-2.4.5-4.7 1.1-5.2s-.3-.8-.3-.8l-.9-.2s-4.3 4.7-4.2 4.7l-2.8 3.5z"
            />
            <path
              className="st123"
              d="M1414.9 1002.4c0 1.7 1.4 6.7.6 10-1.3 5.5-3.7 6.5-5.2 6.7-1.9.2-3.6-6.5-4.2-7.8-1.4-3 1.2-8.8 1.2-10.4 0-2.2 1.3-3.8 2.9-4 4.1-.4 4.7 3.3 4.7 5.5z"
            />
            <path
              className="st121"
              d="M1411.4 1069.5c-.5.8-.3 2.5-.3 2.5h5.3s.7-.4.2-.8c-.5-.3-1.9-.9-2.2-1.2-.1-.1.7-.5.4-.7s-.8-.4-1.1 0c-.3.4-.6.5-.8.6-.2.1-.1-.2-.6-.5-.5-.2-.9.1-.9.1zm6.8 0c-.5.8-.3 2.5-.3 2.5h5.3s.7-.4.2-.8c-.5-.3-1.9-.9-2.2-1.2-.1-.1.7-.5.4-.7-.3-.2-.8-.4-1.1 0-.3.4-.6.5-.8.6-.2.1-.1-.2-.6-.5-.4-.2-.9.1-.9.1zm-11.7-51.4-.7 3.1-.4 1.6s-.5.2-1.2.4c-.8.3-1.9.7-2.7.9l-.6-1.2c0-.1 0-.5.1-1.2.4-2.5 1.7-8 1.9-8.9.3-1.1 1.6-2.6 2.5-2.5.8.2 1.1 7.8 1.1 7.8z"
            />
            <path
              className="st124"
              d="M1406.1 1021.5v.4c0 .4-.1.9-.5 1-.2.1-.8.3-1.5.5-1.1.3-2.5.7-2.5.7s-.2.3-.9-.2-.5-2.3.3-2.2h.1s2.4-.5 3.1-.6h.2c.4 0 1 0 1.3.1.3.1.4.2.4.3z"
            />
            <path
              className="st122"
              d="M1406.1 1021.6v.3c0 .4-.1.9-.5 1-.2.1-.8.3-1.5.5 0 0 .1-.1.1-.2.6-1 0-1.7 0-1.7l.2-.4c.5-.9 1.7-3.3 1.7-4.6.2.6.3 1.3.4 1.7l-.7 3v.1c.2.1.3.2.3.3z"
            />
            <path
              className="st125"
              d="M1418.9 1031.3c-.2 0-.4-.2-1.9-4.7-.7-2.2-1.1-5.8-1-9.7 0-3 .3-6.6 1.1-8 .2-.3.4-.5.6-.5.1 0 .2 0 .2.1s0 .2-.1.2-.3.2-.4.4c-.6 1.1-1.1 4.1-1.1 7.8 0 3.9.3 7.4 1 9.6 1.1 3.4 1.5 4.2 1.6 4.4.1 0 .2.1.1.2.1.1 0 .2-.1.2z"
            />
            <path
              className="st125"
              d="m1425.2 1034.5-3.8 1.6h-1.5c-.4 0-.8-.3-.8-.7l-.6-3.5c-.1-.4.2-.9.6-1l4.3-1.6c.3-.1.7 0 .8.4l1.4 3.8c.1.4-.1.9-.4 1z"
            />
            <path
              className="st113"
              d="M1423.3 1029.8v.9c0 .5-.4.8-.8.9-.4 0-.8-.3-.8-.7v-.2c-.1-.5-.2-1.1-.4-1.6-.1-.3-.1-.5-.2-.8-.1-.3-.1-.5-.2-.8-.1-.5-.3-1.1-.5-1.6-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.3-.8 0-.1-.1-.2-.1-.3v-.1c0-.1-.1-.3-.1-.5v-4.3c0-.3.1-.6.1-.9.1-.6.7-1.1 1.3-1 .3-.1.7.2.8.7 0 .1 0 .1.1.2v.2c0 .1.1.3.1.4 0 .1.1.3.1.4l.1.4v.4l.1.4v.8c0 .3 0 .6.1.9v.6c0 .1 0 .2.1.4l.1.4c.1.3.1.6.2.9l.3 1.8.2 1.8c0 .3.1.6.1.9 0 .3.1.6.1.9 0 .3 0 .6.1.9z"
            />
            <path
              className="st120"
              d="M1423 1027.1c0 .1 0 .1 0 0-.2-1.1-.6-2.8-1-3.3-.6-.7-1.6-1-2.6-.6v-.1c0-.1-.1-.3-.1-.5v-2l2.7-.3c.1.3.1.6.1.9v.6c0 .1.1.3.1.4l.1.4c.1.3.1.6.2.9l.3 1.8.2 1.8z"
            />
            <path
              className="st121"
              d="m1423 1022-.8-.3-4-1.6v-.1l-.5-2.2-.2-7.7c0-.4.3-.8.7-.8.6-.1 1.6 0 2.2.5.2.2.5.8.8 1.6.9 2.5 1.9 6.8 2.2 8 0 .1.1.2.1.3.2.7-.5 2.3-.5 2.3z"
            />
            <path
              className="st124"
              d="M1423.5 1022.3c-.1.1-.8.2-1.7.3-1.5.1-3.4.3-3.5.1-.3-.2-.2-2-.1-2.7v-.1s2.6-.1 3.5-.4h.1c.5-.2 1.1-.2 1.6-.1.4.1.7.2.8.5.2.6-.2 2.2-.7 2.4z"
            />
            <path
              className="st122"
              d="M1423.5 1022.3c-.1.1-.8.2-1.7.3.2-.2.3-.5.4-.9.2-.8.1-1.8-.5-2.2 0 0-.1 0-.1-.1.3-2-.1-6-.4-8.1.9 2.5 1.9 6.8 2.2 8 .4.1.7.2.8.5.2.7-.2 2.3-.7 2.5z"
            />
            <path
              className="st113"
              d="M1423.1 1030.3c.3.7.9 1.1 1.2 1.6.2.5.1 1.7 0 2.4-.2.9-1 1.7-1.6 1.4-.2-.1.1-1.5-.3-1.7-.4-.3-1.1-1.3-1.1-2.3s.5-1.5.5-1.5l1.3.1zm13-30.3c.6 1 1.1 2.3 1 3.6 0 .4 1.5-1.2 1.6-1.5s-1-2.7-1-2.7l-1.6.6zm4.4-5.7c1.8 1.3 1.6 5.4 1.4 6.2s-2.2 1.2-2.2 1.2.1-3.6.2-3.8c.1-.3.6-3.6.6-3.6z"
            />
            <path
              className="st117"
              d="M1436.5 998.9c.2.6.2 1.1 0 1.1s-.5-.3-.7-.9c-.2-.6-.2-1.1 0-1.1.6-.1.5.4.7.9z"
            />
            <path
              className="st113"
              d="M1451.8 1062.3c.1.3.1.6.2.9l.2.9c.2.6.3 1.1.5 1.7.2.6.3 1.1.5 1.7l.1.4.2.4c.1.1.1.2.2.4v.1l.1.2v.1c.2.5 0 1.1-.4 1.3s-1 .1-1.2-.3l-.2-.2-.1-.1v-.2c-.1-.1-.2-.3-.3-.4l-.2-.4-.2-.4c-.3-.6-.5-1.1-.8-1.7-.3-.6-.5-1.1-.7-1.7l-.3-.8-.3-.9c-.3-.7.1-1.6.8-1.9s1.6.1 1.9.9c0-.1 0-.1 0 0zm-15.5 1.4c0 .1-.1.2-.1.4l-.1.4c-.1.3-.1.5-.2.8-.1.5-.3 1-.4 1.6l-.3 1.5c0 .1 0 .3-.1.4v1.2c0 .5-.4 1-1 1-.5 0-.9-.4-1-.8 0-.2-.1-.3-.1-.5v-1.3c0-.6 0-1.2.1-1.7 0-.6.1-1.1.1-1.7 0-.3.1-.6.1-.8l.1-.4c0-.1 0-.3.1-.4.1-.8.9-1.3 1.7-1.2.8.1 1.3.9 1.2 1.7-.1-.4-.1-.3-.1-.2zm.7-57.5v-1.1c0-.4 0-.8.1-1.2l.1-1.3v-1.4c.1-.8.7-1.4 1.5-1.3.5 0 1 .4 1.2.9l.2.6v.1l.1.3.1.6.2 1.3c.1.4.1.9.2 1.3 0 .2.1.4.1.7v.8c-.2 1.1-1.2 1.8-2.2 1.7-.9-.1-1.5-.8-1.6-1.6v-.4zm-6 11.6v-.3c0-.1.1-.3.1-.5.1-.2.1-.3.2-.5.1-.4.3-.7.5-1.1.3-.8.7-1.5 1.1-2.3s.8-1.5 1.2-2.3l1.3-2.3c.2-.2.4-.5.4-.9 0-.6-.4-1.3-1.1-1.8-1.1-.7-2.5-.3-3.2.8l-.1.2-.1.1-.2.3-.3.6-.6 1.2c-.4.8-.8 1.7-1.2 2.5-.4.9-.7 1.7-1 2.7-.2.5-.3.9-.4 1.4-.1.3-.1.5-.2.8s-.1.6-.1.9v1.3c.1.2.1.4.2.5s.1.3.2.4l.3.6c.1.2.2.4.4.6.5.8 1 1.6 1.5 2.3s1.1 1.5 1.6 2.2c.6.7 1.1 1.4 1.7 2.1.2.3.6.4 1 .2.5-.2.7-.7.5-1.1-.5-1.1-.9-2.2-1.4-3.3-.1-.3-.2-.5-.3-.8-.1-.3-.3-.6-.4-.9-.4-.8-.7-1.6-1.1-2.4-.2-.3-.2-.6-.4-.9 0-.1-.1-.1-.1-.3 0 .1 0 .1 0 0 0 .1 0 0 0 0zm28.5-25.9v.8c0 .2-.1.5-.1.7-.1.5-.2.9-.3 1.4-.1.4-.2.9-.3 1.3 0 .1 0 .2-.1.2-.1.4-.2.7-.3 1.1-.1.4-.3.9-.4 1.3-.1.4-.3.9-.5 1.3s-.3.9-.6 1.3c-.1.1-.1.2-.2.3s-.1.2-.2.4c0 0 0 .1-.1.1 0 0 0 .1-.1.1l-.1.1-.1.1c-.1.1-.2.2-.2.3l-.1.1c-.3.3-.5.6-.8.9-.3.3-.6.7-.9 1-.6.6-1.2 1.3-1.9 1.9-.6.6-1.2 1.3-1.9 1.9-.3.3-.6.6-.9 1l-.5.5-.5.5c-1.1 1.2-2.9 1.2-4.1.1-1.2-1.1-1.2-2.9-.1-4.1.2-.2.3-.3.5-.4l.2-.2 1.1-.7 1.1-.7c.7-.5 1.4-.9 2.1-1.4l2.1-1.5c.3-.2.7-.5 1-.7s.6-.5.9-.7l.2-.2.1-.1c0-.1.1-.1.2-.2.2-.3.4-.6.6-1 .4-.7.8-1.4 1.1-2.2.4-.7.7-1.5 1-2.3.1-.4.3-.8.4-1.1.1-.4.2-.8.2-1.1v-.1c.1-.6.6-1 1.2-.9.9-.1 1.3.4 1.3.9z"
            />
            <path
              className="st123"
              d="M1453 1065.4c-.1.1-.2.2-.3.2l-.1.1h-.3l-.1.1c-.1 0-.2.1-.2.1-.3.1-.7.2-1 .3h-1.3c-.1 0-.1-.1-.1-.1l-.1-.2-.1-.3-.1-.3c-.1-.2-.1-.4-.2-.6-.1-.2-.1-.4-.2-.6l-.3-1.2-.1-.6c0-.2-.1-.4-.1-.6-.3-1.6-.6-3.1-.8-4.7l-.3-2.4-.3-2.3c-.2-1.6-.4-3.1-.7-4.7l-.1-.6-.1-.6c0-.2-.1-.5-.2-.8s-.2-.7-.3-1.1c-.1-.4-.2-.7-.3-1.1-.2-.7-.5-1.5-.7-2.2-.2-.7-.5-1.5-.8-2.2l-.8-2.2-.8-2.2c0-.1 0-.1-.1-.2-.3-.7-.5-1.3-.8-2l-.4-1.1-.5-1.1c-.1-.3-.2-.6-.3-1-.2-1.7.7-3.4 2.3-4 1.9-.8 4.2.1 5 2.1.1.1.1.3.2.4l.1.4.3 1.1v.1l.3 1 .6 2.3.6 2.3.3 1.4.2.9c.2.8.3 1.5.5 2.3.2.8.3 1.6.5 2.3.1.4.2.8.2 1.2.1.4.2.8.2 1.2 0 .2.1.4.1.7v1.9c.1 1.5.2 3.1.3 4.6l.4 4.6c.1.8.1 1.5.2 2.3l.1 2.3.1 1.1.1 1.1v.6c0 .2 0 .4.1.5v.7c.3.7.3.7.2.8z"
            />
            <path
              d="M1442 1029.9c-.1.1-.1.3-.1.6l-.1 1.2-.1 1.2-.2 2.3c0 .5 0 .9-.1 1.4-.1 1.1-.1 2.2-.2 3.2-.1.8-.1 1.5-.1 2.3 0 .8-.1 1.5-.2 2.3-.1.8-.1 1.6-.2 2.4v1.4c0 .3-.1.5-.1.7l-.1.3-.1.3-.5 2.3-.2 1.1-.1.6-.6 2.8c-.2.7-.3 1.5-.5 2.2-.2.8-.3 1.5-.5 2.2-.2.7-.3 1.5-.5 2.2-.1.4-.2.7-.3 1.1-.1.4-.2.7-.3 1.1l-.3 1.1-.1.3-.1.3c0 .1 0 .2-.1.3v.1h-1.3c-.4 0-.8 0-1.1-.1h-1s-.1 0-.1-.1v-2.2c0-.4.1-.8.1-1.2s.1-.8.1-1.2c.2-1.5.4-3.1.6-4.6.1-.8.2-1.5.4-2.3l.4-2.3.2-1.2.2-1.1c.1-.8.2-1.5.3-2.2v-2c0-.7-.1-1.5-.1-2.2 0-.8-.1-1.5-.1-2.3l-.1-1.1v-1.2c-.1-1.5-.2-3-.4-4.5l-.2-1.7v-.1l-.1-.4-.2-2.2v-.2c-.1-.7 0-1.2.3-1.8v-.1c.5-1.4 1.8-2.4 3.4-2.6 1.9-.2 3.6.9 4.2 2.6.1.3.2.7.2 1z"
              style={{
                fill: "#2b2b2b",
              }}
            />
            <path
              className="st119"
              d="m1441.9 1030.5-.1 1.2-.1 1.2-.2 2.3c0 .5 0 .9-.1 1.4-1.5-1-3.8-2.8-4.7-3-.8-.2-1.7-.4-2.5 0l-.1-.4-.2-2.2v-.2c-.1-.7 0-1.2.3-1.8h7.3c.1.3.2.7.2 1 .2 0 .2.2.2.5z"
            />
            <path
              className="st119"
              d="M1449.9 1036.6c-.8-1.1-2.5-3.1-4.3-3.8-1.1-.4-2.7-.2-3.3 1.6l-.1.1c-.3-.7-.5-1.3-.8-2l-.4-1.1-.5-1.1c-.1-.3-.2-.6-.3-1l7.5-1.5.4 1.5v.1l.3 1 .6 2.3.6 2.3.3 1.6z"
            />
            <path
              className="st127"
              d="M1436.7 1004.6c-.2 0-.4-.1-.6-.3-.2-.3-.1-.7.2-.9.5-.3 3.9-.6 5.1-.1.3.1.5.5.4.8s-.5.5-.8.4c-.9-.3-3.7-.1-4.1.1h-.2z"
            />
            <path
              className="st116"
              d="M1441.3 996.5c.3 2.5-1 4.7-2.7 4.9s-3.7-1.6-4-4.1c-.2-1.2 0-2.2.5-2.9s2.6-1.5 3.4-1.6c1.2-.2 1.5.6 2.2 1.8.3.6.5 1.2.6 1.9z"
            />
            <path
              className="st34"
              d="M1456.2 1002.9c-1.7 2-3.3 3.8-4.6 5.2-.4.5-.9 1-1.3 1.4-.3.3-.5.6-.8.9-.8.9-1.5 1.7-2 2.3-.4 1.2-.8 2.3-.9 2.9-.3 2.1 2.1 11.4 2.1 11.4-.6.5-1.1 1-1.7 1.4-4.1 3-8.2 2.9-13.8 1.4l.5-11-.5-1.8-.4-1.3-1.3 2.8-3.6.1h-.9s-.2-1.3-.2-2.4c0-1.1 2.9-10.9 6.6-11.1 3.7-1.4 7.9-1.5 11.5-.6 3.2-2.1 8.2-4.6 8.2-4.6s.8.4 1.6 1c.7.7 1.6 1.4 1.5 2z"
            />
            <path
              className="st128"
              d="M1448.7 1027c-.6.5-1.1 1-1.7 1.4-1.2-1.8-3.1-4.9-3.1-6.1 0-1.7.3-7.3.5-8.4.2-1.1 2.5-2 4.9-3.4.1 0 .1-.1.2-.1-.8.9-1.5 1.7-2 2.3-.4 1.2-.8 2.3-.9 2.9-.3 2.1 2.1 11.4 2.1 11.4z"
            />
            <path
              d="M1451.7 1008.1c1.7-2.3 3.2-5.5 2.9-7.2.8.6 1.7 1.3 1.6 1.9-1.7 2.1-3.3 3.8-4.5 5.3z"
              style={{
                opacity: 0.18,
                fill: "#67a4c3",
                enableBackground: "new",
              }}
            />
            <path
              className="st128"
              d="m1433.2 1017.1-.4-1.3-1.3 2.8-3.6.1c2.2-.8 4.6-4.8 4.6-4.8l.7 3.2z"
            />
            <path
              className="st120"
              d="M1433.4 1023.4c-.8-1.1-2-2.7-2.5-3.1-.7-.4-2.2-.9-2.8-.1l-.3-.6c-.1-.1-.1-.2-.2-.4-.1-.1-.1-.3-.2-.5v-.3l.3-.3h3.4c.1.3.2.6.4.9.4.8.7 1.6 1.1 2.4.1.3.2.6.4.9.1.4.2.8.4 1.1z"
            />
            <path
              className="st127"
              d="M1429.6 1019.2c-1.1 0-2.4 0-3-.2-.3-.1-.5-.4-.5-.8.1-.3.4-.5.8-.5.6.2 3.1.1 4.5.1.4 0 .7.3.7.6 0 .4-.3.7-.6.7-.2.1-1 .1-1.9.1z"
            />
            <path
              className="st120"
              d="M1458.7 996.3c-.1.4-.2.7-.3 1.1-.1.4-.3.9-.4 1.3-.1.4-.3.9-.5 1.3s-.3.9-.6 1.3c-.1.1-.1.2-.2.3s-.1.2-.2.4c0 0 0 .1-.1.1 0 0 0 .1-.1.1l-.1.1-.1.1c-.1.1-.2.2-.2.3l-.1.1-.8-1.5c2-1.2 3.1-3.3 3.7-5z"
            />
            <path
              className="st127"
              d="M1456.2 1003.5c-.3 0-.5-.2-.6-.4-.5-1.3-2.2-2.3-2.8-2.5-.3-.1-.5-.5-.3-.8.1-.3.5-.5.8-.3.1 0 2.7 1.2 3.5 3.2.1.3 0 .7-.4.8h-.2z"
            />
            <path
              className="st34"
              d="M1432.8 1069c.6-.8 1.7.6 2.1.8.4.1.1-1.4.5-1.4.3-.1.5 1.2.9 1.4s1.2.6 1.1 1.3c-.1.5-.6.9-1.1.9h-2.7c-.5 0-.9-.3-1-.8-.1-.2-.1-.4-.1-.6-.2-.7.3-1.6.3-1.6zm18.2-.1c.6-1.1 2 .5 2.4.5.8-.1.3-1 .6-1.1.3-.1 1.2.9 1.6 1.1s2.6.8 2.5 1.5c-.1.5-.6.9-1.1.9h-4.7c-.5 0-.9-.3-1-.7-.1-.2-.1-.4-.2-.6 0-.6-.1-1.6-.1-1.6z"
            />
            <path
              className="st113"
              d="M1457.5 991.6c-.1-.9.1-2.8.8-3 .6-.2 2.7.1 3.1 1.2.4 1.1-.3 1.8-.6 1.8-.2 0-.6-.2-.6-.2l-1.1 1.6-1.6-1.4z"
            />
            <path
              className="st113"
              d="M1458.2 989.1v-.5c.1-.1.1-.3.2-.4l.6-.6c.1-.1.2-.2.3-.2.1-.1.2-.1.3-.2.1-.1.2-.1.3-.2.1-.1.2-.1.4-.2s.4 0 .4.2c0 .1 0 .2-.1.3v.1c-.1.1-.2.2-.2.3l-.2.2-.1.1-.1.1-.1.1-.1.1c-.1.2-.3.3-.4.5l-.2.2s-.1 0-.1.1h-.2l-.3.1c-.2.2-.3.1-.4-.1 0 .1 0 0 0 0zm-17.2 9.3c.2.6.2 1.1 0 1.1-.2.1-.5-.3-.7-.9s-.2-1.1 0-1.1c.6-.1.5.4.7.9z"
            />
            <path
              className="st113"
              d="M1440.6 997.6c.3.1.4.2.6.1s.1-1.1.1-1.1l.3 1.8s-.2.5-.3.6-.6 0-.6 0l-.1-1.4z"
            />
            <path className="st120" d="M1459.5 993s-.1.5-.2 1.2l.2-1.2z" />
            <path className="st113" d="M871.6 991.4h1.1v.9h-1.1z" />
            <path
              className="st130"
              d="M872.8 992.3h-1.3v1.2h3s.2-.4-.5-.7c-.5-.2-1.2-.5-1.2-.5z"
            />
            <path className="st113" d="M876.2 991.4h1.1v.9h-1.1z" />
            <path
              className="st130"
              d="M877.3 992.3H876v1.2h3s.2-.4-.5-.7c-.4-.2-1.2-.5-1.2-.5z"
            />
            <path
              className="st34"
              d="M870.1 973.7h7.2s.4 6.3.4 10.3c0 2.1-.2 7.8-.2 7.8h-1.2s-2.3-12.5-2.2-14.6l-.3.2c.1 1.7-.1 5-.3 8.1-.2 3.3-.5 6.3-.5 6.3h-1.2s-.8-5.9-1-7.9c-.8-3.8-.7-10.2-.7-10.2z"
            />
            <path
              className="st33"
              d="m877.2 975.4-7.2-.1v-12.1c0-.8.3-1.3.7-1.7l.1-.1c.6-.5 1.3-.7 1.8-.7h.1c.5-.1 1.5 0 1.5 0 2.8.3 2.5 2.1 2.6 3.5.2 2.7.4 10.4.4 11.2z"
            />
            <path
              className="st130"
              d="M875.7 963.5s3.4 1.6 4.1 1.9c.6.3 1.2.1 1.4-.3.2-.3.2-1-.6-1.4s-5.1-2.8-5.1-2.8l.2 2.6z"
            />
            <path
              className="st130"
              d="M876 959.3s3.1 4.9 3.5 5.6c.3.6.9.7 1.4.5.3-.2.8-.7.3-1.5-.4-.8-4.4-5.3-4.4-5.3l-.8.7zm-.2 1.6c-.4-.2-1.5-.3-1.5-.3l2.9 15.3s1.1.1.9-1.7c-.5-4.3-.5-5.4-1.3-11.7 0-.5-.1-1.1-1-1.6zm-3.1-.4v12.4c0 1.1-.9 2-2 2h-.6v-11.7c0-.8.2-1.4.6-1.8l.1-.1c.6-.5 1.3-.7 1.8-.7 0 0 .1 0 .1-.1zm-2.6 7.4v-5.1s-1.1 6.4-1.9 9.8c-.2 1.1.8 2.5 1.9 2.5v-7.2z"
            />
            <path
              className="st130"
              d="M871.3 975.3s-2.7-5.4-3.1-6.1c-.7-1.4-1.9-1.5-2.4-1.4 0 0-.6.5-.1 1.7.3.8 4.8 6.6 4.8 6.6l.8-.8z"
            />
            <path
              className="st130"
              d="M868.1 969.2s3.4-5.5 3.9-6.2c.3-.4.3-1.2-.1-1.5-.3-.3-.7-.6-1.3 0-.6.7-5 6.4-5 6.4l2.5 1.3z"
            />
            <path
              className="st113"
              d="M876.7 958.8s.3-.4-.1-.9c-.2-.3-.8-1-1.3-1.2l.3 2.4h.3l.1.2.7-.5z"
            />
            <path
              className="st116"
              d="m873.891 956.82 1.021-.805 1.734 2.198-1.02.805z"
            />
            <path
              className="st113"
              d="M872.2 955c1.1-1.8 4.1-1 3.9 1.5v1.2c0 .1 0 .2.1.4s-.1.2-.2.2-.2-.1-.2-.1v.1c-.1.2-.1.4-.2.5-.3.6-.8.6-1.2.6v1.2h-1.6s.4-.9.4-1.4c0-.2-.4-.5-.5-.6-.3-.3-.5-.6-.7-1.1-.4-1.1-.3-1.8.2-2.5z"
            />
            <path
              className="st116"
              d="M871 955.3c0-.3.2-.5.8-.8s.4-.6.9-.9c.4-.2.8-.2 1.1-.1.2.1.3.1.8 0 .4-.1.8.2.9.6.1.3.1.5.6.7.6.2.3 1.4-.3 1.4-.4 0-.5-.6-1-.4-.5.2-.4.9-1 1-.1 0-.3-.1-.4-.4-.1-.3-.6-.1-.6.3 0 .2 0 .8.5.7.3-.1.6.1.1.5-.2.1-.1.6-.3.8 0 0-.1 0-.1.1-.6.3-1.3-.5-1.4-.7-.1-.2-.4-.3-.6-.7-.1-.3 0-.6.1-1s-.1-.6-.1-1.1z"
            />
            <path
              className="st113"
              d="M871.2 975.4s.4.2.5.4l-.8.6s-.3-.1-.4-.4l.7-.6z"
            />
            <path
              transform="rotate(-42.698 870.671 976.375)"
              style={{
                fill: "#3a7dce",
              }}
              d="M869.5 976h2.2v.6h-2.2z"
            />
            <path
              className="st35"
              d="M1758.4 961.4c-1.4-1.4-4.6-5.5-5.3-6.3-.8-.9-.4-1.8 0-2.2.3-.4 1.5-.8 2.3 0s4 4.9 5.1 6.8c.3.5.9 1.4-.1 2.1-.7.5-1.6 0-2-.4z"
            />
            <path
              className="st35"
              d="M1761.5 967.2s-2.5-4.8-3-5.8c-.4-.7-.2-1.4.3-1.7.4-.3 1.2-.4 1.8.6.6.9 2 6.5 2 6.5l-1.1.4z"
            />
            <path
              className="st113"
              d="M1762.7 966.8s1.3.8 1.2 3.2c0 .7-.7.8-.8-.3-.1-1-1.1-2-.9-1.4.1.4.2.9 0 .7-.5-.4-.5-1.9-.5-1.9l1-.3z"
            />
            <path
              className="st132"
              d="m1759.8 964.2-6.9-7.6c-.8-1-1.1-2-.8-2.8.4-1.4 2.1-1.7 2.1-1.7h.1l2.9 3.3-.3.3-2.8-3.2c-.4.2-1.5.4-1.8 1.4-.2.7 0 1.6.8 2.5l6.9 7.6-.2.2z"
            />
            <g />
            <path className="st113" d="m1748.2 990.8-1.4-.1.1-4.1 2.2.1z" />
            <path
              className="st133"
              d="m1746.7 990.6 1.6.2-.1.8-.1.7-3.7-.5s-.2-.5.7-.8c.6-.2 1.6-.4 1.6-.4z"
            />
            <path
              d="m1751 969.2 7-.7s-2.4 7.1-7 10.3c0 0-.1 2.6-.5 5-.2 1.2-2 6.4-2 6.4l-1.7-.3s.2-3.8.2-5.8c0-1.1-.1-4.8.5-6.2 1.1-2.6 3.5-8.7 3.5-8.7z"
              style={{
                fill: "#f2af08",
              }}
            />
            <path className="st113" d="m1762.4 989.7-1.2.7-.5-1.3 1.1-.7z" />
            <path
              className="st133"
              d="m1761.1 990.4 1.4-.8.4.7.3.6-3.3 1.8s-.5-.3.1-1c.5-.5 1.1-1.3 1.1-1.3z"
            />
            <path
              className="st130"
              d="M1755 982.6c-1.4-2.7-2.6-13.5-2.6-13.5l6.7-.6s-1.8 7-.4 10.9c1.6 4.3 3.7 9.7 3.7 9.7l-1.6.8s-4.5-5-5.8-7.3z"
            />
            <path
              className="st113"
              d="M1754.3 945.1c-1.4-2.3-5.2-1.3-5 1.9v1.4c0 .2-.1.3-.1.5-.1.3.2.3.2.3.2 0 .3-.1.3-.1v.1c.1.3.2.5.3.7.3.5.7.7 1.2.7.6 0 .4.9.4.9l-.4 1.3 2.5-.7s-.5-1.2-.5-1.7c0-.3.5-.6.7-.8.3-.3.7-.8.9-1.4.2-1.3.1-2.2-.5-3.1z"
            />
            <path
              className="st35"
              d="m1753.5 951.7-2.2 1.1s-.8 3-.7 11c0 1.9.4 5.7.4 5.7l8.3-1s-1.8-7.5-3.7-14.5c-.8-2.3-2.1-2.3-2.1-2.3z"
            />
            <path
              className="st116"
              d="M1749.5 944.9s1.1-2.1 3-1.4c0 0 1.3.2 1.4 1.1 0 0 1.1.5 1.3 1.9.1 1.4-.5 3.8-2 3.8 0 0-.2 0 0-.4 0 0 .1-1.3.4-1.4.4-.3.8-1.1.3-1.2-.5.1-.6.8-.6.8l-.2-.1c.1-.9-.4-1.6-.7-1.9-.2.2-.5.5-.9.5 0 0-.8 0-.9.2s-1.3.8-1.6.3c-.4-.6-.5-1.5.5-2.2z"
            />
            <path
              className="st130"
              d="M1754.2 949.9s0-2.1-1.1-3.6c-.7-.9-2.4-1-4.3-.4 0 0 .1-1 .7-1.2 0 0 .6-1.3 2.4-1.6 1.4-.2 1.7-.4 1.9-.4.6-.1 2.1 1.2 2 2.4 0 .3-.1.6-.3 1.3-.2.7-.1 2.6-1.3 3.5z"
            />
            <path
              className="st132"
              d="M1756.3 954.3s10.6 9.1 3 11.2c-1.3.4-1 .2-2.2-5.1-1.4-6-.8-6.1-.8-6.1z"
            />
            <path
              className="st132"
              d="m1759 964.5-7.4-8.8c-1.4-2.2-.1-3.1-.1-3.1 1.2-.8 1.9-.3 2.3 0 .8.5 3.3 2.7 3.4 2.7l-.2.3s-2.6-2.2-3.4-2.7c-.4-.3-.9-.6-1.9 0-.1.1-1 .7.2 2.6l7.3 8.7-.2.3z"
            />
            <path
              className="st135"
              d="M1749.7 962.1c.2-2 1.4-7 1.5-8.1.2-1.2 1.1-1.5 1.7-1.4.5 0 1.5.6 1.5 1.7-.1 1.1-1.2 6.3-2 8.3-.2.6-.5 1.6-1.7 1.3-.9-.2-1.1-1.2-1-1.8z"
            />
            <path
              className="st135"
              d="M1746.6 968.1s2.6-4.7 3.1-5.7c.4-.7 1.1-.9 1.6-.7s1 .8.5 1.8-4.3 5.3-4.3 5.3l-.9-.7z"
            />
            <path
              className="st113"
              d="M1746.7 968.2s-1.4.1-2.3 2.3c-.2.6.2 1 .9.1.5-.8 1.8-1.3 1.4-.8-.3.3-.6.7-.3.7.6-.1 1.2-1.6 1.2-1.6l-.9-.7zm-129.6 95.6c0 .1-.1.3-.1.4l-.1.4c-.1.3-.1.5-.2.8-.1.5-.3 1.1-.5 1.6s-.3 1.1-.5 1.6-.4 1.1-.8 1.7c-.2.4-.8.5-1.2.3-.3-.2-.5-.6-.4-1v-.1l.1-.3.1-.4.1-.4c0-.1 0-.3.1-.4.1-.5.1-1 .2-1.6 0-.5.1-1.1.1-1.6v-1.6c0-.9.7-1.6 1.6-1.6s1.6.7 1.6 1.6c0 .4 0 .5-.1.6zm11.8-.4-.1 1.6-.1 1.6c0 1.1-.1 2.2-.2 3.3 0 .5-.5.9-1 .9s-.9-.4-.9-.9c-.1-1.1-.3-2.1-.4-3.2l-.2-1.6-.2-1.6c-.1-.9.5-1.6 1.3-1.8.9-.1 1.6.5 1.8 1.3v.4z"
            />
            <path
              className="st121"
              d="M1632 1032.5v.4c-.2 2.8-.5 5.5-.8 8.3v.2l-.4 4.3-.2 2.2v1.9c0 .4 0 .8-.1 1.2l-.1 1.1c0 .4-.1.7-.1 1.1l-.1 1.1-.4 4.4v1.1l-.1 1.1-.2 2.2-.1 1.1-.1 1.1-.1 1.1v.8s-.1.1-.2.1-.3.1-.7.1c-.4.1-.9.1-1.3 0-.4 0-.5-.1-.7-.1-.1 0-.2-.1-.2-.1v-.3l-.1-.6-.1-1.1-.1-1.1-.1-1v-.1l-.2-2.2-.1-1.1c0-.4-.1-.7-.1-1.1l-.3-4.4-.1-1.1-.1-1.1-.1-1.1c0-.4 0-.7-.1-1v-13.5l.1-2.2c0-.7.1-1.5.1-2.2 0-.7.3-1.4.7-2 .7-.9 1.9-1.5 3.1-1.5 2 .3 3.5 2 3.4 4z"
            />
            <path
              className="st122"
              d="M1629.7 1059.3v.5l-.1 1.1-.2 2.2-.1 1.1-.1 1.1-.1 1.1v.8s-.1.1-.2.1-.3.1-.7.1c-.4.1-.9.1-1.3 0-.4 0-.5-.1-.7-.1-.1 0-.2-.1-.2-.1v-.3l-.1-.6-.1-1.1-.1-1.1-.1-1c.4 1.3 2.5 1.9 3.3-.1 0-.3.4-2.1.8-3.7zm2.3-26.4c-.2 2.8-.5 5.5-.8 8.3-.2-1.9-.7-5.3-2.2-7.1l2.2-2.6.8 1.4z"
            />
            <path
              className="st121"
              d="M1626.3 1032.9v-.6c0-.8-.3-1.5-.8-2.1s-1.2-1.1-2-1.3c-2-.5-4 .7-4.4 2.7l-.6 2.4c-.2.7-.3 1.3-.5 2-.3 1.5-.7 2.9-1 4.4s-.7 2.9-1 4.4c-.1.7-.3 1.5-.4 2.3-.1.4-.1.8-.2 1.2 0 .2-.1.4-.1.7v.6c0 .4 0 .7-.1 1.1 0 .4 0 .7-.1 1.1-.1.7-.1 1.5-.2 2.2-.1.7-.1 1.5-.2 2.2l-.1 1.1c0 .4-.1.7-.1 1.1l-.1 1.1-.1.6v.5c-.1.7-.1 1.5-.2 2.2v1.1c0 .4-.1.7-.1 1.1v1.7c0 .1.1.1.2.2s.2.1.4.2c.1 0 .2.1.3.1l.2.1h.1s.1 0 .1.1h1.4c.1 0 .2-.1.2-.1v-.2c.1-.2.1-.4.2-.5l.2-.5c.1-.2.1-.4.2-.5.1-.4.2-.7.3-1.1.1-.4.2-.7.3-1.1.1-.4.2-.7.3-1.1.1-.4.2-.7.2-1.1.2-.7.3-1.5.4-2.2v-.2c.1-.7.2-1.3.3-2l.4-2.2.2-1.1.2-1.1.4-2.3v-.5c0-.1.1-.2.1-.3l.1-.2.1-.2.2-.5c.1-.3.3-.7.4-1l.2-.5.2-.5.4-1 .4-1 .5-1c.1-.3.3-.7.4-1 .3-.6.5-1.2.8-1.8.3-.8.6-1.5.9-2.3.1-.2.1-.3.2-.5s.1-.4.2-.5c.1-.4.2-.7.3-1.1.1-.4.1-.7.2-1.1 0-.2 0-.4.1-.6v-.6l.1-1z"
            />
            <path
              className="st122"
              d="M1619.2 1058.6v.2c-.1.7-.3 1.5-.4 2.2-.1.4-.2.7-.2 1.1-.1.4-.2.7-.3 1.1-.1.4-.2.7-.3 1.1-.1.4-.2.7-.3 1.1-.1.2-.1.4-.2.5l-.2.5c-.1.2-.1.4-.2.5v.2s-.1.1-.2.1h-1.4l-.1-.1h-.1l-.2-.1c-.1 0-.3-.1-.3-.1-.2-.1-.3-.2-.4-.2-.1-.1-.2-.1-.2-.2v-1.7c0-.4 0-.7.1-1.1v-.4c.8 1.1 3.6-1.2 4.9-4.7z"
            />
            <path
              className="st130"
              d="M1616.2 1068.3c.5 1.1 0 3.7 0 3.7h-5.8s-.2-.8 0-1c.2-.2 1.9-.7 2.6-2.4h.6s.7-.6 1.6-.6c.9-.1 1 .3 1 .3zm12.8 0c.5 1.1 0 3.7 0 3.7h-5.8s-.2-.8 0-1c.2-.2 1.9-.7 2.6-2.4h.6s.7-.6 1.6-.6c.9-.1 1 .3 1 .3z"
            />
            <path
              className="st113"
              d="M1630.6 1003.7c-.8 1.3-.7 2.3-.7 2.8s.4.8.4.8l-3.2-.4s-1.4.3-1.2-.2c.4-.9.2-2.4.2-2.4l4.5-.6zm4.4 7.6.1.2.1.2.1.3.2.6c.1.4.3.8.4 1.2.2.8.5 1.6.7 2.5.2.8.4 1.7.5 2.6.1.4.1.9.1 1.4v1.5c-.1.3-.1.5-.2.8-.1.2-.2.5-.2.7l-.6 1.2c-.4.8-.8 1.5-1.2 2.2-.4.7-.9 1.4-1.3 2.1-.2.3-.5.7-.7 1s-.5.7-.7 1c-.3.5-1 .6-1.5.3s-.6-.9-.3-1.4c.2-.3.4-.7.6-1 .2-.4.4-.7.6-1.1.4-.7.7-1.4 1.1-2.1.3-.7.7-1.4.9-2.2.1-.4.3-.7.4-1.1 0-.2.1-.3.1-.5s.1-.3.1-.4v-.3c0-.1 0-.3-.1-.5-.1-.3-.1-.7-.2-1-.2-.7-.5-1.4-.7-2.1l-.9-2.1c-.2-.4-.3-.7-.5-1.1l-.3-.5-.1-.3-.1-.1s0-.1-.1-.1c-.6-1.1-.2-2.4.8-3 1.1-.6 2.4-.2 3 .8-.2 0-.2.1-.1.3z"
            />
            <path
              className="st113"
              d="M1624.6 1000.7c.1 1.6.3 2.5.9 3.3.5.8 2.3 1.5 3.1 1.2.8-.3 2.1-2 2.1-2.1s-4.2-2.4-4.2-2.4h-1.9zm-4.2 12.1c-.8-.4-1.6-.8-2.3-1.2l-1.2-.6-1.2-.6c-.4-.2-.8-.4-1.2-.7-.2-.1-.4-.3-.6-.4-.2-.2-.4-.3-.7-.5l-.4-.4c-.1-.1-.3-.3-.4-.5v-.2l-.1-.2-.1-.2-.1-.2-.2-.3-.1-.3-.3-.6c-.3-.8-.6-1.7-.8-2.5-.2-.8-.4-1.7-.6-2.5-.1-.4-.2-.8-.3-1.3-.1-.4-.1-.8-.2-1.3-.1-.4-.1-.8-.2-1.3l-.1-.6v-.6c-.1-.5.3-1 .8-1.1s.9.3 1 .7v.1c0 .2.1.4.2.6l.2.6.3 1.2c.1.4.2.8.4 1.2.1.4.3.8.4 1.1.3.8.6 1.5.9 2.2s.6 1.4 1 2.1c.1.2.2.3.3.5l.1.2.2.2.1.1.1.1.1.1v.1-.1h.1c.1 0 .2.1.3.2.1.1.3.1.4.2.3.1.7.2 1 .4.4.1.7.2 1.1.3l1.2.3c.8.2 1.6.4 2.3.7l.6.2c1.3.4 2.1 1.8 1.6 3.2s-1.8 2.1-3.2 1.6c-.1.2-.2.1-.4 0z"
            />
            <path
              className="st120"
              d="M1633.9 1020.4c0 .2.1.4.1.5v.3c0 .1 0 .3-.1.4 0 .2-.1.3-.1.5 0 .1-.1.2-.1.3.7-.2 1.7.5 1.8 1 .1.2-.2 1.5-.5 2.8.3-.6.7-1.2 1-1.8l.6-1.2c.1-.2.2-.4.2-.7.1-.2.1-.5.2-.8v-1.6h-3.1v.3zm-18.2-14.3c-.1-.1-.3-.1-.3-.2h-.1v.1-.1l-.1-.1-.1-.1-.1-.1-.2-.2-.1-.2c-.1-.2-.2-.3-.3-.5-.1-.2-.3-.5-.4-.8 0 .7-.1 1.2-.5 1.2-.9 0-2.2-1.3-3.2-3 .1.5.2.9.4 1.4.2.8.5 1.7.8 2.5l.3.6.1.3.2.3.1.2.1.2.1.2v.2c.1.2.3.4.4.5s.2.3.4.4l.3.3 3.1-2.3s-.1-.1-.2-.3c-.1 0-.2-.1-.3-.1-.1-.2-.3-.3-.4-.4z"
            />
            <path
              className="st113"
              d="M1611.1 995.9c0-.7-.1-2.3-.6-2.5-.5-.1-2.2.1-2.6 1-.3.9.3 1.5.5 1.5s.7.2.7.2l.6 1 1.4-1.2z"
            />
            <path
              className="st113"
              d="M1610.3 993.9c-.1-.1-.1-.1 0 0l-.2-.2c-.1-.1-.1-.1-.1-.2-.1-.1-.2-.3-.3-.4l-.2-.2-.2-.2-.4-.4c-.1-.1-.1-.2 0-.3s.2-.1.2 0c.2.1.4.2.5.3.2.1.3.2.5.4.2.1.3.3.4.5l.3.6c0 .1-.1.2-.1.2h-.1l-.3-.1z"
            />
            <path
              className="st130"
              d="M1638.4 1019.6c-.1-.1-.3-.1-.5-.1 0-1.4-.3-3.9-1.4-6.9-1.1-3.1-2.6-4.3-4.6-4.8-.1 0-.2-.1-.3-.1-2.6-.5-5.4-1.1-8.5-.4-3.4-.3-6.2-1.2-7.5-1.7.2-.1.3-.4.3-.6-.1-.3-.4-.4-.7-.3-1.9.7-3 3.8-3.1 4.9 0 .3.2.5.5.6.2 0 .4-.2.5-.4 1.7 1.7 5 4.4 6 6.2 2.6 5.7-.7 15.8-.7 15.8s1.1-.8 2-.1c3.3 2.4 6 3.6 8 3.8.4 0 1.5-2.3 1.5-2.3.7 1.3.3 2.2.6 2.1 1.4-.5 2.2-1.8 2.1-3.6 0-2.1-1.2-5.5-.7-8.2.1-.8.4-2.3.7-3.8l.7 1.2c-.2 0-.4.2-.5.4-.1.3.1.6.4.6.3.1.7.1 1.1.1.8 0 1.7-.2 2.5-.5.5-.2.9-.4 1.1-.6.2-.2.4-.4.6-.5.2-.3.1-.6-.1-.8z"
            />
            <path
              d="M1631.4 1018.1c-.1 2.6-1.3 5.3-1.2 6.2.2 1.2 2.2 5.5 2.5 8.1v-.7c0-2.1-1.2-5.5-.7-8.2.1-.8.4-2.3.7-3.8l.2-.9 1.2-1.1c.2-.6.5-1.2.6-1.8.2-1.3.5-2.1.9-2.6 1.7 2.6 2 5.4 1.6 6.8.3.5.3 1.2-.7 1.5h.1c.1-.1.3-.1.4-.2.5-.2.9-.4 1.1-.6.2-.2.4-.4.6-.5.2-.2.2-.6-.1-.7-.1-.1-.3-.1-.5-.1 0-1.4-.3-3.9-1.4-6.9-1.1-3.1-2.6-4.3-4.6-4.8-.1 0-.2-.1-.3-.1l-.7 8.2c0 .8.1 1.5.3 2.2z"
              style={{
                opacity: 0.07,
                enableBackground: "new",
              }}
            />
            <path
              className="st113"
              d="M1622.4 1007.2c.5 1.2 4.1 5.7 6 5.9 1.9.1 6.5-3.5 6.5-3.5s-1.1-1.1-2.2-1.6c-2.5-1.1-4.1-1.1-5.1-1.2-1.6-.2-5.2.4-5.2.4z"
            />
            <path
              className="st120"
              d="M1629 1011.9c.2.8.5 1 .5 1l1-.4.8-5-1.2-.3c-.1-.1-.2-.4-.2-.6 0-.5-.1-1.5.7-2.8l-.3.1c.2-.3.4-.5.4-.6 0 0-.1-.1-.2-.1l-3.9.4c.3.9.7 1.8 1.3 2.1s.7 1.3.8 1.6.1 3.8.3 4.6z"
            />
            <path
              className="st116"
              d="M1624.9 999.5c0 2.6 2.6 5.3 3.4 5.3 1.8 0 3.7-1.9 3.7-5.4 0-2.6-2.4-3.5-4.2-3.5-1.9-.1-2.9 1-2.9 3.6z"
            />
            <path
              className="st116"
              d="M1626.3 996.4c-1.7-.4-2.2.7-2.3 2.5 0 1 .4 1.8.4 1.8h1.2l.7-4.3z"
            />
            <path
              className="st113"
              d="M1626.4 1002.1c.1.5 0 1-.3 1s-.7-.7-.8-1.2c-.1-.5.3-.7.5-.7s.5.3.6.9z"
            />
            <path
              className="st116"
              d="M1628.9 999.4c.4-1.5 2.7-2.5 4.3-.2 1.2 1.7 3.8 8 .5 16.1-1.1 2.7-3.5 5.8-3.2-4.2.2-4.7-.2-9.5-.4-10.1-.2-.5-1.3-.8-1.3-.8-.1-.2-.2-.6.1-.8z"
            />
            <path
              className="st113"
              d="M1591.2 1036.2c-.5 1.8-.6 2.6-.3 4.1.3 1.5 1.6 2.5 1.6 2.5s1.1-3.5 1-3.8c-.1-.2-2.3-2.8-2.3-2.8z"
            />
            <path
              className="st113"
              d="M1595.1 1013.4c-.1.5-.3 1-.4 1.6-.2.5-.3 1-.5 1.6-.3 1-.6 2.1-1 3.1-.3 1-.6 2.1-.9 3.1-.1.5-.3 1-.4 1.5-.1.2-.1.5-.2.7v1.1c0 .3 0 .5.1.8 0 .5.1 1.1.2 1.6l.2 1.6.2 1.6.3 3.3c0 .5.1 1.1.1 1.6s.1 1.1.1 1.6c0 .4-.3.8-.7.8-.3 0-.6-.2-.7-.5-.2-.5-.4-1.1-.5-1.6-.2-.5-.3-1.1-.5-1.6-.3-1.1-.6-2.1-.9-3.2-.1-.5-.3-1.1-.4-1.6s-.2-1.1-.4-1.6c-.1-.5-.2-1.1-.3-1.6-.1-.3-.1-.6-.1-.8 0-.3-.1-.6-.1-.9v-1.3c0-.3.1-.6.1-.9.1-.6.2-1.2.4-1.7.1-.6.3-1.1.4-1.6l.2-.8.2-.8c.3-1.1.7-2.1 1.1-3.1l.6-1.5c.2-.5.4-1 .7-1.5.4-.9 1.4-1.2 2.3-.9.6.3 1 1.1.8 1.9zm1.9 50.4c0 .1 0 .3.1.4v.4c0 .3.1.5.1.8.1.5.1 1.1.1 1.6v1.7c0 .6 0 1.1-.1 1.8-.1.5-.5.7-1 .7-.4-.1-.6-.4-.7-.8v-.7l-.1-.4c0-.1 0-.2-.1-.4-.1-.5-.2-1-.4-1.5-.1-.5-.3-1-.4-1.5-.1-.2-.2-.5-.2-.7l-.1-.4c0-.1-.1-.2-.1-.4-.3-.8.1-1.7.9-2 .8-.3 1.7.1 2 .9-.1.2-.1.3 0 .5zm5.9.4-.3 1.6-.3 1.6c-.2 1.1-.4 2.1-.6 3.2-.1.5-.6.9-1.1.8s-.8-.5-.8-.9v-6.4c0-.8.7-1.5 1.5-1.6.8 0 1.5.7 1.6 1.5v.2zm-1.4-31.7.9-1.2.9-1.2 1.8-2.4c.6-.8 1.1-1.6 1.6-2.4.2-.4.5-.8.6-1.2.1-.2.2-.4.2-.5v-.3c0-.1 0-.2-.1-.3-.1-.2-.1-.4-.2-.6-.1-.4-.3-.9-.5-1.3-.3-.9-.7-1.8-1.1-2.7l-.6-1.4c-.2-.5-.4-.9-.6-1.4l-.6-1.4-.3-.7-.3-.7c-.4-.9 0-1.9.9-2.2.8-.4 1.8 0 2.2.7.1.2.2.5.4.7l.4.7c.2.5.5.9.7 1.4s.4.9.6 1.4.4.9.6 1.4.4 1 .6 1.4l.6 1.5c.2.5.3 1 .5 1.6.1.3.1.6.2.9 0 .2.1.3.1.5v1.1c0 .1 0 .2-.1.3 0 .2-.1.4-.2.6-.1.3-.3.6-.4.9l-.9 1.5c-.3.5-.6.9-.9 1.3s-.7.8-1 1.2c-.7.8-1.4 1.6-2.1 2.3l-1.1 1.1-.6.5c-.2.2-.4.4-.6.5-.5.4-1.2.4-1.6-.1-.3-.4-.3-1 0-1.5z"
            />
            <path
              className="st120"
              d="m1592.2 1031.7-.2-1.6-.2-1.6c-.1-.5-.1-1.1-.2-1.6 0-.3 0-.5-.1-.8v-1.1c0-.2.1-.4.2-.7 0-.1.1-.3.1-.4l-3.6-1c-.1.2-.1.5-.1.7-.1.3-.1.6-.1.9v1.5c1.3 0 3.3 1.4 3.6 4.1.4 3.4.6 6.1.7 5.8 0-.1.1-.6.1-1.4 0-1.1-.1-1.9-.2-2.8zm11.1 1.6 1.8-1.1.3-.3c.7-.8 1.4-1.5 2.1-2.3.3-.4.7-.8 1-1.2.3-.4.6-.9.9-1.3.1-.2.3-.4.4-.7l-.5-.7s-1.2-.7-1.2.5c0 1.1-1.2 2.1-2.6 2.4 0 0-.7.3-1.5.7-.2.3-.5.6-.7.9l-.9 1.2-.5.7c.6.6 1.4 1.2 1.4 1.2z"
            />
            <path
              className="st34"
              d="M1600.8 1030.9v.2c-.1.3-.1.5-.2.8l-.1.3-.1.3-.2.5-.4 1c-.1.3-.2.7-.4 1l-.3 1c-.2.5-.3.9-.4 1.4-.1.2-.1.5-.2.7-.1.4-.2.7-.3 1.1l-.3 1.1-.3 1.1c-.1.4-.2.7-.3 1.1-.2.7-.3 1.4-.5 2.1-.2.7-.3 1.4-.4 2.1 0 .2-.1.3-.1.5s-.1.3-.1.5c-.1.3-.1.7-.1 1v2c0 .7.1 1.5.1 2.2.1.7.1 1.5.2 2.2l.3 2.2c0 .3.1.5.1.8.1 1.2.3 2.4.4 3.6 0 .4.1.7.1 1.1s.1.7.1 1.1v1.9c0 .1-.1.1-.1.2-.1.1-.2.1-.3.2h-.2l-.1.1-.1.1-.2.1c-.5.2-1 .2-1.5.2h-.6c-.1 0-.2-.1-.3-.1-.1 0-.1-.1-.2-.1 0 0 0-.1-.1-.1l-.1-.5c-.1-.4-.2-.7-.2-1.1-.2-.7-.3-1.4-.5-2.2v-.1c-.3-1.4-.5-2.8-.8-4.2-.2-1.5-.5-2.9-.7-4.4l-.3-2.2c-.1-.4-.1-.7-.2-1.1v-4.5c0-.8.1-1.5.1-2.3.1-1.5.2-3 .4-4.5.1-1.5.3-3 .5-4.4l.3-2.2.1-1.1.1-1.1.1-.6c.3-2.3 2.3-3.9 4.6-3.6 2.3.3 3.9 2.4 3.7 4.6z"
            />
            <path
              className="st34"
              d="M1605.8 1034.4v.2c-.1 1.4-.2 2.7-.3 4.1-.1 1.3-.2 2.6-.3 3.8l-.3 3.9c-.1.7-.1 1.3-.2 2l-.2 2c-.2 2.3-.5 4.7-.7 7 0 .3-.1.6-.1.8l-.4 3.9-.2 2-.1 1-.1.5v.3s-.1.1-.2.1-.2.1-.4.1c-.8.1-1.6.1-2.3-.1-.2-.1-.3-.1-.4-.1s-.1-.1-.2-.1v-1.8l-.1-2-.1-1.2-.1-2.8c-.1-2.6-.2-5.3-.2-7.9v-2c0-.7 0-1.3-.1-2l-.1-4c0-1.6 0-3.2-.1-4.8v-3.1c0-1.4.9-2.7 2.1-3.2.5-.2 1-.3 1.5-.3 1.2 0 2.2.6 2.9 1.5.4.7.7 1.4.7 2.2z"
            />
            <path
              className="st128"
              d="M1597.4 1065.4c0 .2-.1.2-.1.3-.1.1-.2.1-.3.2h-.2l-.1.1-.1.1-.2.1c-.5.2-1 .2-1.5.2h-.6c-.1 0-.2-.1-.3-.1-.1 0-.1-.1-.2-.1 0 0 0-.1-.1-.1l-.1-.5c-.1-.4-.2-.7-.2-1.1-.2-.7-.3-1.4-.5-2.2v-.1c.9.9 3-.4 3.7-4 .1 1.2.3 2.4.4 3.6 0 .4.1.7.1 1.1 0 .4.1.7.1 1.1v1.2l.2.2zm6.4-8c0 .3-.1.6-.1.8l-.4 3.9-.2 2-.1 1-.1.5v.3s-.1.1-.2.1-.2.1-.4.1c-.8.1-1.6.1-2.3-.1-.2-.1-.3-.1-.4-.1s-.1-.1-.2-.1v-1.8l-.1-2-.1-1.2c.5 1.1 1.4 1.1 2.4.8.8-.2 1.7-2.7 2.2-4.2zm2-23v.2c-.1 1.4-.2 2.7-.3 4.1-.4-1.8-1-3.7-1.9-4.7l.4-1.9 1.1.1c.4.7.7 1.4.7 2.2z"
            />
            <path
              className="st10"
              d="M1605.8 1033.1s-2.1 1.1-4 1.6c-.8.2-1.5.4-2 .4-1.7-.1-7.9-.6-7.9-1.8 0-1 .5-2.5.4-3.6 0-.2 0-.4-.1-.6 0 0 8.4-3.3 11.5-2 .6.2 1 .6 1.1 1.2.2.5.3 1 .4 1.4.8 2.6.6 3.4.6 3.4z"
            />
            <path
              className="st10"
              d="M1611.4 1022.9c0 2.5-.8 3.5-1.2 3.5-.2 0-.4-.1-.7-.3-.8-.5-1.8-1.5-2.4-1.3-.5.1.5-1.2.2-1l-.9-2.1-.1-.3v-.2c-.1.9-.2 1.6-.2 2.2v2.6c.1 1.3.2 2.1.4 3.4-.3.1-.7.2-1.1.2h-.3c-.6-.1-1.1-.1-1.7-.2h-.1c-5.2-.5-9.6.1-10.9.3-.2 0-.4.1-.4.1s.3-1.3 0-3.5v-.2c0-.2-.1-.6-.1-1-.3-.1-.7-.2-1.2-.3-1.3-.3-2.8-.4-2.8-.4s.8-5.7 1.6-8.5c.5-1.7 1.3-3.8 2.2-5.1.3-.4.6-.8 1-1 1.9-1.2 4.4-1.8 6.7-1.9 2.5-.1 4.8.4 5.9 1.5.5.3 1.1 1.1 1.8 2.1.7 1.2 1.5 2.7 2 4.4.3.9.7 2 1.2 3.2.6 1.2 1 2.6 1.1 3.8z"
            />
            <path
              className="st128"
              d="M1605.3 1029.6c.7 2.7.5 3.4.5 3.4s-2.1 1.1-4 1.6c.3-.9.8-2.9 1.4-5.3.2-.8.4-1.5.6-2.3 1.1-4.5 2.1-9.6 2.1-11.1.1 1.8.2 3.6.3 5.3v-.1c-.1.9-.2 1.6-.2 2.2v1.5c0 .4-.1.8 0 1.1.1 1.3.2 2.1.4 3.4-.3.3-.7.3-1.1.3zm6.1-6.7c0 2.5-.8 3.5-1.2 3.5-.2 0-.4-.1-.7-.3l-.7-1.1c1.5-.8 1.8-3.6 1.6-6 .5 1.3.9 2.7 1 3.9zm-20.6 1.8c1-.9 2.7-3.4 3.2-5.3-.3 1.9-.9 6-.9 6l-1.1.7c0-.2-.1-.6-.1-1-.3-.2-.7-.3-1.1-.4z"
            />
            <path
              d="M1594.1 1018.4v.3c0 .2-.1.4-.1.6.1-.4.1-.8.1-.9z"
              style={{
                opacity: 0.4,
                fill: "#67a4c3",
                enableBackground: "new",
              }}
            />
            <path
              className="st128"
              d="M1607.2 1011.4c-1.2-.4-3.9-.2-5.1.1-1.3.3-3 .3-4.4-1l1.7-2.7c2.5-.1 4.8.4 5.9 1.5.7.3 1.3 1.1 1.9 2.1z"
            />
            <path
              className="st10"
              d="M1594.4 1069.7c-1.4-.9-.5-1.1-.1-1.1.3 0 .6 1 .6 1l-.5.1z"
            />
            <path
              className="st10"
              d="M1597.3 1069.2c-.3-.1-1.1.2-1.9.5-.2.1-.6-.4-.9-.3-.9.3-2.1 1-2.3 1.2-.2.2-.4.7-.4 1 0 .2.4.4.4.4h5.4s.2-.7.2-1.2c0-1-.1-1.6-.5-1.6zm5.2.7c1.4-.9.5-1.1.1-1.1-.3 0-.6 1-.6 1l.5.1z"
            />
            <path
              className="st10"
              d="M1600 1069.2c.3-.1 1.1.2 1.9.5.2.1.2-.2.5-.1.9.3 1.5.8 1.7 1 .2.2.4.7.4 1 0 .2-.4.4-.4.4h-4.4s-.2-.7-.2-1.2c0-1 .1-1.6.5-1.6z"
            />
            <path
              d="M1610.7 1027.1c-.1 0-.2 0-.4-.1l-3.7-2.1c-.4-.2-.5-.6-.3-1s.6-.5 1-.3l3.7 2.1c.4.2.5.6.3 1-.1.3-.4.4-.6.4zm-17.9-1.2-5.1-.9c-.4-.1-.7-.5-.6-.9s.5-.7.9-.6l5 .9c.4.1.7.5.6.9-.2.4-.5.6-.8.6z"
              style={{
                fill: "#dd352c",
              }}
            />
            <path
              className="st113"
              d="M1594.8 1000.2c-.7 2.4.1 5.2.7 5.8.7.7 1.2-.1 1.2-.1l.3-4.8-2.2-.9z"
            />
            <path
              className="st116"
              d="M1594.7 998.8c1.8-3 5-1.5 5.7-1s1.9 2.8 1.7 4.1c1.8.5 1.2 2.3 1.2 2.3s1.9-.2 1.9 1.3c1 .8 1.5 1.8.3 2.6-.3 1.8-2.5 2.5-3.1 2.2-.3.6-1.7 1.3-1.8.5-1.2 1-3.9.5-4.1-.4s.2-1.9.2-1.9.4-.9 0-1.1c-.4-.1-.6 0-.8-.5s.9-1.9.5-2.6c-.4-.7-1.4-.9-1.4-1.5s-.4-1.4-.8-2.1.5-1.9.5-1.9z"
            />
          </g>
          <g id="review">
            <g className="st11">
              <path
                className="st12"
                d="M1463.1 1079.9h-96.6c-2 0-3.6-1.6-3.6-3.6v-47.7c0-2 1.6-3.6 3.6-3.6h96.6c2 0 3.6 1.6 3.6 3.6v47.8c0 1.9-1.6 3.5-3.6 3.5z"
              />
            </g>
            <path
              className="st139"
              d="M1463.1 1079.1h-96.6c-2 0-3.6-1.6-3.6-3.6v-47.8c0-2 1.6-3.6 3.6-3.6h96.6c2 0 3.6 1.6 3.6 3.6v47.8c0 2-1.6 3.6-3.6 3.6z"
            />
            <circle className="st53" cx={1376.6} cy={1036.8} r={5.2} />
            <path className="st53" d="M1388.9 1034.3h48.9v2.4h-48.9z" />
            <path className="st140" d="M1388.9 1039.3h24.4v2.4h-24.4z" />
            <path className="st53" d="M1371.4 1061.4h85.6v2.4h-85.6z" />
            <path className="st140" d="M1371.4 1067.6h73.3v2.4h-73.3z" />
            <path
              className="st44"
              d="m1375.3 1047.6.8 2.5c.1.3.3.4.6.4h2.6l-2.1 1.5c-.2.2-.3.4-.2.7l.8 2.5-2.1-1.5c-.2-.2-.5-.2-.7 0l-2.1 1.5.8-2.5c.1-.3 0-.5-.2-.7l-2.1-1.5h2.6c.3 0 .5-.2.6-.4l.7-2.5zm11.6 0 .8 2.5c.1.3.3.4.6.4h2.6l-2.1 1.5c-.2.2-.3.4-.2.7l.8 2.5-2.1-1.5c-.2-.2-.5-.2-.7 0l-2.1 1.5.8-2.5c.1-.3 0-.5-.2-.7l-2.1-1.5h2.6c.3 0 .5-.2.6-.4l.7-2.5zm11.6 0 .8 2.5c.1.3.3.4.6.4h2.6l-2.1 1.5c-.2.2-.3.4-.2.7l.8 2.5-2.1-1.5c-.2-.2-.5-.2-.7 0l-2.1 1.5.8-2.5c.1-.3 0-.5-.2-.7l-2.1-1.5h2.6c.3 0 .5-.2.6-.4l.7-2.5zm11.6 0 .8 2.5c.1.3.3.4.6.4h2.6l-2.1 1.5c-.2.2-.3.4-.2.7l.8 2.5-2.1-1.5c-.2-.2-.5-.2-.7 0l-2.1 1.5.8-2.5c.1-.3 0-.5-.2-.7l-2.1-1.5h2.6c.3 0 .5-.2.6-.4l.7-2.5zm11.6 0 .8 2.5c.1.3.3.4.6.4h2.6l-2.1 1.5c-.2.2-.3.4-.2.7l.8 2.5-2.1-1.5c-.2-.2-.5-.2-.7 0l-2.1 1.5.8-2.5c.1-.3 0-.5-.2-.7l-2.1-1.5h2.6c.3 0 .5-.2.6-.4l.7-2.5z"
            />
          </g>
          <g id="form">
            <g className="st11">
              <path
                className="st12"
                d="M314.4 1079.8h-65.9c-1.3 0-2.4-1.1-2.4-2.4v-35.3c0-1.3 1.1-2.4 2.4-2.4h65.9c1.3 0 2.4 1.1 2.4 2.4v35.3c-.1 1.3-1.1 2.4-2.4 2.4z"
              />
            </g>
            <path
              className="st139"
              d="M314.4 1079.1h-65.9c-1.3 0-2.4-1.1-2.4-2.4v-35.3c0-1.3 1.1-2.4 2.4-2.4h65.9c1.3 0 2.4 1.1 2.4 2.4v35.3c-.1 1.3-1.1 2.4-2.4 2.4z"
            />
            <circle className="st10" cx={256.9} cy={1051.1} r={4.3} />
            <path className="st53" d="M264.5 1047.7h34.3v2.3h-34.3z" />
            <path className="st140" d="M264.5 1051.6h15.7v1.6h-15.7z" />
            <path
              style={{
                fill: "#eaecee",
              }}
              d="M264.5 1062.6h43.9v1.6h-43.9z"
            />
            <path className="st140" d="M264.5 1068.5h37.7v1.6h-37.7z" />
            <path
              className="st3"
              d="M256.5 1064.9h.1s.1 0 .1-.1c.6-.7 1.3-1.5 1.6-1.7.1 0 .1-.1.1-.2v-1.1c0-.1-.1-.1-.1-.1h-.1c-.2.2-1.2 1.1-1.6 1.9l-.3-.5c0-.1-.1-.1-.2-.1l-.7.4-.1.1v.1c.2.4 1 1 1.2 1.3zm0 5.9h.1s.1 0 .1-.1c.6-.7 1.3-1.5 1.6-1.7.1 0 .1-.1.1-.2v-1.1c0-.1-.1-.1-.1-.1h-.1c-.2.2-1.2 1.1-1.6 1.9l-.3-.5c0-.1-.1-.1-.2-.1l-.7.4-.1.1v.1c.2.4 1 1 1.2 1.3z"
            />
          </g>
          <g id="trafic_x5F_signal">
            <g className="st11">
              <path
                className="st12"
                d="M1828.5 1079.8h-15.1c-1.3 0-2.3-1-2.3-2.3v-45.4c0-1.3 1-2.3 2.3-2.3h15.1c1.3 0 2.3 1 2.3 2.3v45.4c-.2 1.2-1.1 2.3-2.3 2.3z"
              />
            </g>
            <path
              className="st4"
              d="M1828.5 1079.1h-15.1c-1.3 0-2.3-1-2.3-2.3v-45.4c0-1.3 1-2.3 2.3-2.3h15.1c1.3 0 2.3 1 2.3 2.3v45.4c-.2 1.2-1.1 2.3-2.3 2.3z"
            />
            <path
              className="st10"
              d="M1826.3 1039.6c0 3-2.4 5.4-5.4 5.4s-5.4-2.4-5.4-5.4 2.4-5.4 5.4-5.4 5.4 2.4 5.4 5.4z"
            />
            <path
              className="st34"
              d="M1826.3 1054.4c0 3-2.4 5.4-5.4 5.4s-5.4-2.4-5.4-5.4 2.4-5.4 5.4-5.4 5.4 2.4 5.4 5.4z"
            />
            <path
              className="st35"
              d="M1826.3 1069.2c0 3-2.4 5.4-5.4 5.4s-5.4-2.4-5.4-5.4 2.4-5.4 5.4-5.4 5.4 2.4 5.4 5.4z"
            />
            <path
              className="st36"
              d="M1825.4 1042c-.1 0 .2-.7.3-1.7 0-1.1-.2-2.6-1.3-3.7-1.1-1.2-2.6-1.6-3.7-1.6s-1.7.2-1.7.2.1-.1.4-.2.8-.2 1.3-.2c1.1 0 2.7.3 3.9 1.6 1.2 1.3 1.4 2.9 1.3 4 0 .5-.2 1-.3 1.3-.1.1-.2.3-.2.3zm0 14.6c-.1 0 .2-.7.3-1.7 0-1.1-.2-2.6-1.3-3.7-1.1-1.2-2.6-1.6-3.7-1.6s-1.7.2-1.7.2.1-.1.4-.2c.3-.1.8-.2 1.3-.2 1.1 0 2.7.3 3.9 1.6 1.2 1.3 1.4 2.9 1.3 4 0 .5-.2 1-.3 1.3-.1.1-.2.3-.2.3zm0 14.9c-.1 0 .2-.7.3-1.7 0-1.1-.2-2.6-1.3-3.7-1.1-1.2-2.6-1.6-3.7-1.6s-1.7.2-1.7.2.1-.1.4-.2.8-.2 1.3-.2c1.1 0 2.7.3 3.9 1.6 1.2 1.3 1.4 2.9 1.3 4 0 .5-.2 1-.3 1.3-.1.2-.2.3-.2.3z"
            />
          </g>
          <g id="number_x5F_plate">
            <g className="st11">
              <path
                className="st12"
                d="M843.8 1045.9v28.1c0 3.3-2.7 6-6 6H766c-3.3 0-6-2.7-6-6v-28.1c0-3.3 2.7-6 6-6h71.8c3.4 0 6 2.7 6 6z"
              />
            </g>
            <path
              className="st139"
              d="M843.8 1045.1v28.1c0 3.3-2.7 6-6 6H766c-3.3 0-6-2.7-6-6v-28.1c0-3.3 2.7-6 6-6h71.8c3.4 0 6 2.7 6 6z"
            />
            <path
              className="st3"
              d="M837.4 1077.8h-70.8c-2.7 0-5-2.2-5-5v-27.4c0-2.7 2.2-5 5-5h70.8c2.7 0 5 2.2 5 5v27.4c0 2.8-2.3 5-5 5zm-70.8-36.4c-2.2 0-4 1.8-4 4v27.4c0 2.2 1.8 4 4 4h70.8c2.2 0 4-1.8 4-4v-27.4c0-2.2-1.8-4-4-4h-70.8z"
            />
            <path d="m785 1054.3-.7 1.8h-2.1l3.9-9h2.1l3.9 9h-2.2l-.7-1.8H785zm2.1-5.2-1.4 3.5h2.8l-1.4-3.5zm10.1-2.1c2 0 3.2.9 3.2 2.3 0 1-.6 1.7-1.6 2 1.2.2 1.9 1.1 1.9 2.3 0 1.5-1.3 2.5-3.4 2.5H793v-9l4.2-.1zm-2.1 3.6h2c.8 0 1.2-.4 1.2-1s-.5-1-1.2-1h-2v2zm0 3.8h2c1 0 1.5-.4 1.5-1.1 0-.7-.6-1.1-1.5-1.1h-2v2.2zm17.7-2.9c0 3-1.4 4.6-3.9 4.6-2.6 0-3.9-1.6-3.9-4.6 0-2.9 1.4-4.6 3.9-4.6s3.9 1.7 3.9 4.6zm-5.8 0c0 2.1.6 3 1.9 3 1.3 0 1.8-.9 1.8-3s-.6-3-1.8-3c-1.3 0-1.9.9-1.9 3zm14.8 0c0 3-1.4 4.6-3.9 4.6-2.6 0-3.9-1.6-3.9-4.6 0-2.9 1.4-4.6 3.9-4.6s3.9 1.7 3.9 4.6zm-5.8 0c0 2.1.6 3 1.9 3 1.3 0 1.8-.9 1.8-3s-.6-3-1.8-3c-1.3 0-1.9.9-1.9 3zm-37.2 10.9-1.4 1.7c-.7-.8-1.7-1.3-2.7-1.3-1.8 0-3.2 1.4-3.2 3.2 0 1.8 1.4 3.2 3.2 3.2.9 0 2-.5 2.7-1.2l1.4 1.5c-1.1 1.1-2.7 1.9-4.2 1.9-3.1 0-5.4-2.3-5.4-5.3s2.4-5.2 5.5-5.2c1.5-.2 3.1.5 4.1 1.5zm5.8-1.6c3.2 0 5.5 2.1 5.5 5.2s-2.3 5.2-5.5 5.2h-4.3v-10.4h4.3zm-2.1 8.4h2.1c1.7 0 3-1.3 3-3.2s-1.3-3.2-3.1-3.2h-2v6.4zm21.2-3.3c0 3.4-1.6 5.3-4.5 5.3s-4.5-1.9-4.5-5.3 1.6-5.2 4.5-5.2 4.5 1.9 4.5 5.2zm-6.6 0c0 2.4.7 3.5 2.1 3.5 1.5 0 2.1-1 2.1-3.5 0-2.4-.7-3.5-2.1-3.5-1.4.1-2.1 1.1-2.1 3.5zm17 0c0 3.4-1.6 5.3-4.5 5.3s-4.5-1.9-4.5-5.3 1.6-5.2 4.5-5.2 4.5 1.9 4.5 5.2zm-6.7 0c0 2.4.7 3.5 2.1 3.5 1.5 0 2.1-1 2.1-3.5 0-2.4-.7-3.5-2.1-3.5-1.4.1-2.1 1.1-2.1 3.5zm17.1 0c0 3.4-1.6 5.3-4.5 5.3s-4.5-1.9-4.5-5.3 1.6-5.2 4.5-5.2c2.8 0 4.5 1.9 4.5 5.2zm-6.7 0c0 2.4.7 3.5 2.1 3.5 1.5 0 2.1-1 2.1-3.5 0-2.4-.7-3.5-2.1-3.5-1.4.1-2.1 1.1-2.1 3.5zm17 0c0 3.4-1.6 5.3-4.5 5.3s-4.5-1.9-4.5-5.3 1.6-5.2 4.5-5.2 4.5 1.9 4.5 5.2zm-6.6 0c0 2.4.7 3.5 2.1 3.5 1.5 0 2.1-1 2.1-3.5 0-2.4-.7-3.5-2.1-3.5-1.5.1-2.1 1.1-2.1 3.5z" />
          </g>
          <g id="one_x5F_way">
            <circle className="st10" cx={96.5} cy={1056.6} r={22.5} />
            <circle className="st13" cx={96.6} cy={1056.6} r={19} />
            <path
              style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#1e1e1e",
              }}
              d="m102.4 1067.5-4.6-9.1 2.9.9v-15h3.5v15l2.9-.9z"
            />
            <path
              style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#ea4335",
              }}
              d="m90.6 1044.3-4.7 9.1 2.9-.9v15h3.5v-15l2.9.9z"
            />
          </g>
          <g id="stop">
            <path
              className="st10"
              d="m1108.8 1079.1-13.1-13.2v-18.6l13.1-13.2h18.7l13.2 13.2v18.6l-13.2 13.2z"
            />
            <path
              style={{
                fill: "none",
                stroke: "#fff",
                strokeWidth: 0.93,
                strokeMiterlimit: 10,
              }}
              d="m1109.3 1078-12.5-12.5v-17.8l12.5-12.5h17.7l12.6 12.5v17.8L1127 1078z"
            />
            <path
              className="st13"
              d="m1107.6 1052.6-.9 1.9c-1.1-.6-2.3-1-3.1-1-.8 0-1.3.3-1.3.8 0 1.8 5.3.8 5.3 4.4 0 2-1.7 3-3.9 3-1.6 0-3.3-.6-4.4-1.6l.9-1.8c1 .9 2.5 1.5 3.6 1.5.9 0 1.5-.3 1.5-1 0-1.9-5.3-.8-5.3-4.3 0-1.8 1.6-3 3.9-3 1.2 0 2.6.4 3.7 1.1zm5.9.9v8.1h-2.3v-8.1h-3.1v-1.9h8.4v1.9h-3zm13.8 3.1c0 2.9-2.3 5.1-5.4 5.1s-5.4-2.2-5.4-5.1 2.3-5.1 5.4-5.1 5.4 2.2 5.4 5.1zm-8.4 0c0 1.8 1.4 3.1 3.1 3.1s3-1.4 3-3.1c0-1.8-1.4-3.1-3-3.1-1.7 0-3.1 1.3-3.1 3.1zm14.2-5c2.6 0 4 1.3 4 3.5 0 2.3-1.5 3.7-4 3.7h-2v2.9h-2.3v-10h4.3v-.1zm-2 5.3h1.9c1.3 0 2-.6 2-1.7s-.7-1.7-2-1.7h-1.9v3.4z"
            />
          </g>
          <g id="men_x5F_walking">
            <circle
              cx={973.7}
              cy={1064.1}
              r={15}
              style={{
                fill: "#e8391c",
              }}
            />
            <circle className="st13" cx={973.7} cy={1064.1} r={12.5} />
            <path d="m967.9 1062.8 2.4-.6s1.4-2.2 2-2.9c.7-.7 2.4-1.4 2.8-1.4.4 0 3.7 3.3 3.7 3.3s.1 3.9-.5 3.9h-1.2l.2-2.9-1.2-1.4-.2 4.7 3.3 6s-.5 1.3-1.2 1.3-3.7-6.1-3.7-6.1l-2.5 1.8s-.8 4.5-1.5 4.6-1.7.1-1.7.1l1.4-5.6 3-2.9-.3-2.4-1.7 1.8s-2.2.6-2.8.2c-.6-.7-.3-1.5-.3-1.5zm3.6-6.8c0 .9.8 1.7 1.7 1.7s1.7-.8 1.7-1.7c0-.9-.8-1.7-1.7-1.7-1 0-1.7.8-1.7 1.7z" />
          </g>
          <g id="uturn">
            <circle className="st130" cx={604.4} cy={1059.1} r={20} />
            <circle className="st13" cx={604.4} cy={1059.1} r={16.7} />
            <path
              className="st130"
              d="M611.2 1060v-6.8c-.2-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8v16.4h4.3v-16.4c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8v6.8h-1.2l3.5 4.2 3.5-4.2h-1.5z"
            />
          </g>
          <g id="petrol_x5F_pump_1_">
            <circle className="st34" cx={448.6} cy={1064.1} r={15} />
            <circle className="st13" cx={448.6} cy={1064.1} r={12.5} />
            <path
              className="st34"
              d="M455.2 1059.3c-.3-.1-.5-.1-.6.1-.4.5-.8 1-1.3 1.5-.1.1-.1.3-.1.4v5h-.6v-8.5c0-.4-.1-.8-.3-1-.3-.3-.5-.4-.8-.5h-7.6c-.3.1-.4.1-.6.3-.4.3-.5.8-.5 1.2v11.3c.5-.1 2.6-.1 5-.1s4.5.1 5 .1v-1.7c0-.1 0-.1.1-.1h.9c.4 0 .5-.1.5-.5v-4h.3c.3 0 .5-.3.5-.5v-1.7c0-.1 0-.3.1-.3.1-.1.3-.3.3-.4-.1-.2-.1-.5-.3-.6zm-9.1 4.9c-.3.1-.5.1-.6.1h-.5c-.3 0-.5-.3-.5-.5 0-.3.1-.5.5-.5h1.2c.3 0 .5.3.5.5s-.3.4-.6.4zm4.7-2.5c0 .4-.1.5-.5.5H445c-.4 0-.5-.1-.5-.5v-3.1c0-.4.1-.5.5-.5h5.3c.4 0 .5.3.5.5v3.1zm2.3 7.5h-.4v-.1c-.5.1-2.6.1-5 .1-2.8 0-5.2-.1-5.2-.1h-.1c-.4 0-.5 0-.6.5v1.8c.1.4.3.5.6.5h10.7c.4 0 .5-.1.5-.6v-1.5c0-.5-.1-.6-.5-.6z"
            />
          </g>
          <g id="Parking">
            <circle className="st34" cx={1527.4} cy={1064.1} r={15} />
            <circle className="st13" cx={1527.4} cy={1064.1} r={12.5} />
            <path
              className="st34"
              d="M1528.2 1056.8c3.7 0 5.8 1.8 5.8 5.1 0 3.4-2.1 5.3-5.8 5.3h-2.9v4.2h-3.3v-14.6h6.2zm-2.9 7.7h2.7c1.8 0 2.9-.8 2.9-2.5 0-1.6-1-2.4-2.9-2.4h-2.7v4.9z"
            />
          </g>
        </svg>
      </div>
    </div>
  );
}

export default MainHeader;
